(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"./src/app/index.js":[function(require,module,exports){
/**
  Proyecto Base Ciris Informatic Solutions
  Enero 2015
  Recursos y lecturas
  Guia de estilo: https://github.com/johnpapa/angularjs-styleguide
  Otra guia de estilo: http://toddmotto.com/opinionated-angular-js-styleguide-for-teams/
  Sobre los controladores: http://toddmotto.com/rethinking-angular-js-controllers/
  Estilos Bootstrap: http://getbootstrap.com/css/
  Tema base de bootstrap: http://bootswatch.com/paper/
  notificaciones: https://github.com/Foxandxss/angular-toastr
*/
"use strict";
var nombre = require( "../../package.json" ).name;
var nombreNatural = require( "../../package.json" ).nombreNatural;
var prefix = "ciris-" + nombre;

moment.locale( "es" );

//URL del backend en constante "urlApi"
var modulo = angular.module( nombre, [
  "ngAnimate",
  "ngMessages",
  "ngTouch",
  "ngStorage",
  "ui.router",
  "cfp.hotkeys",
  "ui.bootstrap",
  "toastr",
  "satellizer",
  "angular-loading-bar",
  "angularUtils.directives.uiBreadcrumbs",
  "Backend",
  "ngFileUpload",
  "AngularPrint",
  "colorpicker.module",
  "angular.filter",
  require( "./base" ).name,
  require( "./login" ).name,
  require( "./archivo" ).name,
  require( "./monitoreo" ).name,
  require( "./transcripciones" ).name,
  require( "./calificacion" ).name,
  require( "./reportes" ).name,
  require( "./administracion" ).name
] );

modulo.config( config );
modulo.run( run );

config.$inject = [
  "$locationProvider",
  "$compileProvider",
  "toastrConfig",
  "$authProvider",
  "urlApi",
  "$localStorageProvider",
  "$sessionStorageProvider",
  "cfpLoadingBarProvider"
];

function config( $locationProvider, $compileProvider, toastrConfig, $authProvider,
   urlApi, $localStorageProvider, $sessionStorageProvider, cfpLoadingBarProvider ) {
  modoHtml5( true );
  $compileProvider.debugInfoEnabled( false );

  function modoHtml5( modo ) {
    if ( window.history && window.history.pushState ) {
      $locationProvider.html5Mode( {
        enabled: modo,
        requireBase: false
      } );
    }
  } //modoHtml5
  $localStorageProvider.setKeyPrefix( prefix + "-" );
  $sessionStorageProvider.setKeyPrefix( prefix + "-" );
  configurarToastr( toastrConfig );
  configurarSatellizer( $authProvider, urlApi );
  configurarLoadingBar( cfpLoadingBarProvider );

} //function

run.$inject = [
  "$rootScope",
  "$auth",
  "$state",
  "Notificaciones",
  "$http",
  "$sessionStorage",
  "$localStorage",
  "Cache",
  "ClienteAPI",
  "EntidadAPI",
  "PersonajeAPI"
];

function run( $rootScope, $auth, $state, Notificaciones, $http,
  $sessionStorage, $localStorage, Cache, ClienteAPI, EntidadAPI, PersonajeAPI ) {
  var cargarCache = require( "./cargarCache.js" );
  var cambioEstadoPar = require( "./cambioEstado.js" );
  var cambioEstado = cambioEstadoPar( $auth, $localStorage,
    $sessionStorage, Notificaciones, $state, $http,
    Cache, ClienteAPI, EntidadAPI, PersonajeAPI, cargarCache );
  $rootScope.$on( "$stateChangeStart", cambioEstado );
  $rootScope.$on( "$stateChangeError", noEncontrado );
  if ( $auth.isAuthenticated() ) {
    cargarCache( Cache, ClienteAPI, EntidadAPI, PersonajeAPI );
  }

  function noEncontrado( event, toState, toParams, fromState, fromParams, error ) {
    console.log(event, toState, error);
    event.preventDefault();
    if ( error.autenticado === false ) {
      $state.go( "403" );
    } else {
      $state.go( "404" );
    }
  }
}

function configurarSatellizer( $authProvider, url ) {
  $authProvider.storageType = "sessionStorage";
  $authProvider.loginUrl = url + "/api/login/odoo";
  $authProvider.baseUrl = url;
  $authProvider.tokenPrefix = prefix;
  $authProvider.google( {
    clientId: "738077328040-4opl3gua0qjr3a5jm015oa0rbid0lgoa.apps.googleusercontent.com",
    url: "/api/login/google"
  } );
  $authProvider.oauth1( {
    name: "odoo",
    url: "/api/login/odoo",
    redirectUri: window.location.origin || window.location.protocol +
      "//" + window.location.host + "/asfaltos"
  } );
}

function configurarToastr( toastrConfig ) {
  angular.extend( toastrConfig, {
    autoDismiss: true,
    containerId: "toast-container",
    maxOpened: 0,
    newestOnTop: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    preventOpenDuplicates: true,
    target: "body",
    allowHtml: true,
    closeButton: true,
    closeHtml: "<i class='fa fa-fw fa-times'></i>",
    extendedTimeOut: 25000,
    iconClasses: {
      error: "alert-danger",
      info: "alert-info",
      success: "alert-success",
      warning: "alert-warning"
    },
    messageClass: "toast-message",
    onHidden: null,
    onShown: null,
    onTap: null,
    progressBar: true,
    tapToDismiss: true,
    timeOut: 10000,
    titleClass: "toast-title",
    toastClass: "alert"
  } );
}

function configurarLoadingBar( cfpLoadingBarProvider ) {
  cfpLoadingBarProvider.includeSpinner = false;
  cfpLoadingBarProvider.loadingBarTemplate = "<div id='loading-bar'>" +
    "<aside class='splash-title'>" +
    "<h1>" + nombreNatural + "</h1>" +
    "<div class='bar'></div>" +
    "<p>Estamos procesando su pedido, por favor espere.</p>" +
    "<img src='recursos/imagenes/loading-bars.svg' " +
    "width='64' height='64' class='animated fadeIn'/>" +
    "</aside>" +
    "</div>";
}

module.exports = modulo;

angular.element( document ).ready( function() {
  angular.bootstrap( document, [ modulo.name ], {
    strictDi: true
  } );
} );

},{"../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./administracion":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/index.js","./archivo":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/archivo/index.js","./base":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/index.js","./calificacion":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/index.js","./cambioEstado.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/cambioEstado.js","./cargarCache.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/cargarCache.js","./login":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/index.js","./monitoreo":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/index.js","./reportes":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/index.js","./transcripciones":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/index.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/node_modules/lodash/index.js":[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json":[function(require,module,exports){
module.exports={
  "name": "ProyectoControles",
  "nombreNatural": "Controles Video Técnicos",
  "version": "1.4.1",
  "description": "Proyecto con utilerías, archivos de construcción y arquitectura sugerida para los desarrollos frontend",
  "main": "src/app/index.js",
  "author": "Pablo Peraza",
  "devDependencies": {
    "bower": "^1.6.5",
    "browser-sync": "^1.9.1",
    "browserify": "^8.1.0",
    "connect-history-api-fallback": "0.0.5",
    "gulp": "^3.9.1",
    "gulp-angular-templatecache": "^1.5.0",
    "gulp-complexity": "^0.3.2",
    "gulp-concat": "^2.4.3",
    "gulp-jasmine": "^2.2.1",
    "gulp-jscs": "^3.0.2",
    "gulp-jshint": "^1.11.2",
    "gulp-jsinspect": "^2.0.0",
    "gulp-less": "^3.0.5",
    "gulp-minify-html": "^0.1.8",
    "gulp-ng-constant": "^0.3.0",
    "gulp-notify": "^2.2.0",
    "gulp-plumber": "^1.0.1",
    "gulp-qunit": "^1.2.1",
    "gulp-rename": "^1.2.2",
    "gulp-size": "^2.0.0",
    "gulp-sloc": "^1.0.4",
    "gulp-sourcemaps": "^1.3.0",
    "gulp-uglify": "^1.1.0",
    "gulp-util": "^3.0.2",
    "gulp-watch": "^4.1.0",
    "istanbul": "^0.4.0",
    "jasmine-core": "^2.3.4",
    "jshint": "^2.8.0",
    "jshint-stylish": "^2.0.1",
    "karma": "^0.13.15",
    "karma-browserify": "^4.4.0",
    "karma-chrome-launcher": "^0.2.1",
    "karma-jasmine": "^0.3.6",
    "karma-phantomjs-launcher": "^0.2.1",
    "karma-spec-reporter": "0.0.22",
    "less-plugin-autoprefix": "^1.5.1",
    "less-plugin-clean-css": "^1.5.1",
    "lodash": "^3.7.0",
    "log": "^1.4.0",
    "main-bower-files": "^2.5.0",
    "map-stream": "0.0.6",
    "mkdirp": "^0.5.1",
    "mocha": "^2.2.4",
    "phantomjs": "^1.9.18",
    "rimraf": "^2.2.8",
    "video.js": "^5.4.6",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.0.0",
    "watchify": "^2.2.1",
    "yargs": "^3.26.0"
  },
  "dependencies": {},
  "scripts": {
    "lint": "lessc --lint src/less/main.less"
  },
  "overrides": {
    "graceful-fs": "^4.2.11"
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/controladores/formClienteCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormClienteCtrl;

FormClienteCtrl.$inject = [ "cliente", "usuarios", "ClienteAPI",
"UsuarioClienteAPI", "EntidadAPI", "PersonajeAPI", "ArchivoAPI",
"$state", "$stateParams", "Notificaciones", "$scope" ];

function FormClienteCtrl( cliente, usuarios, ClienteAPI,
  UsuarioClienteAPI, EntidadAPI, PersonajeAPI, ArchivoAPI,
  $state, $stateParams, Notificaciones, $scope ) {
  var vm = this;
  var imagenParaBorrar = [];
  var pagina = 0;
  var cantidad = 15;
  var passDefault = "controles123";
  vm.cliente = cliente;
  vm.info = true;
  vm.cliente.editando = ( $stateParams.editar === "true" );
  vm.personajes = [];
  vm.entidades = [];
  vm.usuarios = usuarios.docs;
  vm.agregarHorario = agregarHorario;
  vm.removerHorario = removerHorario;
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;
  vm.obtenerPersonajes = obtenerPersonajes;
  vm.agregarPersonaje = agregarPersonaje;
  vm.removerPersonaje = removerPersonaje;
  vm.obtenerEntidades = obtenerEntidades;
  vm.agregarEntidad = agregarEntidad;
  vm.removerEntidad = removerEntidad;
  vm.agregarTema = agregarTema;
  vm.removerTema = removerTema;
  vm.agregarContacto = agregarContacto;
  vm.removerContacto = removerContacto;
  vm.agregarUsuario = agregarUsuario;
  vm.removerUsuario = removerUsuario;
  vm.resetPassword = resetPassword;
  vm.showTab = showTab;
  vm.eliminarLogo = eliminarLogo;
  mostrarInfoPersonajes( vm.cliente.personajes );
  mostrarInfoEntidades( vm.cliente.entidades );

  vm.television = vm.cliente.medios.Televisión;

  if ( _.isNull( vm.cliente.informesConfig ) ) {
    vm.cliente.informesConfig = {
      recibir: true,
      config: [ {
        hora: new Date( moment().hour( 12 ).minute( 0 ).second( 0 ) ),
        dias: dias()
      } ]
    };
  }

  $scope.$watch( "vm.uploaded", function( value ) {
    if ( value ) {
      vm.cliente.agregarArchivo( value.resultado );
    }
  } );

  if ( vm.cliente.idLogo ) {
    cargarArchivo();
  }

  function cargarArchivo() {
    ArchivoAPI.obtener( vm.cliente.idLogo ).then( function( resp ) {
      vm.cliente.archivoLogo = resp;
    } );
  }

  function eliminarLogo() {
    imagenParaBorrar.push( vm.cliente.idLogo );
    delete vm.cliente.idLogo;
    delete vm.cliente.archivoLogo;
  }

  function showTab( nombreTab ) {
    switch ( nombreTab ) {
      case "info":
        vm.info = true;
        vm.servicios = false;
        vm.relaciones = false;
        break;
      case "servicios":
        vm.info = false;
        vm.servicios = true;
        vm.relaciones = false;
        break;
      case "relaciones":
        vm.info = false;
        vm.servicios = false;
        vm.relaciones = true;
        break;
      default:
        vm.info = true;
        vm.servicios = false;
        vm.relaciones = false;
    }
  }

  function setRelacionInfo( itemsMV, itemsDB ) {
    return _.map( itemsMV, function( item ) {
      item.tipoRelacion = _.result( _.find( itemsDB, function( i ) {
          return item._id === i._id;
        } ), "tipoRelacion" );
      return item;
    } );
  }

  function mostrarInfoPersonajes( personajes ) {
    var ids = {ids: _.pluck( personajes, "_id" )};
    PersonajeAPI.getPersonajesBulk( ids ).then( function( resp ) {
      var personajesTemp = formatearPersonajes( resp.docs );
      vm.personajes = setRelacionInfo( personajesTemp, personajes );
    } );
  }

  function  mostrarInfoEntidades( entidades ) {
    var ids = {ids: _.pluck( entidades, "_id" )};
    EntidadAPI.getEntidadesBulk( ids ).then( function( resp ) {
      var entidadesTemp = formatearEntidades( resp.docs );
      vm.entidades = setRelacionInfo( entidadesTemp, entidades );
    } );
  }

  function agregarObjeto( objeto, arreglo ) {
    if ( ( _.isObject( objeto ) ) &&
         !_.find( arreglo, {
           "_id": objeto._id
         } ) ) {
      objeto.tipoRelacion = "Directa";
      arreglo = _.union( arreglo, [ objeto ] );
    }
    return arreglo;
  }

  function removerObjeto( objeto, arreglo ) {
    if ( _.isObject( objeto ) && !_.isNull( objeto ) ) {
      arreglo = _.remove( arreglo, function( item ) {
        return objeto._id !== item._id;
      } );
      return arreglo;
    }
  }

  function agregarContacto( ) {
    vm.cliente.agregarContacto( vm.correo );
    vm.correo = null;
  }

  function removerContacto( contacto ) {
    vm.cliente.removerContacto( contacto );
  }

  function agregarTema() {
    if ( !_.isNull( vm.tema ) ) {
      vm.cliente.agregarTema( vm.tema );
    }
    vm.tema = null;
  }

  function removerTema( tema ) {
    if ( !_.isNull( tema ) ) {
      vm.cliente.removerTema( tema );
    }
  }

  function removerPersonaje( personaje ) {
    vm.personajes = removerObjeto( personaje, vm.personajes );
    vm.cliente.removerPersonaje( personaje._id );
  }

  function agregarPersonaje() {
    vm.personajes = agregarObjeto( vm.textoPersonaje, vm.personajes );
    vm.textoPersonaje = "";
  }

  // Para futuro, esto se puede hacer desde la entidad como una funcion
  function formatearPersonajes( personajes ) {
    _.forEach( personajes, function( personaje ) {
      personaje.display = personaje.nombre + " " + personaje.apellido +
         " - " + personaje.descripcion;
    } );
    return personajes;
  }

  function obtenerPersonajes() {
    return PersonajeAPI.listarSinBarra( pagina, cantidad, vm.textoPersonaje )
         .then( function( resp ) {
           return formatearPersonajes( resp.docs );
         } );
  }

  function removerEntidad( entidad ) {
    vm.entidades = removerObjeto( entidad, vm.entidades );
    vm.cliente.removerEntidad( entidad._id );
  }

  function agregarEntidad() {
    vm.entidades = agregarObjeto( vm.textoEntidad, vm.entidades );
    vm.textoEntidad = "";
  }

  // Para futuro, esto se puede hacer desde la entidad como una funcion
  function formatearEntidades( entidades ) {
    _.forEach( entidades, function( entidad ) {
      if ( entidad.abreviatura ) {
        entidad.display = entidad.nombre + " (" + entidad.abreviatura + ")";
      } else {
        entidad.display = entidad.nombre;
      }
    } );
    return entidades;
  }

  function obtenerEntidades() {
    return EntidadAPI.listarSinBarra( pagina, cantidad, vm.textoEntidad )
         .then( function( resp ) {
           return formatearEntidades( resp.docs );
         } );
  }

  function agregarHorario() {
    var nuevoHorario = {
      hora: new Date( moment().hour( 12 ).minute( 0 ).second( 0 ) ),
      dias: angular.copy( dias() )
    };
    vm.cliente.informesConfig.config.push( nuevoHorario );
  }

  function removerHorario( index ) {
    _.pullAt( vm.cliente.informesConfig.config, index );
  }

  function guardar( formValido ) {
    if ( formValido ) {
      vm.cliente.medios.Televisión = vm.television;
      vm.cliente.agregarPersonajes( vm.personajes );
      vm.cliente.agregarEntidades( vm.entidades );
      ClienteAPI.guardar( vm.cliente )
      .then( function( resp ) {
        if ( _.isEmpty( imagenParaBorrar ) ) {
          reload( resp._id, false );
        } else {
          ArchivoAPI.eliminar( imagenParaBorrar ).then( function() {
            reload( resp._id, false );
          } );
        }
      } )
      .finally( function() {
        Notificaciones.agregarPersonalizado( 0, " Por favor recuerde " +
        "notificar al personal de Monitoreo refrescar el navegador " +
        "para que dispongan de estos cambios." );
      } );
    }
  }

  function editar( valor ) {
    reload( vm.cliente._id, valor );
  }

  function eliminar() {
    ClienteAPI.eliminar( vm.cliente ).then( function() {
      $state.go( "^.cliente-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {
      id: id,
      editar: editando
    }, {
      reload: true
    } );
  }

  function agregarUsuario( ) {
    if ( _.isString( vm.correoLogin ) ) {
      var usuario = {
        correo: vm.correoLogin,
        password:passDefault,
        clienteId:vm.cliente._id
      };

      //si el correo ya está en la lista del FE no hace el request al BE
      if ( !_.some( vm.usuarios, "correo", usuario.correo ) ) {
        UsuarioClienteAPI.guardar( usuario )
        .then( function( resp ) {
          if ( !_.isUndefined( resp ) ) {
            vm.usuarios.push( resp );
          } else {
            Notificaciones.agregarPersonalizado( 0, usuario.correo + " ya ha sido registrado." );
          }
        } );
      } else {
        Notificaciones.agregarPersonalizado( 0, usuario.correo + " ya ha sido registrado." );
      }
      vm.correoLogin = null;
    }
  }

  function removerUsuario( usuario ) {
    if ( confirm( "¿Desea eliminar este usuario?" +
    " El usuario no podrá loguearse en la aplicación ni al sitio web." ) ) {
      UsuarioClienteAPI.eliminar( usuario._id ).then( function( ) {
        vm.usuarios = _.remove( vm.usuarios, function( usr ) {
          return usr._id !== usuario._id;
        } );
      } );
    }
  }

  function resetPassword( usuario ) {
    if ( confirm( "¿Desea resetear la contraseña para este usuario?" ) ) {
      usuario.password = passDefault;
      UsuarioClienteAPI.guardar( usuario );
    }
  }
}

function dias() {
  return [ {
    nombre: "Lun",
    index: 1,
    valor: true
  }, {
    nombre: "Mar",
    index: 2,
    valor: true
  }, {
    nombre: "Mie",
    index: 3,
    valor: true
  }, {
    nombre: "Jue",
    index: 4,
    valor: true
  }, {
    nombre: "Vie",
    index: 5,
    valor: true
  }, {
    nombre: "Sab",
    index: 6
  }, {
    nombre: "Dom",
    index: 7
  } ];
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/controladores/listadoClienteCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoClienteCtrl;

ListadoClienteCtrl.$inject = [ "listado", "ClienteAPI", "$state", "$stateParams" ];
function ListadoClienteCtrl( listado, ClienteAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.texto = $stateParams.texto;
  vm.listado = listado;
  vm.cambiarEstado = cambiarEstado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;
  vm.filtrarListado = filtrarListado;

  function cambiarEstado( cliente ) {
    if ( cliente.habilitado ) {
      cliente.deshabilitar();
    } else {
      cliente.habilitar();
    }
    ClienteAPI.guardar( cliente );
  }

  function eliminar( cliente ) {
    if( confirm("Desea eliminar el cliente?") ){
      cliente.borrado = true;
      ClienteAPI.guardar( cliente )
      .then( function( response ) {
        _.remove(vm.listado.docs, {"_id": cliente._id});
      } );
    }
  }

  function filtrarListado() {
    vm.buscando = true;
    ClienteAPI.listarSinBarra( $stateParams.pagina, $stateParams.cantidad, vm.texto, true )
      .then( function( response ) {
        vm.listado.docs = response.docs;
        vm.listado.contador = response.contador;
      } )
      .finally( function() {
        vm.buscando = false;
      } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad, texto: vm.texto}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/controladores/rest/clienteAPI.js":[function(require,module,exports){
"use strict";

module.exports = ClienteAPI;

var Cliente = require( "../../modelos/cliente.js" );

ClienteAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function ClienteAPI( urlApi, $http, Notificaciones ) {
  ClienteAPI.obtener = obtener;
  ClienteAPI.listar = listar;
  ClienteAPI.listarSinBarra = listarSinBarra;
  ClienteAPI.guardar = guardar;
  ClienteAPI.eliminar = eliminar;
  ClienteAPI.getClientes = getClientes;
  ClienteAPI.getClientesBulk = getClientesBulk;
  ClienteAPI.listarTodosLosClientes = listarTodosLosClientes;
  return ClienteAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/cliente/" + id ).then( function( resp ) {
        return Cliente.cargar( resp.data );
      } );
    } else {
      return new Cliente();
    }
  }

  function getClientes( id, tipoMedio, all ) {
    var params = {
        params: {
          id: id,
          tipoMedio: tipoMedio,
          all: all || false
        },
        ignoreLoadingBar: true
      };
    return $http.get( urlApi + "/api/cliente/clientes", params ).then( clienteOk, err );
  }

  function getClientesBulk( ids ) {
    return $http.post( urlApi + "/api/cliente/clientes", ids );
  }

  function clienteOk( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Cliente.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function listar( pagina, cantidad, texto, all ) {
    return listarCurried( false )( pagina, cantidad, texto, all );
  }

  function listarSinBarra( pagina, cantidad, texto, all ) {
    return listarCurried( true )( pagina, cantidad, texto, all );
  }

  function listarTodosLosClientes() {
    var params = {
      params: {
        all: false
      },
      ignoreLoadingBar: false
    };
    return $http.get( urlApi + "/api/cliente/", params ).then( ok, err );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto, all ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto,
          all: all || false
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/cliente/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Cliente.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Cliente" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/cliente/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Cliente" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Cliente" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/cliente/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Cliente" );
      return Cliente.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Cliente" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/cliente/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Cliente" );
      return Cliente.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Cliente" );
      return resp;
    } );
  }
}

},{"../../modelos/cliente.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/modelos/cliente.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/controladores/rest/usuarioClienteAPI.js":[function(require,module,exports){
"use strict";

module.exports = UsuarioClienteAPI;

var UsuarioCliente = require( "../../modelos/usuarioCliente.js" );

UsuarioClienteAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function UsuarioClienteAPI( urlApi, $http, Notificaciones ) {
  UsuarioClienteAPI.obtener = obtener;
  UsuarioClienteAPI.listar = listar;
  UsuarioClienteAPI.listarSinBarra = listarSinBarra;
  UsuarioClienteAPI.guardar = guardar;
  UsuarioClienteAPI.eliminar = eliminar;
  return UsuarioClienteAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/usuariocliente/" + id ).then( function( resp ) {
        return UsuarioCliente.cargar( resp.data );
      } );
    } else {
      return new UsuarioCliente();
    }
  }

  function listar( pagina, cantidad, clienteId ) {
    return listarCurried( false )( pagina, cantidad, clienteId );
  }

  function listarSinBarra( pagina, cantidad, clienteId ) {
    return listarCurried( true )( pagina, cantidad, clienteId );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, clienteId ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          clienteId: clienteId
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/usuariocliente/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = UsuarioCliente.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Usuario" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/usuariocliente/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/usuariocliente/", obj ).then( function( resp ) {
      return UsuarioCliente.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/usuariocliente/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return UsuarioCliente.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return resp;
    } );
  }
}

},{"../../modelos/usuarioCliente.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/modelos/usuarioCliente.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Cliente", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoClienteCtrl", require( "./controladores/listadoClienteCtrl.js" ) );
modulo.controller( "FormClienteCtrl", require( "./controladores/formClienteCtrl.js" ) );

modulo.factory( "ClienteAPI", require( "./controladores/rest/clienteAPI.js" ) );
modulo.factory( "UsuarioClienteAPI", require( "./controladores/rest/usuarioClienteAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formClienteCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/controladores/formClienteCtrl.js","./controladores/listadoClienteCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/controladores/listadoClienteCtrl.js","./controladores/rest/clienteAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/controladores/rest/clienteAPI.js","./controladores/rest/usuarioClienteAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/controladores/rest/usuarioClienteAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/modelos/cliente.js":[function(require,module,exports){
"use strict";

module.exports = Cliente;

function Cliente( nombre, abreviatura, idLogo, color,  correos,
  usuarios, servicios, medios, fechaRegistro, habilitado, informesConfig,
  personajes, entidades,  temas, _id ) {
  this.nombre = nombre || null;
  this.abreviatura = abreviatura;
  this.idLogo = idLogo;
  this.color = color || "#15460f";
  this.correos = correos || [];
  this.usuarios = usuarios || [];
  this.servicios = servicios || serviciosDefault();
  this.medios = medios || mediosDefault();
  this.fechaRegistro = fechaRegistro || moment();
  this.habilitado = validarBoolean( habilitado );
  this.informesConfig = informesConfig || null;
  this.personajes = personajes || [];
  this.entidades = entidades || [];
  this.temas = temas || [];
  this._id = _id;
}

function serviciosDefault() {
  return {
    transcripcion: false,
    alertas: false
  };
}

function mediosDefault() {
  return {
    Prensa:false,
    Televisión: false,
    Radio: false
  };
}

Cliente.cargar = cargar;
Cliente.prototype.habilitar = habilitar;
Cliente.prototype.deshabilitar = deshabilitar;
Cliente.prototype.agregarPersonajes = agregarPersonajes;
Cliente.prototype.agregarEntidades = agregarEntidades;
Cliente.prototype.agregarTema = agregarTema;
Cliente.prototype.agregarContacto = agregarContacto;
Cliente.prototype.agregarUsuarios = agregarUsuarios;
Cliente.prototype.removerPersonaje = removerPersonaje;
Cliente.prototype.removerEntidad = removerEntidad;
Cliente.prototype.removerTema = removerTema;
Cliente.prototype.removerContacto = removerContacto;
Cliente.prototype.toString = toString;
Cliente.prototype.agregarArchivo = agregarArchivo;

function toString() {
  return this.nombre;
}

function habilitar() {
  this.habilitado = true;
}

function deshabilitar() {
  this.habilitado = false;
}

function agregarElementos( arreglo ) {
  var arregloRelaciones = [];
  if ( _.isArray( arreglo ) ) {
    _.forEach( arreglo, function( item ) {
      arregloRelaciones = _.union( arregloRelaciones, [
        {
          _id:item._id,
          tipoRelacion:item.tipoRelacion
        }
      ] );
    } );
  }
  return arregloRelaciones;
}

function agregarUsuarios( usuariosIds ) {
  this.usuarios = usuariosIds;
}

function agregarContacto( contacto ) {
  if ( _.isString( contacto ) ) {
    this.correos = _.union( this.correos, [ contacto ] );
  }
}

function removerContacto( contacto ) {
  if ( _.isString( contacto ) ) {
    this.correos = _.without( this.correos, contacto );
  }
}

function removerPersonaje( id ) {
  this.personajes = _.without( this.personajes, id );
}

function removerEntidad( id ) {
  this.entidades = _.without( this.entidades, id );
}

function removerTema( tema ) {
  this.temas = _.without( this.temas, tema );
}

function agregarPersonajes( personajes ) {
  this.personajes = agregarElementos( personajes );
}

function agregarEntidades( entidades ) {
  this.entidades = agregarElementos( entidades );
}

function agregarTema( tema ) {
  if ( _.isString( tema ) && tema.length > 0 ) {
    this.temas = _.union( this.temas, [ tema ] ) ;
  }
}

function validarBoolean( bool ) {
  if ( _.isUndefined( bool ) ) {
    return true;
  } else {
    return bool;
  }
}

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function agregarArchivo( archivo ) {
  if ( archivo ) {
    this.idLogo = archivo._id;
    this.archivoLogo = archivo;
  }
}

function instanciar( json ) {
  return new Cliente( json.nombre, json.abreviatura, json.idLogo,
    json.color, json.correos, json.usuarios, json.servicios, json.medios,
    json.fechaRegistro, json.habilitado, json.informesConfig,
    json.personajes, json.entidades, json.temas, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/modelos/usuarioCliente.js":[function(require,module,exports){
"use strict";

module.exports = UsuarioCliente;

function UsuarioCliente( correo, password, clienteId, _id ) {
  this.correo = correo;
  this.password = password;
  this.clienteId = clienteId;
  this._id = _id;
}

UsuarioCliente.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new UsuarioCliente( json.correo, json.password, json.clienteId, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.cliente-lista", {
    templateUrl: "administracion/cliente/vistas/listaCliente.html",
    url: "/cliente?pagina&cantidad?texto",
    controller: "ListadoClienteCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarCliente
    },
    data: {
      titulo: "Listado de Cliente",
      icono: "fa-list",
      menu: "Listar Cliente"
    }
  } );

  $stateProvider.state( "inicio.administracion.cliente-uno", {
    templateUrl: "administracion/cliente/vistas/formCliente.html",
    url: "/cliente/:id?editar",
    controller: "FormClienteCtrl",
    controllerAs: "vm",
    resolve: {
      cliente: obtenerCliente,
      usuarios: listarUsuariosCliente
    },
    data: {
      titulo: "Form de Cliente",
      icono: "fa-file-o",
      menu: "Form Cliente"
    }
  } );

  listarUsuariosCliente.$inject = [ "UsuarioClienteAPI", "$stateParams", "$auth", "$q" ];
  function listarUsuariosCliente( UsuarioClienteAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.cliente.listar ) {
      if ( $stateParams.id ) {
        return UsuarioClienteAPI.listarSinBarra( 0, 20, $stateParams.id );
      } else {
        return { count: 0, docs: [] };
      }
    }
    return $q.reject( {autenticado: false} );
  }

  listarCliente.$inject = [ "ClienteAPI", "$stateParams", "$auth", "$q" ];
  function listarCliente( ClienteAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.cliente.listar ) {
      return ClienteAPI.listar( $stateParams.pagina, $stateParams.cantidad, $stateParams.texto, true );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerCliente.$inject = [ "ClienteAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerCliente( ClienteAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "cliente" ) ) {
      return ClienteAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/administracionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = AdministracionCtrl;

AdministracionCtrl.$inject = [];
function AdministracionCtrl() {
  var mod = this;
  mod.fechaActual = moment();
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/contabilizarCaracteresCtrl.js":[function(require,module,exports){
"use strict";

module.exports = contabilizarCaracteresCtrl;

contabilizarCaracteresCtrl.$inject = [ "contarCaracteres" ];
function contabilizarCaracteresCtrl( contarCaracteres ) {
  var vm = this;
  vm.contarChars = contarChars;

  function contarChars() {
    vm.caracteresBrutos = contarCaracteres.contarCaracteresBrutos( vm.texto );
    vm.caracteres = contarCaracteres.contarCaracteres( vm.texto );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/formRolCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormRolCtrl;

FormRolCtrl.$inject = [ "rol", "RolAPI", "$state", "$stateParams" ];
function FormRolCtrl( rol, RolAPI, $state, $stateParams ) {
  var vm = this;
  vm.rol = rol;
  vm.rol.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;

  function guardar( formValido ) {
    if ( formValido ) {
      RolAPI.guardar( vm.rol ).then( function( resp ) {
        reload( resp._id, false );
      } );
    }
  }

  function editar( valor ) {
    reload( vm.rol._id, valor );
  }

  function eliminar() {
    RolAPI.eliminar( vm.rol ).then( function() {
      $state.go( "^.rol-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/formUsuarioCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormUsuarioCtrl;

FormUsuarioCtrl.$inject = [ "usuario", "UsuarioAPI", "RolAPI", "$state", "$stateParams", "$auth" ];
function FormUsuarioCtrl( usuario, UsuarioAPI, RolAPI, $state, $stateParams, $auth ) {
  var vm = this;
  vm.usuario = usuario;
  vm.idUsuarioLogueado = $auth.getPayload().sub;
  vm.usuario.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;
  vm.aplicarPermisos = aplicarPermisos;
  listarRoles();

  function guardar( formValido ) {
    if ( formValido ) {
      UsuarioAPI.guardar( vm.usuario ).then( function( resp ) {
        reload( resp._id, false );
      } );
    }
  }

  function editar( valor ) {
    reload( vm.usuario._id, valor );
  }

  function eliminar() {
    UsuarioAPI.eliminar( vm.usuario ).then( function() {
      $state.go( "^.usuario-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }

  function listarRoles() {
    RolAPI.listar( 0, 0 ).then( function( resp ) {
      vm.listaRoles = resp.docs;
    } );
  }

  function aplicarPermisos( rol ) {
    var i = _.findIndex( vm.listaRoles, function( elem ) {
      return elem.nombre === rol;
    } );
    Object.assign( vm.usuario.permisos, vm.listaRoles[i].permisos );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/listadoRolCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoRolCtrl;

ListadoRolCtrl.$inject = [ "listado", "RolAPI", "$state", "$stateParams" ];
function ListadoRolCtrl( listado, RolAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;

  function eliminar( rol ) {
    if ( confirm( "¿Está seguro que desea eliminar el Rol?" ) ) {
      RolAPI.eliminar( rol._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === rol._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/listadoUsuarioCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoUsuarioCtrl;

ListadoUsuarioCtrl.$inject = [ "listado", "UsuarioAPI", "$state", "$stateParams", "$auth" ];
function ListadoUsuarioCtrl( listado, UsuarioAPI, $state, $stateParams, $auth ) {
  var vm = this;
  vm.idUsuarioLogueado = $auth.getPayload().sub;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.listadoTotal = listado.contador;
  vm.listado = listado.docs;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;

  function eliminar( usuario ) {
    if ( confirm( "¿Está seguro que desea eliminar el Usuario?" ) ) {
      UsuarioAPI.eliminar( usuario._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === usuario._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/rest/rolAPI.js":[function(require,module,exports){
"use strict";

module.exports = RolAPI;

var Rol = require( "../../modelos/rol.js" );

RolAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function RolAPI( urlApi, $http, Notificaciones ) {
  RolAPI.obtener = obtener;
  RolAPI.listar = listar;
  RolAPI.guardar = guardar;
  RolAPI.eliminar = eliminar;
  return RolAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/rol/" + id ).then( function( resp ) {
        return Rol.cargar( resp.data );
      } );
    } else {
      return new Rol();
    }
  }

  function listar( pagina, cantidad ) {
    var params = {
      params: {
        pagina: pagina || 0,
        cantidad: ( cantidad || cantidad === 0 ) ? cantidad : 10
      }
    };
    return $http.get( urlApi + "/api/rol/", params ).then( ok, err );
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Rol.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Rol" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/rol/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Rol" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Rol" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/rol/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Rol" );
      return Rol.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Rol" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/rol/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Rol" );
      return Rol.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Rol" );
      return resp;
    } );
  }
}

},{"../../modelos/rol.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/modelos/rol.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/controladores/formEntidadCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormEntidadCtrl;

FormEntidadCtrl.$inject = [
  "entidad",
  "EntidadAPI",
  "$state",
  "$stateParams",
  "Notificaciones"
];
function FormEntidadCtrl( entidad, EntidadAPI, $state, $stateParams, Notificaciones ) {
  var vm = this;
  vm.entidad = entidad;
  vm.entidad.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;
  vm.volverURI = volverURI;

  obtenerParams();

  function obtenerParams() {
    if ( $stateParams.etiqueta && $stateParams.nombre ) {
      vm.origen = "etiqueta";
      vm.entidad.nombre = $stateParams.nombre;
      vm.etiqueta = $stateParams.etiqueta;
    }
  }

  function volverURI() {
    switch ( vm.origen ) {
      case "etiqueta":
        return "inicio.administracion.etiqueta-lista";
      default:
        return "^.entidad-lista";
    }
  }

  function guardar( formValido ) {
    if ( formValido ) {
      EntidadAPI.guardar( vm.entidad )
      .then( function( resp ) {
        switch ( vm.origen ) {
          case "etiqueta":
            $state.go( "inicio.administracion.etiqueta-lista", { completado: vm.etiqueta } );
            break;
          default:
            reload( resp._id, false );
        }
      } )
      .finally( function() {
        Notificaciones.agregarPersonalizado( 0, " Por favor recuerde " +
        "notificar al personal de Monitoreo refrescar el navegador " +
        "para que dispongan de estos cambios." );
      } );
    }
  }

  function editar( valor ) {
    reload( vm.entidad._id, valor );
  }

  function eliminar() {
    EntidadAPI.eliminar( vm.entidad ).then( function() {
      $state.go( "^.entidad-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/controladores/listadoEntidadCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoEntidadCtrl;

ListadoEntidadCtrl.$inject = [ "listado", "EntidadAPI", "$state", "$stateParams" ];
function ListadoEntidadCtrl( listado, EntidadAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.texto = $stateParams.texto;
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;
  vm.filtrarListado = filtrarListado;

  function eliminar( entidad ) {
    if ( confirm( "¿Está seguro que desea eliminar el Entidad?" ) ) {
      EntidadAPI.eliminar( entidad._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === entidad._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function filtrarListado() {
    vm.buscando = true;
    EntidadAPI.listarSinBarra( $stateParams.pagina, $stateParams.cantidad, vm.texto )
      .then( function( response ) {
        vm.listado.docs = response.docs;
        vm.listado.contador = response.contador;
      } )
      .finally( function() {
        vm.buscando = false;
      } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad, texto: vm.texto}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/controladores/rest/entidadAPI.js":[function(require,module,exports){
"use strict";

module.exports = EntidadAPI;

var Entidad = require( "../../modelos/entidad.js" );

EntidadAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function EntidadAPI( urlApi, $http, Notificaciones ) {
  EntidadAPI.obtener = obtener;
  EntidadAPI.listar = listar;
  EntidadAPI.listarSinBarra = listarSinBarra;
  EntidadAPI.guardar = guardar;
  EntidadAPI.eliminar = eliminar;
  EntidadAPI.getEntidadesBulk = getEntidadesBulk;
  return EntidadAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/entidad/" + id ).then( function( resp ) {
        return Entidad.cargar( resp.data );
      } );
    } else {
      return new Entidad();
    }
  }

  function getEntidadesBulk( ids ) {
    return $http.post( urlApi + "/api/entidad/entidades", ids ).then( function( resp ) {
      return resp.data;
    } );
  }

  function listar( pagina, cantidad, texto ) {
    return listarCurried( false )( pagina, cantidad, texto );
  }

  function listarSinBarra( pagina, cantidad, texto ) {
    return listarCurried( true )( pagina, cantidad, texto );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/entidad/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Entidad.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Entidad" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/entidad/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Entidad" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Entidad" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/entidad/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Entidad" );
      return Entidad.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Entidad" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/entidad/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Entidad" );
      return Entidad.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Entidad" );
      return resp;
    } );
  }
}

},{"../../modelos/entidad.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/modelos/entidad.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Entidad", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoEntidadCtrl", require( "./controladores/listadoEntidadCtrl.js" ) );
modulo.controller( "FormEntidadCtrl", require( "./controladores/formEntidadCtrl.js" ) );

modulo.factory( "EntidadAPI", require( "./controladores/rest/entidadAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formEntidadCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/controladores/formEntidadCtrl.js","./controladores/listadoEntidadCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/controladores/listadoEntidadCtrl.js","./controladores/rest/entidadAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/controladores/rest/entidadAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/modelos/entidad.js":[function(require,module,exports){
"use strict";

module.exports = Entidad;

function Entidad( nombre, abreviatura, _id ) {
  this.nombre = nombre;
  this.abreviatura = abreviatura;
  this._id = _id;
}

Entidad.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Entidad( json.nombre, json.abreviatura, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.entidad-lista", {
    templateUrl: "administracion/entidad/vistas/listaEntidad.html",
    url: "/entidad?pagina&cantidad?texto",
    controller: "ListadoEntidadCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarEntidad
    },
    data: {
      titulo: "Listado de Entidad",
      icono: "fa-list",
      menu: "Listar Entidad"
    }
  } );

  $stateProvider.state( "inicio.administracion.entidad-uno", {
    templateUrl: "administracion/entidad/vistas/formEntidad.html",
    url: "/entidad/:id?editar?nombre?etiqueta",
    controller: "FormEntidadCtrl",
    controllerAs: "vm",
    resolve: {
      entidad: obtenerEntidad
    },
    data: {
      titulo: "Form de Entidad",
      icono: "fa-file-o",
      menu: "Form Entidad"
    }
  } );

  listarEntidad.$inject = [ "EntidadAPI", "$stateParams", "$auth", "$q" ];
  function listarEntidad( EntidadAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.entidad.listar ) {
      return EntidadAPI.listar( $stateParams.pagina, $stateParams.cantidad, $stateParams.texto );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerEntidad.$inject = [ "EntidadAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerEntidad( EntidadAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "entidad" ) ) {
      return EntidadAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/controladores/listadoEtiquetaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoEtiquetaCtrl;

ListadoEtiquetaCtrl.$inject = [ "listado", "EtiquetaAPI", "$state", "$stateParams" ];
function ListadoEtiquetaCtrl( listado, EtiquetaAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;

  obtenerParams();

  function obtenerParams() {
    if ( $stateParams.completado ) {
      borrarEtiqueta( $stateParams.completado );
    }
  }

  function eliminar( etiqueta ) {
    if ( confirm( "¿Está seguro que desea eliminar el Etiqueta?" ) ) {
      borrarEtiqueta( etiqueta._id );
    }
  }

  function borrarEtiqueta( id ) {
    EtiquetaAPI.eliminar( id ).then( function( err ) {
      if ( !err ) {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          if ( elem._id === id ) {
            vm.listado.contador -= 1;
          }
          return elem._id === id;
        } );
      }
    } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/controladores/rest/etiquetaAPI.js":[function(require,module,exports){
"use strict";

module.exports = EtiquetaAPI;

var Etiqueta = require( "../../modelos/etiqueta.js" );

EtiquetaAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function EtiquetaAPI( urlApi, $http, Notificaciones ) {
  EtiquetaAPI.obtener = obtener;
  EtiquetaAPI.listar = listar;
  EtiquetaAPI.guardar = guardar;
  EtiquetaAPI.guardarBulk = guardarBulk;
  EtiquetaAPI.eliminar = eliminar;
  return EtiquetaAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/etiqueta/" + id ).then( function( resp ) {
        return Etiqueta.cargar( resp.data );
      } );
    } else {
      return new Etiqueta();
    }
  }

  function listar( pagina, cantidad ) {
    var params = {
      params: {
        pagina: pagina || 0,
        cantidad: cantidad || 10
      }
    };
    return $http.get( urlApi + "/api/etiqueta/", params ).then( ok, err );
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Etiqueta.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Etiqueta" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/etiqueta/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Etiqueta" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Etiqueta" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function guardarBulk( etiquetas ) {
    return $http.post( urlApi + "/api/etiqueta/etiquetas", etiquetas ).then( function( resp ) {
      return resp.data;
    } );
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/etiqueta/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Etiqueta" );
      return Etiqueta.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Etiqueta" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/etiqueta/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Etiqueta" );
      return Etiqueta.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Etiqueta" );
      return resp;
    } );
  }
}

},{"../../modelos/etiqueta.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/modelos/etiqueta.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Etiqueta", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoEtiquetaCtrl", require( "./controladores/listadoEtiquetaCtrl.js" ) );

modulo.factory( "EtiquetaAPI", require( "./controladores/rest/etiquetaAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/listadoEtiquetaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/controladores/listadoEtiquetaCtrl.js","./controladores/rest/etiquetaAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/controladores/rest/etiquetaAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/modelos/etiqueta.js":[function(require,module,exports){
"use strict";

module.exports = Etiqueta;

function Etiqueta( nombre, _id ) {
  this.nombre = nombre;
  this._id = _id;
}

Etiqueta.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Etiqueta( json.nombre, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.etiqueta-lista", {
    templateUrl: "administracion/etiqueta/vistas/listaEtiqueta.html",
    url: "/etiqueta?pagina&cantidad?completado",
    controller: "ListadoEtiquetaCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarEtiqueta
    },
    data: {
      titulo: "Listado de Etiqueta",
      icono: "fa-list",
      menu: "Listar Etiqueta"
    }
  } );

  listarEtiqueta.$inject = [ "EtiquetaAPI", "$stateParams", "$auth", "$q" ];
  function listarEtiqueta( EtiquetaAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.etiqueta.listar ) {
      return EtiquetaAPI.listar( $stateParams.pagina, $stateParams.cantidad );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/controladores/formGrupoclientesCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormGrupoclientesCtrl;

FormGrupoclientesCtrl.$inject = [ "grupoclientes", "GrupoclientesAPI", "ClienteAPI", "$state",
  "$stateParams" ];
function FormGrupoclientesCtrl( grupoclientes, GrupoclientesAPI, ClienteAPI, $state,
                                $stateParams ) {
  var vm = this;
  vm.grupoclientes = grupoclientes;
  vm.grupoclientes.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.clientes = [];
  precargarClientes();

  vm.cargarCliente = cargarCliente;
  vm.agregarCliente = agregarCliente;
  vm.eliminarCliente = eliminarCliente;

  function precargarClientes() {
    vm.clientes = vm.grupoclientes.idClientes;
    vm.grupoclientes.setearClientes( _.map( vm.clientes, "_id" ) );
  }

  function guardar( formValido ) {
    if ( formValido ) {
      GrupoclientesAPI.guardar( vm.grupoclientes ).then( function( resp ) {
        reload( resp._id, false );
      } );
    }
  }

  function editar( valor ) {
    reload( vm.grupoclientes._id, valor );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }

  function cargarCliente( texto ) {
    return ClienteAPI.listarSinBarra( 0, 10, texto )
      .then( function( response ) {
        return response.docs;
      }
    );
  }

  function agregarCliente() {
    vm.clientes.push( vm.cliente );
    vm.grupoclientes.agregarCliente( vm.cliente );
    vm.cliente = undefined;
  }

  function eliminarCliente( id ) {
    vm.clientes = _.reject( vm.clientes, function( c ) { return c._id === id; } );
    vm.grupoclientes.eliminarCliente( id );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/controladores/listadoGrupoclientesCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoGrupoclientesCtrl;

ListadoGrupoclientesCtrl.$inject = [ "listado", "GrupoclientesAPI", "$state", "$stateParams" ];
function ListadoGrupoclientesCtrl( listado, GrupoclientesAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;

  function eliminar( grupoclientes ) {
    if ( confirm( "¿Está seguro que desea eliminar el Grupoclientes?" ) ) {
      GrupoclientesAPI.eliminar( grupoclientes._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === grupoclientes._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/controladores/rest/grupoclientesAPI.js":[function(require,module,exports){
"use strict";

module.exports = GrupoclientesAPI;

var Grupoclientes = require( "../../modelos/grupoclientes.js" );

GrupoclientesAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function GrupoclientesAPI( urlApi, $http, Notificaciones ) {
  GrupoclientesAPI.obtener = obtener;
  GrupoclientesAPI.listar = listar;
  GrupoclientesAPI.guardar = guardar;
  GrupoclientesAPI.eliminar = eliminar;
  return GrupoclientesAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/grupoclientes/" + id ).then( function( resp ) {
        return Grupoclientes.cargar( resp.data );
      } );
    } else {
      return new Grupoclientes();
    }
  }

  function listar( pagina, cantidad ) {
    var params = {
      params: {
        pagina: pagina || 0,
        cantidad: cantidad || 10
      }
    };
    return $http.get( urlApi + "/api/grupoclientes/", params ).then( ok, err );
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Grupoclientes.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Grupoclientes" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/grupoclientes/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Grupoclientes" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Grupoclientes" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/grupoclientes/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Grupoclientes" );
      return Grupoclientes.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Grupoclientes" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/grupoclientes/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Grupoclientes" );
      return Grupoclientes.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Grupoclientes" );
      return resp;
    } );
  }
}

},{"../../modelos/grupoclientes.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/modelos/grupoclientes.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Grupoclientes", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoGrupoclientesCtrl",
  require( "./controladores/listadoGrupoclientesCtrl.js" ) );
modulo.controller( "FormGrupoclientesCtrl",
  require( "./controladores/formGrupoclientesCtrl.js" ) );

modulo.factory( "GrupoclientesAPI", require( "./controladores/rest/grupoclientesAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formGrupoclientesCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/controladores/formGrupoclientesCtrl.js","./controladores/listadoGrupoclientesCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/controladores/listadoGrupoclientesCtrl.js","./controladores/rest/grupoclientesAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/controladores/rest/grupoclientesAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/modelos/grupoclientes.js":[function(require,module,exports){
"use strict";

module.exports = Grupoclientes;

function Grupoclientes( nombre, idClientes, _id ) {
  this.nombre = nombre;
  this.idClientes = idClientes || [];
  this._id = _id;
}

Grupoclientes.cargar = cargar;
Grupoclientes.prototype.agregarCliente = agregarCliente;
Grupoclientes.prototype.eliminarCliente = eliminarCliente;
Grupoclientes.prototype.setearClientes = setearClientes;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function setearClientes( ids ) {
  this.idClientes = ids || [];
}

function instanciar( json ) {
  return new Grupoclientes( json.nombre, json.idClientes, json._id );
}

function agregarCliente( cliente ) {
  this.idClientes.push( cliente._id );
}

function eliminarCliente( id ) {
  this.idClientes = _.reject( this.idClientes, function( c ) { return c === id; } );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.grupoclientes-lista", {
    templateUrl: "administracion/grupoclientes/vistas/listaGrupoclientes.html",
    url: "/grupoclientes?pagina&cantidad",
    controller: "ListadoGrupoclientesCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarGrupoclientes
    },
    data: {
      titulo: "Listado de Grupoclientes",
      icono: "fa-list",
      menu: "Listar Grupoclientes"
    }
  } );

  $stateProvider.state( "inicio.administracion.grupoclientes-uno", {
    templateUrl: "administracion/grupoclientes/vistas/formGrupoclientes.html",
    url: "/grupoclientes/:id?editar",
    controller: "FormGrupoclientesCtrl",
    controllerAs: "vm",
    resolve: {
      grupoclientes: obtenerGrupoclientes
    },
    data: {
      titulo: "Form de Grupoclientes",
      icono: "fa-file-o",
      menu: "Form Grupoclientes"
    }
  } );

  listarGrupoclientes.$inject = [ "GrupoclientesAPI", "$stateParams", "$auth", "$q" ];
  function listarGrupoclientes( GrupoclientesAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.grupoCliente.listar ) {
      return GrupoclientesAPI.listar( $stateParams.pagina, $stateParams.cantidad );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerGrupoclientes.$inject = [ "GrupoclientesAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerGrupoclientes( GrupoclientesAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "grupoCliente" ) ) {
      return GrupoclientesAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../package.json" ).name;

var submodulos = [
  require( "./entidad" ).name,
  require( "./cliente" ).name,
  require( "./etiqueta" ).name,
  require( "./grupoclientes" ).name,
  require( "./listanegra" ).name,
  require( "./medio" ).name,
  require( "./personaje" ).name,
  require( "./programa" ).name,
  require( "./seccion" ).name,
  require( "./tema" ).name,
  require( "./redes" ).name
];

var modulo = angular.module( nombre + ".Administracion", submodulos );
modulo.config( require( "./rutas" ) );

modulo.controller( "AdministracionCtrl", require( "./controladores/administracionCtrl.js" ) );

modulo.controller( "ListadoUsuarioCtrl", require( "./controladores/listadoUsuarioCtrl.js" ) );
modulo.controller( "FormUsuarioCtrl", require( "./controladores/formUsuarioCtrl.js" ) );

modulo.controller( "ListadoRolCtrl", require( "./controladores/listadoRolCtrl.js" ) );
modulo.controller( "FormRolCtrl", require( "./controladores/formRolCtrl.js" ) );

modulo.controller( "contabilizarCaracteresCtrl",
require( "./controladores/contabilizarCaracteresCtrl.js" ) );

modulo.factory( "RolAPI", require( "./controladores/rest/rolAPI.js" ) );

module.exports = modulo;

},{"../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./cliente":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/cliente/index.js","./controladores/administracionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/administracionCtrl.js","./controladores/contabilizarCaracteresCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/contabilizarCaracteresCtrl.js","./controladores/formRolCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/formRolCtrl.js","./controladores/formUsuarioCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/formUsuarioCtrl.js","./controladores/listadoRolCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/listadoRolCtrl.js","./controladores/listadoUsuarioCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/listadoUsuarioCtrl.js","./controladores/rest/rolAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/controladores/rest/rolAPI.js","./entidad":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/entidad/index.js","./etiqueta":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/etiqueta/index.js","./grupoclientes":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/grupoclientes/index.js","./listanegra":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/index.js","./medio":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/index.js","./personaje":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/index.js","./programa":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/index.js","./redes":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/index.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/rutas.js","./seccion":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/index.js","./tema":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/index.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/controladores/listadoListanegraCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoListanegraCtrl;

ListadoListanegraCtrl.$inject = [ "listado", "ListanegraAPI", "$state", "$stateParams" ];
function ListadoListanegraCtrl( listado, ListanegraAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;

  function eliminar( listanegra ) {
    if ( confirm( "¿Está seguro que desea eliminar el Listanegra?" ) ) {
      ListanegraAPI.eliminar( listanegra._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === listanegra._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/controladores/rest/listanegraAPI.js":[function(require,module,exports){
"use strict";

module.exports = ListanegraAPI;

var Listanegra = require( "../../modelos/listanegra.js" );

ListanegraAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function ListanegraAPI( urlApi, $http, Notificaciones ) {
  ListanegraAPI.obtener = obtener;
  ListanegraAPI.listar = listar;
  ListanegraAPI.guardar = guardar;
  ListanegraAPI.eliminar = eliminar;
  return ListanegraAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/listanegra/" + id ).then( function( resp ) {
        return Listanegra.cargar( resp.data );
      } );
    } else {
      return new Listanegra();
    }
  }

  function listar( pagina, cantidad ) {
    var params = {
      params: {
        pagina: pagina || 0,
        cantidad: cantidad || 10
      }
    };
    return $http.get( urlApi + "/api/listanegra/", params ).then( ok, err );
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Listanegra.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Listanegra" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/listanegra/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Listanegra" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Listanegra" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/listanegra/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Listanegra" );
      return Listanegra.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Listanegra" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/listanegra/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Listanegra" );
      return Listanegra.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Listanegra" );
      return resp;
    } );
  }
}

},{"../../modelos/listanegra.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/modelos/listanegra.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Listanegra", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoListanegraCtrl", require( "./controladores/listadoListanegraCtrl.js" ) );

modulo.factory( "ListanegraAPI", require( "./controladores/rest/listanegraAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/listadoListanegraCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/controladores/listadoListanegraCtrl.js","./controladores/rest/listanegraAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/controladores/rest/listanegraAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/modelos/listanegra.js":[function(require,module,exports){
"use strict";

module.exports = Listanegra;

function Listanegra( correo, motivos, estado, alertas, _id ) {
  this.correo = correo;
  this.motivos = motivos;
  this.estado = estado;
  this.alertas = alertas;
  this._id = _id;
}

Listanegra.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Listanegra( json.correo, json.motivos, json.estado, json.alertas, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/listanegra/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.listanegra-lista", {
    templateUrl: "administracion/listanegra/vistas/listaListanegra.html",
    url: "/listanegra?pagina&cantidad",
    controller: "ListadoListanegraCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarListanegra
    },
    data: {
      titulo: "Listado de Listanegra",
      icono: "fa-list",
      menu: "Listar Listanegra"
    }
  } );

  listarListanegra.$inject = [ "ListanegraAPI", "$stateParams", "$auth", "$q" ];
  function listarListanegra( ListanegraAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.listaNegra.listar ) {
      return ListanegraAPI.listar( $stateParams.pagina, $stateParams.cantidad );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/controladores/formMedioCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormMedioCtrl;

FormMedioCtrl.$inject = [ "medio", "MedioAPI", "ArchivoAPI", "$scope", "$state", "$stateParams" ];
function FormMedioCtrl( medio, MedioAPI, ArchivoAPI, $scope, $state, $stateParams ) {
  var vm = this;
  var imagenParaBorrar = [];
  vm.medio = medio;
  vm.medio.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;
  vm.eliminarLogo = eliminarLogo;
  vm.tiposMedio = [ "Radio", "Televisión", "Prensa", "Medios Digitales", "Redes Sociales" ];

  $scope.$watch( "vm.uploaded", function( value ) {
    if ( value ) {
      vm.medio.agregarArchivo( value.resultado );
    }
  } );

  if ( vm.medio.idLogo ) {
    cargarArchivo();
  }

  function cargarArchivo() {
    ArchivoAPI.obtener( vm.medio.idLogo ).then( function( resp ) {
      vm.medio.archivoLogo = resp;
    } );
  }

  function guardar( formValido ) {
    if ( formValido ) {
      MedioAPI.guardar( vm.medio ).then( function( resp ) {
        var respuesta = resp;
        if ( _.isEmpty( imagenParaBorrar ) ) {
          reload( respuesta._id, false );
        } else {
          ArchivoAPI.eliminar( imagenParaBorrar ).then( function() {
            reload( respuesta._id, false );
          } );
        }
      } );
    }
  }

  function editar( valor ) {
    reload( vm.medio._id, valor );
  }

  function eliminar() {
    MedioAPI.eliminar( vm.medio ).then( function() {
      $state.go( "^.medio-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }

  function eliminarLogo() {
    imagenParaBorrar.push( vm.medio.idLogo );
    delete vm.medio.idLogo;
    delete vm.medio.archivoLogo;
  }
}
},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/controladores/listadoMedioCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoMedioCtrl;

ListadoMedioCtrl.$inject = [ "listado", "MedioAPI", "$state", "$stateParams" ];
function ListadoMedioCtrl( listado, MedioAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.texto = $stateParams.texto;
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;
  vm.filtrarListado = filtrarListado;

  function eliminar( medio ) {
    if ( confirm( "¿Está seguro que desea eliminar el Medio?" ) ) {
      MedioAPI.eliminar( medio._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === medio._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function filtrarListado() {
    MedioAPI.listarSinBarra( $stateParams.pagina, $stateParams.cantidad, vm.texto )
      .then( function( response ) {
        listado.docs = response.docs;
        listado.contador = response.contador;
      } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad, texto: vm.texto}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/controladores/rest/medioAPI.js":[function(require,module,exports){
"use strict";

module.exports = MedioAPI;

var Medio = require( "../../modelos/medio.js" );

MedioAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function MedioAPI( urlApi, $http, Notificaciones ) {
  MedioAPI.obtener = obtener;
  MedioAPI.listar = listar;
  MedioAPI.listarSinBarra = listarSinBarra;
  MedioAPI.guardar = guardar;
  MedioAPI.eliminar = eliminar;
  MedioAPI.obtenerMediosTipo = fromTipo;
  MedioAPI.getBulk = getBulk;
  MedioAPI.getMediosPorNombre = getMediosPorNombre;
  return MedioAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/medio/" + id ).then( function( resp ) {
        return Medio.cargar( resp.data );
      } );
    } else {
      return new Medio();
    }
  }

  function getBulk( ids ) {
    return $http.post( urlApi + "/api/medio/medios", ids ).then( function( resp ) {
      return resp.data;
    } );
  }

  function listar( pagina, cantidad, texto, tipoMedio ) {
    return listarCurried( false )( pagina, cantidad, texto, tipoMedio );
  }

  function listarSinBarra( pagina, cantidad, texto, tipoMedio ) {
    return listarCurried( true )( pagina, cantidad, texto, tipoMedio );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto, tipoMedio ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto,
          tipoMedio: tipoMedio
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/medio/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Medio.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Medio" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/medio/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Medio" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Medio" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/medio/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Medio" );
      return Medio.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Medio" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/medio/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Medio" );
      return Medio.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Medio" );
      return resp;
    } );
  }

  function fromTipo( tipo ) {
    var params = {
      params: { tipo: tipo },
      ignoreLoadingBar: true
    };
    return $http.get( urlApi + "/api/medio/tipo", params ).then( ok, err );
  }

  function getMediosPorNombre( nombres ) {
    return $http.post( urlApi + "/api/medio/nombres", {
      nombres: nombres
    } ).then( function( resp ) {
      return resp.data;
    }, function( err ) {
      return err;
    } );
  }
}

},{"../../modelos/medio.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/modelos/medio.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Medio", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoMedioCtrl", require( "./controladores/listadoMedioCtrl.js" ) );
modulo.controller( "FormMedioCtrl", require( "./controladores/formMedioCtrl.js" ) );

modulo.factory( "MedioAPI", require( "./controladores/rest/medioAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formMedioCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/controladores/formMedioCtrl.js","./controladores/listadoMedioCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/controladores/listadoMedioCtrl.js","./controladores/rest/medioAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/controladores/rest/medioAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/modelos/medio.js":[function(require,module,exports){
"use strict";

module.exports = Medio;

function Medio( nombre, tipoMedio, idLogo, _id ) {
  this.nombre = nombre;
  this.tipoMedio = tipoMedio;
  this.idLogo = idLogo;
  this._id = _id;
  this.toString = toString;
}

Medio.cargar = cargar;
Medio.prototype.agregarArchivo = agregarArchivo;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function toString() {
  return "(" + this.tipoMedio + ") " + this.nombre;
}

function instanciar( json ) {
  return new Medio( json.nombre, json.tipoMedio, json.idLogo, json._id );
}

function agregarArchivo( archivo ) {
  if ( archivo ) {
    this.idLogo = archivo._id;
    this.archivoLogo = archivo;
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/medio/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.medio-lista", {
    templateUrl: "administracion/medio/vistas/listaMedio.html",
    url: "/medio?pagina&cantidad?texto",
    controller: "ListadoMedioCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarMedio
    },
    data: {
      titulo: "Listado de Medio",
      icono: "fa-list",
      menu: "Listar Medio"
    }
  } );

  $stateProvider.state( "inicio.administracion.medio-uno", {
    templateUrl: "administracion/medio/vistas/formMedio.html",
    url: "/medio/:id?editar",
    controller: "FormMedioCtrl",
    controllerAs: "vm",
    resolve: {
      medio: obtenerMedio
    },
    data: {
      titulo: "Form de Medio",
      icono: "fa-file-o",
      menu: "Form Medio"
    }
  } );

  listarMedio.$inject = [ "MedioAPI", "$stateParams", "$auth", "$q" ];
  function listarMedio( MedioAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.medio.listar ) {
      return MedioAPI.listar( $stateParams.pagina, $stateParams.cantidad, $stateParams.texto );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerMedio.$inject = [ "MedioAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerMedio( MedioAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "medio" ) ) {
      return MedioAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/modelos/rol.js":[function(require,module,exports){
"use strict";

module.exports = Rol;

function Rol( nombre, descripcion, permisos, _id ) {
  this.nombre = nombre || null;
  this.descripcion = descripcion || null;
  this.permisos = permisos || {};
  this._id = _id;
}

Rol.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Rol( json.nombre, json.descripcion, json.permisos, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/controladores/formPersonajeCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormPersonajeCtrl;

FormPersonajeCtrl.$inject = [
  "personaje",
  "PersonajeAPI",
  "$state",
  "$stateParams",
  "Notificaciones"
];

function FormPersonajeCtrl( personaje, PersonajeAPI, $state, $stateParams, Notificaciones ) {
  var vm = this;
  vm.personaje = personaje;
  vm.personaje.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;
  vm.volverURI = volverURI;

  obtenerParams();

  function obtenerParams() {
    if ( $stateParams.etiqueta && $stateParams.nombre ) {
      vm.origen = "etiqueta";
      vm.personaje.nombre = $stateParams.nombre;
      vm.etiqueta = $stateParams.etiqueta;
    }
  }

  function volverURI() {
    switch ( vm.origen ) {
      case "etiqueta":
        return "inicio.administracion.etiqueta-lista";
      default:
        return "^.personaje-lista";
    }
  }

  function guardar( formValido ) {
    if ( formValido ) {
      PersonajeAPI.guardar( vm.personaje )
      .then( function( resp ) {
        switch ( vm.origen ) {
          case "etiqueta":
            $state.go( "inicio.administracion.etiqueta-lista", { completado: vm.etiqueta } );
            break;
          default:
            reload( resp._id, false );
        }
      } )
      .finally( function() {
        Notificaciones.agregarPersonalizado( 0, " Por favor recuerde " +
        "notificar al personal de Monitoreo refrescar el navegador " +
        "para que dispongan de estos cambios." );
      } );
    }
  }

  function editar( valor ) {
    reload( vm.personaje._id, valor );
  }

  function eliminar() {
    PersonajeAPI.eliminar( vm.personaje ).then( function() {
      $state.go( "^.personaje-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/controladores/listadoPersonajeCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoPersonajeCtrl;

ListadoPersonajeCtrl.$inject = [ "listado", "PersonajeAPI", "$state", "$stateParams" ];
function ListadoPersonajeCtrl( listado, PersonajeAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.texto = $stateParams.texto;
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;
  vm.filtrarListado = filtrarListado;

  function eliminar( personaje ) {
    if ( confirm( "¿Está seguro que desea eliminar el Personaje?" ) ) {
      PersonajeAPI.eliminar( personaje._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === personaje._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function filtrarListado() {
    vm.buscando = true;
    PersonajeAPI.listarSinBarra( $stateParams.pagina, $stateParams.cantidad, vm.texto )
      .then( function( response ) {
        vm.listado.docs = response.docs;
        vm.listado.contador = response.contador;
      } )
      .finally( function() {
        vm.buscando = false;
      } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad, texto: vm.texto}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/controladores/rest/personajeAPI.js":[function(require,module,exports){
"use strict";

module.exports = PersonajeAPI;

var Personaje = require( "../../modelos/personaje.js" );

PersonajeAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function PersonajeAPI( urlApi, $http, Notificaciones ) {
  PersonajeAPI.obtener = obtener;
  PersonajeAPI.listar = listar;
  PersonajeAPI.listarSinBarra = listarSinBarra;
  PersonajeAPI.guardar = guardar;
  PersonajeAPI.eliminar = eliminar;
  PersonajeAPI.getPersonajesBulk = getPersonajesBulk;
  return PersonajeAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/personaje/" + id ).then( function( resp ) {
        return Personaje.cargar( resp.data );
      } );
    } else {
      return new Personaje();
    }
  }

  function getPersonajesBulk( ids ) {
    return $http.post( urlApi + "/api/personaje/personajes", ids ).then( function( resp ) {
      return resp.data;
    } );
  }

  function listar( pagina, cantidad, texto ) {
    return listarCurried( false )( pagina, cantidad, texto );
  }

  function listarSinBarra( pagina, cantidad, texto ) {
    return listarCurried( true )( pagina, cantidad, texto );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/personaje/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Personaje.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Personaje" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/personaje/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Personaje" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Personaje" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/personaje/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Personaje" );
      return Personaje.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Personaje" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/personaje/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Personaje" );
      return Personaje.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Personaje" );
      return resp;
    } );
  }
}

},{"../../modelos/personaje.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/modelos/personaje.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Personaje", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoPersonajeCtrl", require( "./controladores/listadoPersonajeCtrl.js" ) );
modulo.controller( "FormPersonajeCtrl", require( "./controladores/formPersonajeCtrl.js" ) );

modulo.factory( "PersonajeAPI", require( "./controladores/rest/personajeAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formPersonajeCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/controladores/formPersonajeCtrl.js","./controladores/listadoPersonajeCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/controladores/listadoPersonajeCtrl.js","./controladores/rest/personajeAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/controladores/rest/personajeAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/modelos/personaje.js":[function(require,module,exports){
"use strict";

module.exports = Personaje;

function Personaje( nombre, apellido, descripcion, _id ) {
  this.nombre = nombre || null;
  this.apellido = apellido || null;
  this.descripcion = descripcion || "NR";
  this._id = _id;
}

Personaje.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Personaje( json.nombre, json.apellido, json.descripcion, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/personaje/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.personaje-lista", {
    templateUrl: "administracion/personaje/vistas/listaPersonaje.html",
    url: "/personaje?pagina&cantidad?texto",
    controller: "ListadoPersonajeCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarPersonaje
    },
    data: {
      titulo: "Listado de Personaje",
      icono: "fa-list",
      menu: "Listar Personaje"
    }
  } );

  $stateProvider.state( "inicio.administracion.personaje-uno", {
    templateUrl: "administracion/personaje/vistas/formPersonaje.html",
    url: "/personaje/:id?editar?nombre?etiqueta",
    controller: "FormPersonajeCtrl",
    controllerAs: "vm",
    resolve: {
      personaje: obtenerPersonaje
    },
    data: {
      titulo: "Form de Personaje",
      icono: "fa-file-o",
      menu: "Form Personaje"
    }
  } );

  listarPersonaje.$inject = [ "PersonajeAPI", "$stateParams", "$auth", "$q" ];
  function listarPersonaje( PersonajeAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.personaje.listar ) {
      return PersonajeAPI.listar( $stateParams.pagina, $stateParams.cantidad, $stateParams.texto );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerPersonaje.$inject = [ "PersonajeAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerPersonaje( PersonajeAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "personaje" ) ) {
      return PersonajeAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/controladores/formProgramaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormProgramaCtrl;

FormProgramaCtrl.$inject = [ "programa", "ProgramaAPI", "MedioAPI", "ArchivoAPI", "$state",
    "$stateParams", "$scope" ];
function FormProgramaCtrl( programa, ProgramaAPI, MedioAPI, ArchivoAPI, $state, $stateParams,
                           $scope ) {
  var vm = this;
  var imagenParaBorrar = [];
  vm.programa = programa;
  vm.programa.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;
  vm.eliminarLogo = eliminarLogo;
  vm.diasValidos = diasValidos;
  vm.tiposMedio = [ "Radio", "Televisión" ];

  vm.agregarEdicion = agregarEdicion;
  vm.eliminarEdicion = eliminarEdicion;
  vm.paraEditar = paraEditar;
  vm.nuevaEdicion = nuevaEdicion;
  vm.modificarEdicion = modificarEdicion;
  vm.limpiarForm = limpiarForm;
  vm.cancelarNuevaEdicion = cancelarNuevaEdicion;
  vm.validarCampoDias = validarCampoDias;

  vm.cargarMedio = cargarMedio;

  $scope.$watch( "vm.uploaded", function( value ) {
    if ( value ) {
      vm.programa.agregarArchivo( value.resultado );
    }
  } );

  if ( vm.programa.idMedio ) {
    cargarMedioUsado();
  }

  if ( vm.programa.idLogo ) {
    cargarArchivo();
  }

  function cargarArchivo() {
    ArchivoAPI.obtener( vm.programa.idLogo ).then( function( resp ) {
      vm.programa.archivoLogo = resp;
    } );
  }

  function cargarMedioUsado() {
    MedioAPI.obtener( vm.programa.idMedio ).then( function( resp ) {
      vm.programa.tipoMedio = resp.tipoMedio;
      vm.programa.medio = resp;
    } );
  }

  function nuevaEdicion() {
    vm.edicion = {
      diasSemana: dias(),
      inicio: new Date( moment().hour( 12 ).minute( 0 ).second( 0 ) ),
      fin: new Date( moment().hour( 12 ).minute( 0 ).second( 0 ) )
    };
  }

  function cancelarNuevaEdicion() {
    delete vm.edicion;
  }

  function modificarEdicion( edicion ) {
    vm.edicion = _.clone( edicion );
    vm.edicion.editando = true;
    vm.edicion.inicio = new Date( vm.edicion.horaInicio );
    vm.edicion.fin = new Date( vm.edicion.horaFin );
  }

  function guardar( form ) {
    if ( form.nombre.$valid && form.medio.$valid ) {
      vm.programa.idMedio = vm.programa.medio._id;
      ProgramaAPI.guardar( vm.programa ).then( function( resp ) {
        var respuesta = resp;
        if ( _.isEmpty( imagenParaBorrar ) ) {
          reload( respuesta._id, false );
        } else {
          ArchivoAPI.eliminar( imagenParaBorrar ).then( function() {
            reload( respuesta._id, false );
          } );
        }
      } );
    }
  }

  function editar( valor ) {
    reload( vm.programa._id, valor );
  }

  function eliminar() {
    ProgramaAPI.eliminar( vm.programa ).then( function() {
      $state.go( "^.programa-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }

  function validarCampoDias() {
    if ( vm.edicion ) {
      if ( _.some( vm.edicion.diasSemana, function( d ) { return d.valor; } ) ) {
        vm.edicion.diasValidos = true;
      } else {
        vm.edicion.diasValidos = undefined;
      }
    }
  }

  function agregarEdicion( edicion, form ) {
    if ( form.$valid ) {
      edicion.horaInicio = convertirHora( vm.edicion.inicio );
      edicion.horaFin = convertirHora( vm.edicion.fin );
      if ( vm.edicion.editando ) {
        vm.programa.modificarEdicion( edicion );
      } else {
        vm.programa.agregarEdicion( edicion );
      }
      limpiarForm( form );
    }
  }

  function eliminarEdicion( index ) {
    vm.programa.eliminarEdicion( index );
  }

  function convertirHora( date ) {
    return moment( date );
  }

  function limpiarForm( form ) {
    delete vm.edicion;
    if ( !_.isUndefined( form ) && !_.isNull( form ) ) {
      form.$setUntouched();
      form.$setPristine();
    }
  }

  function diasValidos( form ) {
    var diasSeleccionados = _.filter( vm.edicion.diasSemana, function( d ) {
      return d.valor;
    } );
    if ( diasSeleccionados.length > 0 ) {
      form.dias.$error.require = true;
      return true;
    } else {
      return false;
    }
  }

  function cargarMedio( texto ) {
    return MedioAPI.listarSinBarra( 0, 10, texto, [ vm.programa.tipoMedio ] )
      .then( function( response ) {
        return response.docs;
      } );
  }

  //borrar
  function paraEditar( edicion ) {
    vm.edicion = _.clone( edicion );
    vm.edicion.editando = true;
    vm.edicion.inicio = new Date( vm.edicion.horaInicio );
    vm.edicion.fin = new Date( vm.edicion.horaFin );
  }

  function eliminarLogo() {
    imagenParaBorrar.push( vm.programa.idLogo );
    delete vm.programa.idLogo;
    delete vm.programa.archivoLogo;
  }

}

function dias() {
  return [ {
    nombre: "Lunes",
    index: 1
  }, {
    nombre: "Martes",
    index: 2
  }, {
    nombre: "Miercoles",
    index: 3
  }, {
    nombre: "Jueves",
    index: 4
  }, {
    nombre: "Viernes",
    index: 5
  }, {
    nombre: "Sabado",
    index: 6
  }, {
    nombre: "Domingo",
    index: 7
  } ];
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/controladores/listadoProgramaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoProgramaCtrl;

ListadoProgramaCtrl.$inject = [ "listado", "ProgramaAPI", "$state", "$stateParams" ];
function ListadoProgramaCtrl( listado, ProgramaAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.texto = $stateParams.texto;
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;
  vm.filtrarListado = filtrarListado;

  function eliminar( programa ) {
    if ( confirm( "¿Está seguro que desea eliminar el Programa?" ) ) {
      ProgramaAPI.eliminar( programa._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === programa._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function filtrarListado() {
    ProgramaAPI.listarSinBarra( $stateParams.pagina, $stateParams.cantidad, vm.texto )
      .then( function( response ) {
        vm.listado.docs = response.docs;
        vm.listado.contador = response.contador;
      } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad, texto: vm.texto}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/controladores/rest/programaAPI.js":[function(require,module,exports){
"use strict";

module.exports = ProgramaAPI;

var Programa = require( "../../modelos/programa.js" );

ProgramaAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function ProgramaAPI( urlApi, $http, Notificaciones ) {
  ProgramaAPI.obtener = obtener;
  ProgramaAPI.listar = listar;
  ProgramaAPI.listarSinBarra = listarSinBarra;
  ProgramaAPI.guardar = guardar;
  ProgramaAPI.eliminar = eliminar;
  ProgramaAPI.obtenerProgramasMedio = obtenerProgramasMedio;
  ProgramaAPI.obtenerProgramasMedioSinBarra = obtenerProgramasMedioCurried( false );
  ProgramaAPI.getBulk = getBulk;
  return ProgramaAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/programa/" + id ).then( function( resp ) {
        return Programa.cargar( resp.data );
      } );
    } else {
      return new Programa();
    }
  }

  function obtenerProgramasMedio( id ) {
    return obtenerProgramasMedioCurried( true )( id );
  }

  function obtenerProgramasMedioCurried( loadingBar ) {
    return function( id ) {
      var params = {
        params: { id: id },
        ignoreLoadingBar: !loadingBar
      };
      return $http.get( urlApi + "/api/programa/medio", params ).then( ok, err );
    };
  }

  function getBulk( ids ) {
    return $http.post( urlApi + "/api/programa/programas", ids ).then( function( resp ) {
      return resp.data;
    } );
  }

  function listar( pagina, cantidad, texto ) {
    return listarCurried( false )( pagina, cantidad, texto );
  }

  function listarSinBarra( pagina, cantidad, texto ) {
    return listarCurried( true )( pagina, cantidad, texto );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/programa/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Programa.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Programa" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/programa/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Programa" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Programa" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/programa/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Programa" );
      return Programa.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Programa" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/programa/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Programa" );
      return Programa.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Programa" );
      return resp;
    } );
  }
}

},{"../../modelos/programa.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/modelos/programa.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Programa", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoProgramaCtrl", require( "./controladores/listadoProgramaCtrl.js" ) );
modulo.controller( "FormProgramaCtrl", require( "./controladores/formProgramaCtrl.js" ) );

modulo.factory( "ProgramaAPI", require( "./controladores/rest/programaAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formProgramaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/controladores/formProgramaCtrl.js","./controladores/listadoProgramaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/controladores/listadoProgramaCtrl.js","./controladores/rest/programaAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/controladores/rest/programaAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/modelos/programa.js":[function(require,module,exports){
"use strict";

require( "lodash" );

module.exports = Programa;

function Programa( nombre, idMedio, idLogo, ediciones, _id ) {
  this.nombre = nombre;
  this.idMedio = idMedio;
  this.ediciones = cargarEdiciones( ediciones );
  this.idLogo = idLogo;
  this._id = _id;
}

Programa.cargar = cargar;
Programa.prototype.agregarEdicion = agregarEdicion;
Programa.prototype.eliminarEdicion = eliminarEdicion;
Programa.prototype.modificarEdicion = modificarEdicion;
Programa.prototype.agregarArchivo = agregarArchivo;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function textoDias( dias ) {
  if ( !_.isArray ) {
    return undefined;
  }
  var diasOrden = _.pluck( _.filter( dias, function( a ) { return a.valor; } ), "index" );
  if ( _.isEqual( diasOrden, [ 1, 2, 3, 4, 5 ] ) ) {
    return "L-V";
  }
  if ( _.isEqual( diasOrden, [ 6, 7 ] ) ) {
    return "S-D";
  }
  var letras = _.map( diasOrden, function( d ) {
    switch ( d ) {
      case 1:
        return "L";
      case 2:
        return "K";
      case 3:
        return "M";
      case 4:
        return "J";
      case 5:
        return "V";
      case 6:
        return "S";
      case 7:
        return "D";
      default:
        return "";
    }
  } );
  return _.reduce( letras, function( s, l ) { return s + ", " + l; } );
}

function horaString( hora ) {
  return hora.format( "LT" );
}

function extenderEdicion( edicion ) {
  edicion.textoDias = textoDias( edicion.diasSemana );
  edicion.toString = function() {
    return edicion.nombre + " | " + edicion.textoDias + " de " +
      horaString( edicion.horaInicio ) + " - " + horaString( edicion.horaFin );
  };
  return edicion;
}

function cargarEdiciones( ediciones ) {
  return _.map( ediciones, extenderEdicion );
}

function instanciar( json ) {
  return new Programa( json.nombre, json.idMedio, json.idLogo, json.ediciones, json._id );
}

function agregarEdicion( edicion ) {
  this.ediciones.push( extenderEdicion( edicion ) );
}

function eliminarEdicion( index ) {

  //pullAt muta el array original
  _.pullAt( this.ediciones, index );
}

function modificarEdicion( edicion ) {
  this.ediciones = _.map( this.ediciones, function( e ) {
    if ( e._id === edicion._id ) {
      return extenderEdicion( edicion );
    } else {
      return e;
    }
  } );
}

function agregarArchivo( archivo ) {
  if ( archivo ) {
    this.idLogo = archivo._id;
    this.archivoLogo = archivo;
  }
}

},{"lodash":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/node_modules/lodash/index.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/programa/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.programa-lista", {
    templateUrl: "administracion/programa/vistas/listaPrograma.html",
    url: "/programa?pagina&cantidad?texto",
    controller: "ListadoProgramaCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarPrograma
    },
    data: {
      titulo: "Listado de Programa",
      icono: "fa-list",
      menu: "Listar Programa"
    }
  } );

  $stateProvider.state( "inicio.administracion.programa-uno", {
    templateUrl: "administracion/programa/vistas/formPrograma.html",
    url: "/programa/:id?editar",
    controller: "FormProgramaCtrl",
    controllerAs: "vm",
    resolve: {
      programa: obtenerPrograma
    },
    data: {
      titulo: "Form de Programa",
      icono: "fa-file-o",
      menu: "Form Programa"
    }
  } );

  listarPrograma.$inject = [ "ProgramaAPI", "$stateParams", "$auth", "$q" ];
  function listarPrograma( ProgramaAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.programa.listar ) {
      return ProgramaAPI.listar( $stateParams.pagina, $stateParams.cantidad, $stateParams.texto );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerPrograma.$inject = [ "ProgramaAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerPrograma( ProgramaAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "programa" ) ) {
      return ProgramaAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/controladores/redesCtrl.js":[function(require,module,exports){
"use strict";

module.exports = RedesCtrl;

var Red = require( "../modelos/red.js" );

RedesCtrl.$inject = [ "$scope", "MedioAPI", "NotaAPI", "Util", "RedesAPI", "Notificaciones" ];
function RedesCtrl( $scope, MedioAPI, NotaAPI, Util, RedesAPI, Notificaciones ) {
  var vm = this;
  vm.excelData = [];
  vm.guardar = guardar;
  vm.seleccionarArchivo = seleccionarArchivo;

  $scope.$watch( "vm.excelData", procesarExcel );

  function procesarExcel( val ) {
    if ( val.length ) {
      vm.tabla = [];
      vm.datosGuardados = false;
      vm.cargandoExcel = true;
      Red.formatearClaves( vm.excelData );
      var claves = Red.obtenerClaves( vm.excelData );

      return NotaAPI.getNotasCompletas( claves ).then( function( resp ) {
        if ( resp.status === 200 ) {
          vm.tabla = Red.generarTabla( vm.excelData, resp.data, vm.tipoMedio, Util );
        }
        vm.cargandoExcel = false;
      } );
    }
  }

  function guardar( data ) {
    var dataPreparada = Red.preguardar( data );
    RedesAPI.guardar( dataPreparada ).then( function( resp ) {
      vm.tabla = Red.agregarIds( data, resp.data );
      vm.datosGuardados = true;
      Notificaciones.agregar( resp.status, "Redes" );
    } ).catch( function( err ) {
      Notificaciones.agregar( err.status, "Redes" );
    } );
  }

  function seleccionarArchivo( tipoMedio ) {
    vm.tipoMedio = tipoMedio;
    $( "#excel" ).click();
  }
}

},{"../modelos/red.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/modelos/red.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/controladores/rest/redesAPI.js":[function(require,module,exports){
"use strict";

module.exports = RedesAPI;

RedesAPI.$inject = [ "urlApi", "$http" ];
function RedesAPI( urlApi, $http ) {
  RedesAPI.guardar = guardar;
  return RedesAPI;

  function guardar( data ) {
    return $http.post( urlApi + "/api/redesymedios/excel", {
      data: data
    }, function( resp ) {
      return resp;
    }, function( err ) {
      return err;
    } );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Redes", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "RedesCtrl", require( "./controladores/redesCtrl.js" ) );
modulo.factory( "RedesAPI", require( "./controladores/rest/redesAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/redesCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/controladores/redesCtrl.js","./controladores/rest/redesAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/controladores/rest/redesAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/modelos/red.js":[function(require,module,exports){
"use strict";

var Guion = require( "../../../monitoreo/modelos/guion.js" );
var Nota = require( "../../../monitoreo/modelos/nota.js" );

module.exports = {
  obtenerClaves: obtenerClaves,
  generarTabla: generarTabla,
  formatearClaves: formatearClaves,
  preguardar: preguardar,
  agregarIds: agregarIds
};

function obtenerClaves( lista ) {
  var arrayClaves = [];
  _.forEach( lista, function( row ) {
    arrayClaves = arrayClaves.concat( row["Keywords"] );
  } );
  return _.uniq( arrayClaves );
}

function formatearClaves( lista ) {
  return _.forEach( lista, function( row ) {
    var arrayClaves = row["Keywords"].split( "," );
    row["Keywords"] = _.map( arrayClaves, function( clave ) {
      return clave.replace( /^\s+|\s+$/g, "" ).toUpperCase();
    } );
  } );
}

function generarTabla( rowsNotas, clavesDB, tipoMedio, Util ) {
  moment.locale( "en" ); // las fechas en el excel vienen en inglés
  var tabla = _.map( rowsNotas, crearNotas( clavesDB, tipoMedio, Util ) );
  moment.locale( "es" );
  var gruposMedios = _.groupBy( tabla, "nombreMedio" );
  var guionesConNotas = _.map( gruposMedios, transformarEnGuion( tipoMedio ) );
  return _.flatten( guionesConNotas );
}

function transformarEnGuion( tipoMedio ) {
  return function( grupo, nombreGrupo ) {
    var gruposXFecha = _.groupBy( grupo, function( nota ) {
      return moment( nota.fecha ).format( "YYYY-MM-DD" );
    } );
    return _.map( gruposXFecha, function( gxf, fecha ) {
      var nuevoGuion = new Guion( moment( fecha, "YYYY-MM-DD" ), tipoMedio, null );
      nuevoGuion.notas = gxf;
      nuevoGuion.nombreMedio = nombreGrupo;
      return nuevoGuion;
    } );
  };
}

function crearNotas( clavesDB, tipoMedio, Util ) {
  return function( nota ) {
    var hora = moment( nota.Date, "DD-MMM-YYYY HH:mm" );
    var fecha = moment( nota.Date, "DD-MMM-YYYY HH:mm" );
    var partes = obtenerPartes( {
      entidades: clavesDB.entidades,
      personajes: clavesDB.personajes,
      etiquetasTematicas: clavesDB.temas
    }, nota );
    var nuevaNota = new Nota( hora, fecha, null, null, null, nota.Headline, [],
      _.uniq( partes.entidades, "_id" ), partes.personajes, partes.etiquetasTematicas,
      partes.etiquetas, null, false, null, null, null, null, [], null, null, nota.URL );
    nuevaNota.nombreMedio = nota["Source"];
    var sentimiento = nota["Sentiment"].toLowerCase();
    nuevaNota.sentimiento = sentimiento !== "neutral"? sentimiento.replace( /.$/, "a" ):sentimiento;
    _.forEach( pluckearNota( nuevaNota ), function( obj ) {
      var id = _.isObject( obj ) ? obj._id : obj;
      Nota.buscarClientes( id, clavesDB.clientes, nuevaNota, tipoMedio, Util );
    } );
    return nuevaNota;
  };
}

function pluckearNota( nota ) {
  return nota.entidades
  .concat( nota.personajes )
  .concat( nota.etiquetasTematicas );
}

function obtenerPartes( clavesDB, nota ) {
  var obj = {
    personajes: [],
    entidades: [],
    etiquetas: [],
    etiquetasTematicas: []
  };
  _.forEach( nota["Keywords"], function( palabraClave ) {
    var agregado = _.some( clavesDB, function( grupoClaves, keyGrupo ) {
      var claveEncontrada = _.find( grupoClaves, function( claveUno ) {
        return claveUno.nombre === palabraClave || claveUno.abreviatura === palabraClave;
      } );
      if ( claveEncontrada ) {
        return obj[keyGrupo].push( claveEncontrada );
      }
    } );
    if ( !agregado ) {
      obj.etiquetas.push( palabraClave );
    }
  } );
  return obj;
}

function preguardar( tabla ) {
  return _.map( angular.copy( tabla ), function( guion ) {
    guion.notas = _.map( guion.notas, function( nota ) {
      nota.agregarEntidades( nota.entidades );
      nota.agregarPersonajes( nota.personajes );
      nota.agregarClientes( nota.clientes );
      return nota;
    } );
    return guion;
  } );
}

function agregarIds( data, dataIds ) {
  return _.map( data, function( guion, indexGuion ) {
    guion._id = dataIds[indexGuion]._id;
    guion.notas = _.map( guion.notas, function( nota, indexNota ) {
      nota._id = dataIds[indexGuion].notas[indexNota]._id;
      return nota;
    } );
    return guion;
  } );
}

},{"../../../monitoreo/modelos/guion.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/modelos/guion.js","../../../monitoreo/modelos/nota.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/modelos/nota.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/redes/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.red", {
    templateUrl: "administracion/redes/vistas/inicio.html",
    url: "/red",
    controller: "RedesCtrl",
    controllerAs: "vm",
    data: {
      titulo: "Redes Sociales / Medios Digitales",
      icono: "fa-list"
    }
  } );

  listarRed.$inject = [ "RedAPI", "$stateParams", "$auth", "$q" ];
  function listarRed( RedAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.redes.crear ) {
      return RedAPI.listar( $stateParams.pagina, $stateParams.cantidad );
    }
    return $q.reject( {autenticado: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  //################################################################################################
  // #####   Rutas de administración   #############################################################
  //################################################################################################

  $stateProvider.state( "inicio.administracion", {
    templateUrl: "administracion/vistas/inicio.html",
    url: "/administracion",
    controller: "AdministracionCtrl",
    controllerAs: "mod",
    data: {
      titulo: "Módulo Administración",
      icono: "fa-cog",
      menu: "Administración"
    }
  } );

  //################################################################################################
  // #####   Rutas de administración de usuarios   #################################################
  //################################################################################################

  $stateProvider.state( "inicio.administracion.usuario-lista", {
    templateUrl: "administracion/vistas/listaUsuario.html",
    url: "/usuario?pagina&cantidad",
    controller: "ListadoUsuarioCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarUsuario
    },
    data: {
      titulo: "Listado de Usuarios",
      icono: "fa-list",
      menu: "Listar Usuarios"
    }
  } );

  $stateProvider.state( "inicio.administracion.usuario-uno", {
    templateUrl: "administracion/vistas/formUsuario.html",
    url: "/usuario/:id?editar",
    controller: "FormUsuarioCtrl",
    controllerAs: "vm",
    resolve: {
      usuario: obtenerUsuario
    },
    data: {
      titulo: "Form de Usuario",
      icono: "fa-file-o",
      menu: "Form Usuario"
    }
  } );

  listarUsuario.$inject = [ "UsuarioAPI", "$stateParams", "$auth", "$q" ];
  function listarUsuario( UsuarioAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.usuario.listar ) {
      return UsuarioAPI.listar( $stateParams.pagina, $stateParams.cantidad );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerUsuario.$inject = [ "UsuarioAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerUsuario( UsuarioAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "usuario" ) ) {
      return UsuarioAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

  //################################################################################################
  // #####   Rutas de administración de roles   ####################################################
  //################################################################################################

  $stateProvider.state( "inicio.administracion.rol-lista", {
    templateUrl: "administracion/vistas/listaRol.html",
    url: "/rol?pagina&cantidad",
    controller: "ListadoRolCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarRol
    },
    data: {
      titulo: "Listado de Roles",
      icono: "fa-list",
      menu: "Listar Rol"
    }
  } );

  $stateProvider.state( "inicio.administracion.rol-uno", {
    templateUrl: "administracion/vistas/formRol.html",
    url: "/rol/:id?editar",
    controller: "FormRolCtrl",
    controllerAs: "vm",
    resolve: {
      rol: obtenerRol
    },
    data: {
      titulo: "Form de Rol",
      icono: "fa-file-o",
      menu: "Form Rol"
    }
  } );

  listarRol.$inject = [ "RolAPI", "$stateParams", "$auth", "$q" ];
  function listarRol( RolAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.rol.listar ) {
      return RolAPI.listar( $stateParams.pagina, $stateParams.cantidad );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerRol.$inject = [ "RolAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerRol( RolAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "rol" ) ) {
      return RolAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

  /*
  ########################################################
    Rutas de administración para Contabilizar caracteres
  ########################################################
  */

  $stateProvider.state( "inicio.administracion.contar-caracteres", {
    templateUrl: "administracion/vistas/contabilizarCaracteres.html",
    url:"/contarcaracteres",
    controller: "contabilizarCaracteresCtrl",
    controllerAs: "vm",
    data: {
      titulo: "Contabilizar caracteres",
      icono: "fa-list",
      menu: "contabilizar caracteres"
    }
  } );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/controladores/formSeccionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormSeccionCtrl;

FormSeccionCtrl.$inject = [ "seccion", "SeccionAPI", "MedioAPI", "$state", "$stateParams" ];
function FormSeccionCtrl( seccion, SeccionAPI, MedioAPI, $state, $stateParams ) {
  var vm = this;
  vm.seccion = seccion;
  vm.seccion.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;
  vm.cargarMedio = cargarMedio;

  if ( vm.seccion.idMedio ) {
    cargarMedioUsado();
  }

  function cargarMedioUsado() {
    MedioAPI.obtener( vm.seccion.idMedio ).then( function( resp ) {
      vm.seccion.medio = resp;
    } );
  }

  function guardar( formValido ) {
    if ( formValido ) {
      vm.seccion.idMedio = vm.seccion.medio._id;
      SeccionAPI.guardar( vm.seccion ).then( function( resp ) {
        reload( resp._id, false );
      } );
    }
  }

  function editar( valor ) {
    reload( vm.seccion._id, valor );
  }

  function eliminar() {
    SeccionAPI.eliminar( vm.seccion ).then( function() {
      $state.go( "^.seccion-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }

  function cargarMedio( texto ) {
    return MedioAPI.listarSinBarra( 0, 10, texto, [ "Prensa" ] )
      .then( function( response ) {
        return response.docs;
      } );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/controladores/listadoSeccionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoSeccionCtrl;

ListadoSeccionCtrl.$inject = [ "listado", "SeccionAPI", "$state", "$stateParams" ];
function ListadoSeccionCtrl( listado, SeccionAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.texto = $stateParams.texto;
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;
  vm.filtrarListado = filtrarListado;

  function eliminar( seccion ) {
    if ( confirm( "¿Está seguro que desea eliminar el Seccion?" ) ) {
      SeccionAPI.eliminar( seccion._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === seccion._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function filtrarListado() {
    SeccionAPI.listarSinBarra( $stateParams.pagina, $stateParams.cantidad, vm.texto )
      .then( function( response ) {
        vm.listado.docs = response.docs;
        vm.listado.contador = response.contador;
      } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad, texto: vm.texto}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/controladores/rest/seccionAPI.js":[function(require,module,exports){
"use strict";

module.exports = SeccionAPI;

var Seccion = require( "../../modelos/seccion.js" );

SeccionAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function SeccionAPI( urlApi, $http, Notificaciones ) {
  SeccionAPI.obtener = obtener;
  SeccionAPI.listar = listar;
  SeccionAPI.listarSinBarra = listarSinBarra;
  SeccionAPI.guardar = guardar;
  SeccionAPI.eliminar = eliminar;
  SeccionAPI.obtenerSeccionesMedio = obtenerSeccionesMedioCurried( true );
  SeccionAPI.obtenerSeccionesMedioSinBarra = obtenerSeccionesMedioCurried( false );
  SeccionAPI.getBulk = getBulk;
  return SeccionAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/seccion/" + id ).then( function( resp ) {
        return Seccion.cargar( resp.data );
      } );
    } else {
      return new Seccion();
    }
  }

  function obtenerSeccionesMedioCurried( loadingBar ) {
    return function( id ) {
      var params = {
        params: { id: id },
        ignoreLoadingBar: !loadingBar
      };
      return $http.get( urlApi + "/api/seccion/medio", params ).then( ok, err );
    };
  }

  function getBulk( ids ) {
    return $http.post( urlApi + "/api/seccion/secciones", ids ).then( function( resp ) {
      return resp.data;
    } );
  }

  function listar( pagina, cantidad, texto ) {
    return listarCurried( false )( pagina, cantidad, texto );
  }

  function listarSinBarra( pagina, cantidad, texto ) {
    return listarCurried( true )( pagina, cantidad, texto );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/seccion/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Seccion.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Seccion" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/seccion/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Seccion" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Seccion" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/seccion/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Seccion" );
      return Seccion.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Seccion" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/seccion/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Seccion" );
      return Seccion.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Seccion" );
      return resp;
    } );
  }
}

},{"../../modelos/seccion.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/modelos/seccion.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Seccion", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoSeccionCtrl", require( "./controladores/listadoSeccionCtrl.js" ) );
modulo.controller( "FormSeccionCtrl", require( "./controladores/formSeccionCtrl.js" ) );

modulo.factory( "SeccionAPI", require( "./controladores/rest/seccionAPI.js" ) );

module.exports = modulo;

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formSeccionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/controladores/formSeccionCtrl.js","./controladores/listadoSeccionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/controladores/listadoSeccionCtrl.js","./controladores/rest/seccionAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/controladores/rest/seccionAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/modelos/seccion.js":[function(require,module,exports){
"use strict";

module.exports = Seccion;

function Seccion( nombre, idMedio, publicity, _id ) {
  this.nombre = nombre;
  this.idMedio = idMedio;
  this.publicity = publicity;
  this._id = _id;
}

Seccion.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Seccion( json.nombre, json.idMedio, json.publicity, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/seccion/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.seccion-lista", {
    templateUrl: "administracion/seccion/vistas/listaSeccion.html",
    url: "/seccion?pagina&cantidad?texto",
    controller: "ListadoSeccionCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarSeccion
    },
    data: {
      titulo: "Listado de Seccion",
      icono: "fa-list",
      menu: "Listar Seccion"
    }
  } );

  $stateProvider.state( "inicio.administracion.seccion-uno", {
    templateUrl: "administracion/seccion/vistas/formSeccion.html",
    url: "/seccion/:id?editar",
    controller: "FormSeccionCtrl",
    controllerAs: "vm",
    resolve: {
      seccion: obtenerSeccion
    },
    data: {
      titulo: "Form de Seccion",
      icono: "fa-file-o",
      menu: "Form Seccion"
    }
  } );

  listarSeccion.$inject = [ "SeccionAPI", "$stateParams", "$auth", "$q" ];
  function listarSeccion( SeccionAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.seccion.listar ) {
      return SeccionAPI.listar( $stateParams.pagina, $stateParams.cantidad, $stateParams.texto );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerSeccion.$inject = [ "SeccionAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerSeccion( SeccionAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "seccion" ) ) {
      return SeccionAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/controladores/formTemaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormTemaCtrl;

FormTemaCtrl.$inject = [ "tema", "TemaAPI", "$state", "$stateParams" ];
function FormTemaCtrl( tema, TemaAPI, $state, $stateParams ) {
  var vm = this;
  vm.tema = tema;
  vm.tema.editando = ( $stateParams.editar === "true" );
  vm.guardar = guardar;
  vm.editar = editar;
  vm.eliminar = eliminar;

  function guardar( formValido ) {
    if ( formValido ) {
      TemaAPI.guardar( vm.tema ).then( function( resp ) {
        reload( resp._id, false );
      } );
    }
  }

  function editar( valor ) {
    reload( vm.tema._id, valor );
  }

  function eliminar() {
    TemaAPI.eliminar( vm.tema ).then( function() {
      $state.go( "^.tema-lista" );
    } );
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/controladores/listadoTemaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoTemaCtrl;

ListadoTemaCtrl.$inject = [ "listado", "TemaAPI", "$state", "$stateParams" ];
function ListadoTemaCtrl( listado, TemaAPI, $state, $stateParams ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.listado = listado;
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;

  function eliminar( tema ) {
    if ( confirm( "¿Está seguro que desea eliminar el Tema?" ) ) {
      TemaAPI.eliminar( tema._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === tema._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad}, {reload: false} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/controladores/rest/temaAPI.js":[function(require,module,exports){
"use strict";

module.exports = TemaAPI;

var Tema = require( "../../modelos/tema.js" );

TemaAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function TemaAPI( urlApi, $http, Notificaciones ) {
  TemaAPI.obtener = obtener;
  TemaAPI.listar = listar;
  TemaAPI.listarSinBarra = listarSinBarra;
  TemaAPI.guardar = guardar;
  TemaAPI.eliminar = eliminar;
  return TemaAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/tema/" + id ).then( function( resp ) {
        return Tema.cargar( resp.data );
      } );
    } else {
      return new Tema();
    }
  }

  function listar( pagina, cantidad, texto ) {
    return listarCurried( false )( pagina, cantidad, texto );
  }

  function listarSinBarra( pagina, cantidad, texto ) {
    return listarCurried( true )( pagina, cantidad, texto );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/tema/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Tema.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Tema" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/tema/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Tema" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Tema" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/tema/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Tema" );
      return Tema.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Tema" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/tema/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Tema" );
      return Tema.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Tema" );
      return resp;
    } );
  }
}

},{"../../modelos/tema.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/modelos/tema.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../../package.json" ).name;

var modulo = angular.module( nombre + ".Tema", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListadoTemaCtrl", require( "./controladores/listadoTemaCtrl.js" ) );
modulo.controller( "FormTemaCtrl", require( "./controladores/formTemaCtrl.js" ) );

modulo.factory( "TemaAPI", require( "./controladores/rest/temaAPI.js" ) );

module.exports = modulo;
},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formTemaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/controladores/formTemaCtrl.js","./controladores/listadoTemaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/controladores/listadoTemaCtrl.js","./controladores/rest/temaAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/controladores/rest/temaAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/modelos/tema.js":[function(require,module,exports){
"use strict";

module.exports = Tema;

function Tema( nombre, _id ) {
  this.nombre = nombre;
  this._id = _id;
}

Tema.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Tema( json.nombre, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/administracion/tema/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.administracion.tema-lista", {
    templateUrl: "administracion/tema/vistas/listaTema.html",
    url: "/tema?pagina&cantidad",
    controller: "ListadoTemaCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarTema
    },
    data: {
      titulo: "Listado de Tema para calificar",
      icono: "fa-list",
      menu: "Listar Tema para calificar"
    }
  } );

  $stateProvider.state( "inicio.administracion.tema-uno", {
    templateUrl: "administracion/tema/vistas/formTema.html",
    url: "/tema/:id?editar",
    controller: "FormTemaCtrl",
    controllerAs: "vm",
    resolve: {
      tema: obtenerTema
    },
    data: {
      titulo: "Form de Tema para calificar",
      icono: "fa-file-o",
      menu: "Form Tema para calificar"
    }
  } );

  listarTema.$inject = [ "TemaAPI", "$stateParams", "$auth", "$q" ];
  function listarTema( TemaAPI, $stateParams, $auth, $q ) {
    if ( $auth.getPayload().permisos.tema.listar ) {
      return TemaAPI.listar( $stateParams.pagina, $stateParams.cantidad );
    }
    return $q.reject( {autenticado: false} );
  }

  obtenerTema.$inject = [ "TemaAPI", "$stateParams", "Validaciones", "$q" ];
  function obtenerTema( TemaAPI, $stateParams, Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "tema" ) ) {
      return TemaAPI.obtener( $stateParams.id, $stateParams.editar );
    }
    return $q.reject( {autenticado: false} );
  }


}
},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/archivo/controladores/rest/archivoAPI.js":[function(require,module,exports){
"use strict";

module.exports = ArchivoAPI;

var Archivo = require( "../../modelos/archivo.js" );

ArchivoAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function ArchivoAPI( urlApi, $http, Notificaciones ) {
  ArchivoAPI.obtener = obtener;
  ArchivoAPI.obtenerSinBarra = obtenerSinBarra;
  ArchivoAPI.listar = listar;
  ArchivoAPI.listarSinBarra = listarSinBarra;
  ArchivoAPI.guardar = guardar;
  ArchivoAPI.eliminar = eliminar;
  return ArchivoAPI;

  function obtener( id ) {
    return obtenerCurried( false )( id );
  }

  function obtenerSinBarra( id ) {
    return obtenerCurried( true )( id );
  }

  function obtenerCurried( loadingBar ) {
    return function( id ) {
      if ( id ) {
        return $http.get( urlApi + "/api/archivo/" + id, { ignoreLoadingBar: loadingBar } )
          .then( function( resp ) {
            return Archivo.cargar( resp.data );
          }
        );
      } else {
        return new Archivo();
      }
    };
  }

  function listar( pagina, cantidad, texto ) {
    return listarCurried( false )( pagina, cantidad, texto );
  }

  function listarSinBarra( pagina, cantidad, texto ) {
    return listarCurried( true )( pagina, cantidad, texto );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto
        },
        ignoreLoadingBar: loadingBar
      };
      return $http.get( urlApi + "/api/archivo/", params ).then( ok, err );
    };
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Archivo.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Archivo" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/archivo/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Archivo" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Archivo" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/archivo/", obj, { ignoreLoadingBar: true } ).then(
      function( resp ) {
        Notificaciones.agregar( resp.status, "Archivo" );
        return Archivo.cargar( resp.data );
      },
      function( resp ) {
        Notificaciones.agregar( resp.status, "Archivo" );
        return resp;
      }
    );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/archivo/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Archivo" );
      return Archivo.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Archivo" );
      return resp;
    } );
  }
}

},{"../../modelos/archivo.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/archivo/modelos/archivo.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/archivo/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../package.json" ).name;

var modulo = angular.module( nombre + ".Archivo", [] );
modulo.config( require( "./rutas" ) );

modulo.factory( "ArchivoAPI", require( "./controladores/rest/archivoAPI.js" ) );

module.exports = modulo;

},{"../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/rest/archivoAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/archivo/controladores/rest/archivoAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/archivo/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/archivo/modelos/archivo.js":[function(require,module,exports){
"use strict";

module.exports = Archivo;

function Archivo( nombre, mymeType, tamaño, awsS3Key, S3url, _id ) {
  this.nombre = nombre;
  this.mymeType = mymeType;
  this.tamaño = tamaño;
  this.awsS3Key = awsS3Key;
  this.S3url = S3url;
  this._id = _id;
}

Archivo.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Archivo( json.nombre, json.mymeType, json.tamaño, json.awsS3Key, json.S3url,
    json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/archivo/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ ];
function rutas(  ) {
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/btnVolver.js":[function(require,module,exports){
"use strict";
module.exports = btnVolver;

function btnVolver() {
  return {
    restric: "EA",
    link: link
  };
}

function link( scope, elem ) {
  elem.on( "click", function() {
    window.history.back();
  } );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisEnter.js":[function(require,module,exports){
"use strict";

module.exports = cisEnter;

function cisEnter() {
  return function( scope, element, attrs ) {
    element.bind( "keydown keypress", function( event ) {
      if ( event.which === 13 ) {
        scope.$apply( function() {
          scope.$eval( attrs.cisEnter );
        } );

        //event.preventDefault();
      }
    } );
  };
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisExcel.js":[function(require,module,exports){
"use strict";
module.exports = cisExcel;
function cisExcel( ) {
  return {
    restrict: "E",
    require: "ngModel",
    scope: {
      loading: "@"
    },
    link: link,
    templateUrl: "base/vistas/cisExcel.html"
  };
}

function link( scope, element, attrs, ngModelCtrl ) {
  element.bind( "change", function( ) {
    scope.$apply( function() {
      var filename = event.target.files[0].name;
      var ext = filename.split( "." ).pop();
      if ( ext !== "xls" ) {
        alert( "Los archivos con extensión ." + ext + " no son soportados." +
        "\nUtilice únicamente archivos con extensión .xls" );
      } else {
        var files = event.target.files, file;
        if ( !files || files.length === 0 ) {
          return;
        }
        file = files[0];
        var self = {};
        self.model = ngModelCtrl;
        scope.loading = true;
        var fileReader = new FileReader();

        fileReader.onload = function( ) {
          self.filename = file.name;
          self.oFile = XLS.read( event.target.result, {type: "binary"} );
          var sheetName = _.keys( self.oFile.Sheets )[0];
          self.data = self.oFile.Sheets[ sheetName ];
          scope.loading = false;
          var object_array = XLS.utils.sheet_to_row_object_array( self.data );
          self.model.$setViewValue( object_array );
        };

        fileReader.readAsBinaryString( file );

      }
    }, false );
  } ) ;
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisInputNumerico.js":[function(require,module,exports){
"use strict";
module.exports = cisInputNumerico;
cisInputNumerico.$inject = [ "$filter" ];
function cisInputNumerico( $filter ) {
  return {
    require: "ngModel",
    restrict: "E",
    link: link( $filter )
  };
}

function link( $filter ) {
  return function( scope, element, attrs, ngModelCtrl ) {
    if ( attrs.type === "numerico" ) {
      ngModelCtrl.$parsers.push( function( val ) {
        var clean = val.replace( /[^0-9,\,]+/g, "" );
        if ( val !== clean ) {
          ngModelCtrl.$setViewValue( clean );
          ngModelCtrl.$render();
        }
        if ( clean === "" ) {
          clean = "0";
        }
        return parseFloat( clean.replace( ",", "." ) );
      } );
      ngModelCtrl.$formatters.push( function( val ) {
        var cantDecimales = String( val ).split( "." )[1];
        var decimales = 0;
        if ( cantDecimales ) {
          decimales = cantDecimales.length;
        }
        return $filter( "Numero" )( val, decimales );
      } );

      element.bind( "keypress", function( event ) {
        if ( event.keyCode === 32 ) {
          event.preventDefault();
        }
      } );
    }
    return;
  };
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisMinimizar.js":[function(require,module,exports){
"use strict";

module.exports = cisMinimizar;

function cisMinimizar() {
  return {
    restrict: "A",
    scope: true,
    link: function( $scope, $element ) {
      if ( $( window ).width() < 768 ) {
        oscurecer();
        estilos();
      }
      $element.on( "click", minimizar );
      function minimizar() {
        oscurecer();
        estilos();
      }
    }
  };
}

function estilos() {
  $( "#wrapper" ).toggleClass( "minimizado" );
  $( "#logo" ).toggleClass( "ocultarLogo" );
  if ( $( "#wrapper" ).hasClass( "minimizado" ) ) {
    $( "#iconoMinimizador" ).removeClass( "fa-chevron-left" );
    $( "#iconoMinimizador" ).addClass( "fa-chevron-right" );
  } else {
    $( "#iconoMinimizador" ).removeClass( "fa-chevron-right" );
    $( "#iconoMinimizador" ).addClass( "fa-chevron-left" );
  }
}

function oscurecer() {
  if ( $( window ).width() < 768 ) {
    if ( $( "#wrapper" ).hasClass( "minimizado" ) ) {
      $( "#oscurecer" ).removeClass( "hidden" );
    } else {
      $( "#oscurecer" ).addClass( "hidden" );
    }
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisSwitch.js":[function(require,module,exports){
"use strict";

module.exports = cosSwitch;

function cosSwitch() {
  return {
    restrict: "EA",
    replace: true,
    templateUrl: "base/vistas/cisSwitch.html",
    require: "ngModel",
    scope: true,
    link: link
  };
}

function link( $scope, $elem, $attr, ngModelCtrl ) {
  $scope.id = uuid();
  $scope.tipo = $attr.tipo || null;
  $scope.valor = false;
  $scope.apply = apply;

  $scope.$watch( function() {
    return $scope.$eval( $attr.ngDisabled );
  }, function( val ) {
    if ( val ) {
      $elem.addClass( "deshabilitado" );
    } else {
      $elem.removeClass( "deshabilitado" );
    }
  } );

  $scope.$watch( function() {
    return ngModelCtrl.$modelValue;
  }, function( val ) {
    if ( val ) {
      $scope.valor = ngModelCtrl.$modelValue;
    } else {
      ngModelCtrl.$setViewValue( $scope.valor );
    }
  } );

  function apply( val ) {
    ngModelCtrl.$setViewValue( val );
  }

}

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace( /[xy]/g, function( c ) {
    var r = Math.random() * 16 | 0,
      v = ( c === "x" ? r : ( r & 0x3 | 0x8 ) );
    return v.toString( 16 );
  } );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisTitulo.js":[function(require,module,exports){
"use strict";

module.exports = titulo;
var nombre = require( "../../../../package.json" ).nombreNatural;

titulo.$inject = [ "$rootScope", "$timeout" ];
function titulo( $rootScope, $timeout ) {
  return {
    restrict: "EA",
    scope: true,
    link: link
  };

  function link( scope, element ) {
    $rootScope.$on( "$stateChangeStart", cambio );

    function cambio( event, toState ) {
      var titulo = titular( toState );
      $timeout( function() {
        element.text( titulo );
      } );
    }

    function titular( toState ) {
      if ( toState.data && toState.data.titulo ) {
        return toState.data.titulo + " | " + nombre;
      }
      return nombre;
    }
  }

}

},{"../../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisUpload.js":[function(require,module,exports){
"use strict";

module.exports = cisUpload;

cisUpload.$inject = [ "urlApi", "$auth", "Upload", "Notificaciones" ];
function cisUpload( urlApi, $auth, Upload, Notificaciones ) {
  return {
    restrict: "EA",
    replace: true,
    templateUrl: "base/vistas/cisUpload.html",
    require: "ngModel",
    scope: true,
    link: link
  };

  function link( $scope, $elem, $attr, ngModelCtrl ) {
    $scope.id = uuid();
    $scope.estados = {
      seleccion: "seleccion",
      previa: "previa",
      subiendo: "subiendo",
      exito: "exito"
    };

    $scope.acepta = $attr.acepta || "";
    $scope.small = $attr.small || false;
    $scope.subirArchivo = subirArchivo;
    $scope.cancelarSubida = cancelarSubida;
    $scope.estado = $scope.estados.seleccion;
    $scope.borrarSeleccion = borrarSeleccion;
    $scope.archivoSeleccionado = archivoSeleccionado;

    function archivoSeleccionado( file ) {
      $scope.estado = $scope.estados.previa;
      $scope.cisArchivo = file;
    }

    $scope.$watch( function() {
      return $scope.$eval( $attr.ngDisabled );
    }, function( val ) {
      if ( val ) {
        $elem.addClass( "deshabilitado" );
      } else {
        $elem.removeClass( "deshabilitado" );
      }
    } );

    function borrarSeleccion() {
      delete $scope.cisArchivo;
      $scope.estado = $scope.estados.seleccion;
    }

    function subirArchivo() {
      $scope.estado = $scope.estados.subiendo;
      $scope.uploaded = 0;
      $scope.upload = Upload.upload(
        {
          url: urlApi + "/api/archivo",
          data: { archivo: $scope.cisArchivo },
          headers: { "Authorization": "Bearer " + $auth.getToken() },
          ignoreLoadingBar: true
        }
      );
      $scope.upload.then( OKupload, ERRupload, EVTupload );

      //Upload.mediaDuration($scope.cisArchivo).then( function(sec) {
      //  duracion = sec;
      //});
    }

    function cancelarSubida() {
      $scope.upload.abort();
      borrarSeleccion();
    }

    function OKupload( result ) {
      $scope.estado = $scope.estados.exito;
      var retorno = {
        resultado: result.data
      };

      if ( $scope.cisArchivo.type.match( "(video|audio)/\*" ) ) {
        Upload.mediaDuration( $scope.cisArchivo ).then( function( sec ) {
          retorno.duracion = sec;
          ngModelCtrl.$setViewValue( retorno );
        } );
      } else {
        ngModelCtrl.$setViewValue( retorno );
      }
    }

    function ERRupload( err ) {
      Notificaciones.agregar( err.status );
    }

    function EVTupload( evt ) {
      $scope.uploaded = evt.loaded;
    }

  }
}

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace( /[xy]/g, function( c ) {
    var r = Math.random() * 16 | 0,
      v = ( c === "x" ? r : ( r & 0x3 | 0x8 ) );
    return v.toString( 16 );
  } );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/clickEn.js":[function(require,module,exports){
"use strict";
module.exports = clickEn;

function clickEn() {
  return {
    restrict: "A",
    link: link
  };
}

function link( $scope, $elem, attr ) {
  $elem.on( "click", function() {
    $( "#" + attr.clickEn ).click();
  } );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/ocultarAccion.js":[function(require,module,exports){
"use strict";
module.exports = ocultarAccion;
ocultarAccion.$inject = [ "$auth" ];

function ocultarAccion( $auth ) {
  return {
    restrict: "EA",
    require: "?ngModel",
    scope: true,
    link: link( $auth )
  };
}

function link( $auth ) {
  return function( scope, element, attrs ) {
    scope.permiso = attrs.permiso;
    scope.accion = attrs.accion;
    try {
      if ( !$auth.getPayload().permisos[scope.permiso][scope.accion] ) {
        element.hide();
      }
    }
    catch ( err ) {
      element.hide();
    }
  };
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/filtros.js":[function(require,module,exports){
"use strict";

exports.fecha = fecha;
exports.duracion = duracion;
exports.porcentaje = porcentaje;
exports.bool = bool;
exports.trustAsResourceUrl = trustAsResourceUrl;
exports.numero = numero;

function duracion() {
  return function( segundos ) {
    var secs = parseInt( segundos );
    if ( !_.isNaN( secs ) ) {
      return new Date( secs * 1000 ).toISOString().substr( 11, 8 );
    }
  };
}

function fecha() {
  var formatoFecha = "YYYY-MM-DDTHH:mm:ss.sssZ";
  return filtro;

  function filtro( date, formatoDespliegue ) {
    if ( unNull( date ) ) {
      return "No Definido";
    }
    var formateado = formatear( date, formatoDespliegue, formatoFecha );
    if ( formateado ) {
      return formateado;
    }
    return "Fecha Inválida";
  }

  function formatear( date, formatoDespliegue, formatoFecha ) {
    var instancia = instanciar( date, formatoDespliegue );
    if ( validarFormatoString( date ) ) {
      return instancia( formatoFecha );
    }
    if ( date._isAMomentObject ) {
      return instancia( );
    }
  }

  function instanciar( date, formatoDespliegue ) {
    return function( formato ) {
      if ( formato ) {
        return moment( date, formatoFecha ).format( formatoDespliegue );
      } else {
        return moment( date ).format( formatoDespliegue );
      }
    };
  }

  function unNull( obj ) {
    return _.isUndefined( obj ) || _.isNull( obj );
  }

  function validarFormatoString( string ) {
    var regex = /^\d{4}-[0-1]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d{3}(Z)?(-[0-2]\d:[0-5]\d)?$/;
    return _.isString( string ) && regex.test( string );
  }
}

trustAsResourceUrl.$inject = [ "$sce" ];

function trustAsResourceUrl( $sce ) {
  return function( val ) {
    return $sce.trustAsResourceUrl( val );
  };
}

porcentaje.$inject = [ "$filter" ];

function porcentaje( $filter ) {
  return filtro;

  function filtro( num, decimales ) {
    if ( isNumber( num ) ) {
      return $filter( "number" )( num * 100, decimales || 2 ) + "%";
    }
    return "No Definido";
  }

  function isNumber( n ) {
    return !isNaN( parseFloat( n ) ) && isFinite( n );
  }
} //function

function bool() {
  return filtro;

  function filtro( bool, positivo, negativo ) {
    if ( bool ) {
      return positivo;
    } else {
      return negativo;
    } // if..else
  } //function

} //function

function numero( ) {
  return function( num, decimales ) {
    return accounting.formatMoney( num || 0, "", decimales, " ", "," );
  };
} //function

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/index.js":[function(require,module,exports){
"use strict";

var angular = window.angular;

var modulo = angular.module( "ProyectoBase.base", [] );

modulo.config( require( "./rutas" ) );

//modulo.config( require( "./configuracion.js" ) );

modulo.controller( "NavegacionCtrl", require( "./servicios/navegacionCtrl.js" ) );

modulo.factory( "Notificaciones", require( "./servicios/notificaciones" ) );
modulo.factory( "Futuros", require( "./servicios/futuros" ) );
modulo.factory( "Validaciones", require( "./servicios/validaciones.js" ) );
modulo.factory( "Cache", require( "./servicios/cacheClaves.js" ) );
modulo.factory( "Util", require( "./servicios/util.js" ) );
modulo.factory( "contarCaracteres",
require( "./servicios/contabilizarCaracteresServicio.js" ) );

modulo.directive( "clickEn", require( "./directivas/clickEn.js" ) );
modulo.directive( "cisSwitch", require( "./directivas/cisSwitch.js" ) );
modulo.directive( "cisTitulo", require( "./directivas/cisTitulo.js" ) );
modulo.directive( "cisMinimizar", require( "./directivas/cisMinimizar.js" ) );
modulo.directive( "numerico", require( "./directivas/cisInputNumerico.js" ) );
modulo.directive( "cisEnter", require( "./directivas/cisEnter.js" ) );
modulo.directive( "cisUpload", require( "./directivas/cisUpload.js" ) );
modulo.directive( "ocultarAccion", require( "./directivas/ocultarAccion.js" ) );
modulo.directive( "btnVolver", require( "./directivas/btnVolver.js" ) );
modulo.directive( "cisExcel", require( "./directivas/cisExcel.js" ) );

var filtros = require( "./filtros" );
modulo.filter( "Duracion", filtros.duracion );
modulo.filter( "Fecha", filtros.fecha );
modulo.filter( "Porcentaje", filtros.porcentaje );
modulo.filter( "Booleano", filtros.bool );
modulo.filter( "TrustAsResourceUrl", filtros.trustAsResourceUrl );
modulo.filter( "Numero", filtros.numero );

module.exports = modulo;

},{"./directivas/btnVolver.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/btnVolver.js","./directivas/cisEnter.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisEnter.js","./directivas/cisExcel.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisExcel.js","./directivas/cisInputNumerico.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisInputNumerico.js","./directivas/cisMinimizar.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisMinimizar.js","./directivas/cisSwitch.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisSwitch.js","./directivas/cisTitulo.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisTitulo.js","./directivas/cisUpload.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/cisUpload.js","./directivas/clickEn.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/clickEn.js","./directivas/ocultarAccion.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/directivas/ocultarAccion.js","./filtros":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/filtros.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/rutas.js","./servicios/cacheClaves.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/cacheClaves.js","./servicios/contabilizarCaracteresServicio.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/contabilizarCaracteresServicio.js","./servicios/futuros":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/futuros.js","./servicios/navegacionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/navegacionCtrl.js","./servicios/notificaciones":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/notificaciones.js","./servicios/util.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/util.js","./servicios/validaciones.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/validaciones.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;
rutas.$inject = [ "$stateProvider", "$urlRouterProvider" ];

function rutas( $stateProvider, $urlRouterProvider ) {

  $stateProvider.state( "inicio", {
    templateUrl: "base/vistas/plantilla.html",
    abstract: true
  } );

  $stateProvider.state( "404", {
    url: "/404",
    templateUrl: "base/vistas/404.html",
    libre: true,
    data: {
      titulo: "Página no encontrada"
    }
  } );

  $stateProvider.state( "403", {
    url: "/403",
    templateUrl: "base/vistas/403.html",
    libre: true,
    data: {
      titulo: "Acceso denegado"
    }
  } );

  $urlRouterProvider.otherwise( "/" );
} //rutas

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/selectorItems.js":[function(require,module,exports){
"use strict";

module.exports = {
  excluir: excluir,
  cambiarInclusion: cambiarInclusion,
  todoSeleccionado: todoSeleccionado,
  getIdsExcluidos: getIdsExcluidos
};

function excluir( nota, excluidas, listado, pagina ) {
  if ( !excluidas[pagina] ) {
    excluidas[pagina] = {};
  }
  excluidas[pagina][ nota._id ] = nota.incluir;
  return todoSeleccionado( listado );
}

function todoSeleccionado( listado ) {
  return _.every( listado, "incluir" );
}

function cambiarInclusion( estado, listado, excluidas, pagina ) {
  _.forEach( listado, function( doc ) {
    doc.incluir = estado;
    if ( !excluidas[pagina] ) {
      excluidas[pagina] = {};
    }
    excluidas[pagina][doc._id] = estado;
  } );
}

function getIdsExcluidos( excluidos ) {
  var llaves = _.map( excluidos, function( pag ) {
    var falsies = _.pick( pag, function( v ) {
      return !v;
    } );
    return _.keys( falsies );
  } );
  return _.flatten( llaves );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/cacheClaves.js":[function(require,module,exports){
"use strict";

module.exports = Cache;

Cache.$inject = [];
function Cache() {
  var clientesMap = {};
  var entidadesMap = {};
  var personajesMap = {};

  Cache.setClientes = setObjeto( clientesMap );
  Cache.setEntidades = setObjeto( entidadesMap );
  Cache.setPersonajes = setObjeto( personajesMap );
  Cache.listaClientes = getLista( clientesMap );
  Cache.listaEntidades = getLista( entidadesMap );
  Cache.listaPersonajes = getLista( personajesMap );
  Cache.clientes = clientesMap;
  Cache.entidades = entidadesMap;
  Cache.personajes = personajesMap;
  return Cache;

  function setObjeto( mapa ) {
    return function( lista ) {
      _.forEach( lista, function( objeto ) {
        if ( objeto._id ) {
          mapa[ objeto._id ] = objeto;
        }
      } );
    };
  }

  function getLista( mapa ) {
    return function() { return angular.copy( _.values( mapa ) ); };
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/contabilizarCaracteresServicio.js":[function(require,module,exports){
"use strict";

module.exports = contabilizarCaracteresServicio;

contabilizarCaracteresServicio.$inject = [];
function contabilizarCaracteresServicio( ) {
  var cont = this;
  cont.contarCaracteresBrutos = contarCaracteresBrutos;
  cont.contarCaracteres = contarCaracteres;
  cont.caracteresSinEspacios = caracteresSinEspacios;

  function contarCaracteresBrutos( texto ) {
    return _.size( texto );
  }

  function contarCaracteres( texto ) {
    return contarCaracteresValidos(
       texto, eliminarEspaciosRepetidos );
  }
  function caracteresSinEspacios( texto ) {
    return contarCaracteresValidos(
       texto, eliminarEspacios );
  }

  function eliminarEspaciosRepetidos( hilera ) {
    return hilera.replace( /\s+/g, " " );
  }

  function eliminarEspacios( hilera ) {
    return hilera.split( " " ).join( "" );
  }

  function eliminarSaltosDeLinea( hilera ) {
    return hilera.replace( /(\r\n|\n|\r)/gm, "" );
  }

  function contarRepetidos( hilera ) {
    var charAt;
    var charCount = 1;
    var total = 0;
    _.forEach( hilera, function( char ) {
        if ( charAt === char ) {
          charCount += 1;
          if ( charCount >= 3 ) {
            total += 1;
          }
        } else {
          charCount = 1;
        }
        charAt = char;
      } );
    return total;
  }

  function contarCaracteresValidos( hilera, contadorEspacios ) {
    var hileraFinal  = angular.copy( hilera );
    hileraFinal = _.trim( hileraFinal );
    hileraFinal = eliminarSaltosDeLinea( hileraFinal );
    hileraFinal = contadorEspacios( hileraFinal );
    return _.size( hileraFinal ) - contarRepetidos( hileraFinal );
  }

  return cont;
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/futuros.js":[function(require,module,exports){
"use strict";

module.exports = futuros;

function futuros( $q, $timeout ) {
  futuros.aFuturo = aFuturo;
  futuros.aRechazo = aRechazo;
  return futuros;

  function aFuturo( valor, timeout ) {
    return promesa( "resolve", valor, timeout );
  } //function

  function aRechazo( valor, timeout ) {
    return promesa( "reject", valor, timeout );
  } //function

  function promesa( tipo, valor, timeout ) {
    try {
      var futuro = $q.defer();
      $timeout( function() {
        futuro[tipo]( valor );
      }, ( _.isUndefined( timeout ) ) ? 0 : timeout );
      return futuro.promise;
    } catch ( ex ) {
      return ex;
    } //catch
  } //function

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/navegacionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = NavegacionCtrl;

NavegacionCtrl.$inject = [ "$state", "$localStorage", "Notificaciones", "$auth",
 "$sessionStorage" ];
function NavegacionCtrl( $state, $localStorage, Notificaciones, $auth, $sessionStorage ) {
  var nav = this;
  nav.salir = salir;
  nav.hoy = moment();
  nav.titulo = titulo;
  nav.icono = icono;
  nav.usuario = $sessionStorage.usuario;
  nav.estados = filtrarEstadosNoDeseados( $state.get() );

  function salir() {
    $auth.logout()
      .then( function() {
        delete $sessionStorage.usuario;
        delete $localStorage.usuario;
        Notificaciones.agregarPersonalizado( 200, "Desconectado con exito" );
        $state.go( "login" );
      } );
  }

  function titulo() {
    if ( $state.current.data && $state.current.data.titulo ) {
      return $state.current.data.titulo;
    } else {
      return "Cargando";
    }
  }

  function icono() {
    if ( $state.current.data && $state.current.data.icono ) {
      return $state.current.data.icono;
    } else {
      return "fa-home";
    }
  }

  function filtrarEstadosNoDeseados( estados ) {
    return _.reject( estados, function( estado ) {
      return estado.abstract || estado.name === "login" ||
       estado.name === "404" || estado.name === "403" ||
       estado.name === "inicio.transcripciones" ||
       estado.name.match( /^(\w*\.\w*)\..*$/ );
    } );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/notificaciones.js":[function(require,module,exports){
"use strict";

module.exports = notificaciones;

notificaciones.$inject = [ "toastr" ];

function notificaciones( toastr ) {
  notificaciones.agregar = agregar;
  notificaciones.agregarPersonalizado = agregarPersonalizado;
  return notificaciones;

  function tipo( status ) {
    switch ( String( status ).substr( 0, 1 ) ){
      case "2":
        return toastr.success;
      case "4":
        return toastr.info;
      case "5":
        return toastr.error;
      default:
        return toastr.warning;
    }
  }

  function agregar( status, objeto ) {
    tipo( status )( deEstado( status, objeto ) );
  } //function

  function agregarPersonalizado( status, mensaje ) {
    tipo( status )( mensaje );
  } //function

  function deEstado( status, objeto ) {
    var elem = objeto || "documento";
    switch ( status ) {
    case 0:
      return "<strong>0</strong> - No ha habido comunicación con el servidor";
    case 200:
      return "<strong>200</strong> - Se ha procesado su pedido con éxito";
    case 201:
      return "<strong>201</strong> - Se ha guardado el " + elem + " con éxito";
    case 204:
      return "<strong>204</strong> - Se ha eliminado el " + elem + " con éxito";
    case 400:
      return "<strong>400</strong> - Faltan datos para poder completar su pedido";
    case 403:
      return "<strong>493</strong> - Credenciales inválidos";
    case 404:
      return "<strong>404</strong> - " + elem + " no encontrado";
    case 409:
      return "<strong>409</strong> - " +
       "La acción no se puede ejecutar pues generará un conflicto en los datos";
    case 470:
      return "<strong>470</strong> - La identificación del " + elem + " no es válida";
    case 471:
      return "<strong>471</strong> - El " + elem + " ya existe.";
    case 472:
      return "<strong>472</strong> - Sus credenciales han caducado";
    case 473:
      return "<strong>473</strong> - Sus credenciales son incorrectos";
    case 500:
      return "<strong>500</strong> - " +
       "Se ha producido un error inesperado. Por favor, inténtelo más tarde.";
    case 501:
      return "<strong>501</strong> - El servicio solicitado no ha sido implementado";
    case 530:
      return "<strong>530</strong> - No hemos podido completar su pedido debido a que" +
      " hemos tardado demasiado en procesarlo. Por favor, inténtelo más tarde.";
    default:
      return "<strong>0</strong> - Notificación sin mensaje";
    }
  }
} //functions

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/util.js":[function(require,module,exports){
"use strict";

module.exports = Util;

Util.$inject = [];

function Util() {
  Util.desacentuar = desacentuar;
  Util.formatear = formatear;
  Util.comparar = comparar;
  return Util;

  function omitirVocales( texto ) {
    var vocales = [ "(a|á)", "(e|é)", "(i|í)", "(o|ó)", "(u|ú)" ];

    vocales.forEach( function( vocal ) {
      texto = texto.replace( new RegExp( vocal, "ig" ), vocal );
    } );
    return texto;
  }

  function desacentuar( original ) {
    var texto = angular.copy( original );
    return ( texto ) ? omitirVocales( texto ) : undefined;
  }

  function formatear( original, noAcentos, upper ) {
    var texto = angular.copy( original );
    var strCase = ( _.isUndefined( upper ) ) ? null : upper;
    if ( noAcentos ) {
      texto = desacentuar( texto );
    }
    if ( !_.isNull( strCase ) ) {
      texto = strCase ? texto.toUpperCase() : texto.toLowerCase();
    } else {
      texto = texto.charAt( 0 ).toUpperCase() + texto.slice( 1 );
    }
    return texto;
  }

  function comparar( original1, original2 ) {
    var texto1 = formatear( original1, true, false );
    var texto2 = formatear( original2, true, false );
    return ( texto1 === texto2 );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/servicios/validaciones.js":[function(require,module,exports){
"use strict";

module.exports = Validaciones;

Validaciones.$inject = [ "$auth" ];

function Validaciones( $auth ) {
  Validaciones.dejarPasar = dejarPasar;
  return Validaciones;

  function dejarPasar( params, nombrePermisos ) {
    var permisos = $auth.getPayload().permisos[nombrePermisos];
    //if ( !params.id && permisos.crear ) {
    //  return true;
    //}
    //if ( params.id && params.editar === "true" && permisos.editar ) {
    //  return true;
    //}
    //if ( params.id && ( !params.editar || params.editar === "false" ) && permisos.ver ) {
    //  return true;
    //}
    //return false;
    return ( !params.id && permisos.crear ) ||  // para crear
      ( params.id && params.editar === "true" && permisos.editar ) || // para editar
      ( params.id && ( !params.editar || params.editar === "false" ) && permisos.ver ); // para ver
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/controladores/ListaCalificacionCtrl.js":[function(require,module,exports){
"use strict";

var si = require( "../../base/selectorItems.js" );

module.exports = ListaRevisionCtrl;

ListaRevisionCtrl.$inject = [
  "ClienteAPI",
  "NotaAPI",
  "TranscripcionAPI",
  "TemaAPI",
  "ReporteAPI",
  "$modal",
  "$stateParams",
  "$document",
  "$timeout"
];
function ListaRevisionCtrl( ClienteAPI, NotaAPI, TranscripcionAPI, TemaAPI, ReporteAPI,
                            $modal, $stateParams, $document, $timeout ) {
  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 50 );
  vm.actualizarPagina = actualizarPagina;
  vm.fechasValidas = fechasValidas;
  vm.buscar = buscar;
  vm.mostrarModal = mostrarModal;
  vm.marcarPositivo = marcarPositivo();
  vm.marcarNeutro = marcarNeutro();
  vm.marcarNegativo = marcarNegativo();
  vm.clienteRelativo = clienteRelativo;
  vm.cargarCliente = cargarCliente;
  vm.cargarTema = cargarTema;
  vm.limpiarFiltros = limpiar;
  vm.generar = generarReporte;
  vm.algoSeleccionado = algoSeleccionado;
  vm.nadaSeleccionado = nadaSeleccionado;
  vm.cambiarInclusion = si.cambiarInclusion;
  vm.abrir = abrir;
  vm.sentimientoSeleccionado = sentimientoSeleccionado;
  vm.temaSeleccionado = temaSeleccionado;
  vm.fuenteSeleccionado = fuenteSeleccionado;
  vm.listado = { docs: [], contador: 0 };
  vm.generacion = { untouch: true };
  vm.checkAll = true;
  vm.datepickerConfig = {
    maxdate: new Date()
  };
  vm.guardando = {};
  vm.fuentes = [ "", "Dedicada", "Contenido", "Mención", "Mixta", "Interna", "Externa" ];
  vm.excluir = si.excluir;
  vm.notasExcluidas = {};

  limpiar();

  function limpiar( filtrosForm ) {
    if ( filtrosForm ) {
      filtrosForm.$setUntouched();
      filtrosForm.$setPristine();
    }
    vm.listado = { docs: [], contador: 0 };
    vm.filtro = {
      fechaInicio: {
        fecha: new Date(),
        open: false
      },
      fechaFin: {
        fecha: new Date(),
        open: false
      },
      tipoMencion: "Directa",
      tipoMedio: {
        prensa: false,
        television: false,
        radio: false,
        md: false,
        rs: false
      }
    };
  }

  function fechasValidas() {
    return vm.filtro.fechaInicio.fecha <= vm.filtro.fechaFin.fecha;
  }

  function abrir( fecha ) {
    fecha.open = true;
  }

  function buscar( filtrosForm ) {
    vm.notasExcluidas = {};
    if ( filtrosForm.$valid ) {
      vm.pagina = 1;
      buscarInterno( vm.pagina - 1, vm.cantidad );
    }
  }

  function actualizarPagina( pagina ) {
    buscarInterno( pagina, vm.cantidad );
  }

  function buscarInterno( pagina, cantidad ) {
    var mencion = formatearMencion( vm.filtro.tipoMencion );
    var cliente = ( vm.filtro.cliente ) ? vm.filtro.cliente._id : undefined;
    ReporteAPI.notas( cliente, moment( vm.filtro.fechaInicio.fecha ),
        moment( vm.filtro.fechaFin.fecha ), mencion, vm.filtro.tipoMedio,
        vm.filtro.texto, pagina * cantidad, cantidad )
      .then( function( response ) {
        vm.listado.docs = [];
        var listaTemp = _.map( response.docs );
        _.forEach( listaTemp, function( nota ) {
          nota.incluir = _.get( vm.notasExcluidas[vm.pagina], nota._id, true );
          if ( nota.tema ) {
            nota.elTema = nota.tema;
            nota.tema = nota.elTema._id;
          }
          nota.calificacionesRelativas = obtenerCalificacionesRelativas( nota );
          vm.listado.docs.push( nota );
        } );
        vm.checkAll = si.todoSeleccionado( vm.listado.docs );
        vm.listado.contador = response.contador;
        var conTrans = _.filter( response.docs, function( n ) { return n.transcripcion; } );
        buscarTranscripciones( _.pluck( conTrans, "_id" ) );
      } );
  }

  function buscarTranscripciones( idNotas ) {
    TranscripcionAPI.obtenerDesdeNotas( idNotas ).then( mapearTranscripciones );
  }

  function mapearTranscripciones( transcripciones ) {
    _.forEach( transcripciones, function( transcripcion ) {
      var nota = _.find( vm.listado.docs, function( n ) {
        return n._id === transcripcion.notaId;
      } );
      nota ? nota.trans = transcripcion : false;
    } );
  }

  function obtenerCalificacionesRelativas( nota ) {
    var arreglo = [];
    var cliente = clienteRelativo( nota );
    var relaciones = _.filter( cliente.relaciones, function( relacion ) {
      return relacion.tipoRelacion === vm.filtro.tipoMencion;
    } );
    _.forEach( relaciones, function( relacion ) {

      // buscar la entidad que corresponde a la relación
      // si la entidad no existe no se mete
      var entidad = _.find( nota.entidades, function( ent ) {
        return ent._id._id === relacion.relacion;
      } );
      if ( entidad ) {

        // buscar la calificación según cliente y entidad
        // se usa la que existe o se crea una nueva
        var calificacion = _.find( nota.calificacionEntidad, function( calif ) {
          return calif.cliente.toString() === cliente._id._id.toString() &&
            calif.entidad.toString() === entidad._id._id.toString();
        } );
        if ( calificacion ) {
          calificacion.entidadObj = entidad._id;
          calificacion.tipoRelacion = relacion.tipoRelacion;
          arreglo.push( calificacion );
        } else {
          var nuevaCalif = {
            cliente: cliente._id._id,
            entidad: entidad._id._id,
            sentimiento: cliente.sentimiento,
            tipoRelacion: relacion.tipoRelacion,
            entidadObj: entidad._id
          };
          nota.calificacionEntidad.push( nuevaCalif );
          arreglo.push( nuevaCalif );
        }
      }
    } );
    return _.uniq( arreglo, "_id" );
  }

  function cargarCliente( texto ) {
    return ClienteAPI.listarSinBarra( 0, 10, texto )
      .then( function( response ) {
        return response.docs;
      } );
  }

  function mostrarModal( nota, soloMultimedia ) {
    var scroll = {
      left: $document.scrollLeft(),
      top: $document.scrollTop()
    };

    function scrollBack() {
      $timeout( function() {
        $document.scrollTop( scroll.top );
      }, 250 );
    }

    var modalInstance = $modal.open( {
      templateUrl: "calificacion/vistas/modalNota.html",
      size: "lg",
      resolve: {
        nota: nota,
        soloMultimedia: soloMultimedia,
        cliente: function() { return vm.filtro.cliente._id; }
      },
      controller: "ModalNotaRev",
      controllerAs: "mc"
    } );
    modalInstance.result.then( scrollBack, scrollBack );
  }

  function clienteRelativo( nota ) {
    return _.find( nota.clientes, function( cliente ) {
      return cliente._id._id === vm.filtro.cliente._id;
    } );
  }

  function marcarPositivo() {
    return marcarCliente( "positiva" );
  }

  function marcarNeutro() {
    return marcarCliente( "neutra" );
  }

  function marcarNegativo() {
    return marcarCliente( "negativa" );
  }

  function marcarCliente( sentimiento ) {
    return function( calificacion, nota ) {
      vm.guardando[nota._id] = true;
      calificacion.sentimiento = sentimiento;
      modificarSentimientoCliente( nota );
      guardarNota( nota, function() {
        delete vm.guardando[nota._id];
      } );
    };
  }

  function modificarSentimientoCliente( nota ) {
    if ( vm.filtro.tipoMencion === "Directa" ) {
      var cliente = clienteRelativo( nota );
      var resultados = { pos: 0, neu: 0, neg: 0 };

      // reducir la lista
      var calculo = _.reduce( nota.calificacionesRelativas, function( resultado, item ) {
        if ( item.sentimiento === "positiva" ) {
          resultado.pos += 1;
        }
        if ( item.sentimiento === "neutra" ) {
          resultado.neu += 1;
        }
        if ( item.sentimiento === "negativa" ) {
          resultado.neg += 1;
        }
        return resultado;
      }, resultados );

      // tomar decisión sobre la calificación del cliente
      if ( calculo.neg > 0 ) {
        cliente.sentimiento = "negativa";
      } else {
        if ( calculo.pos > 0 ) {
          cliente.sentimiento = "positiva";
        } else {
          cliente.sentimiento = "neutra";
        }
      }
    }
  }

  function temaSeleccionado( nota, $item ) {
    nota.tema = $item._id;
    vm.guardando[nota._id] = true;
    guardarNota( nota, function() {
      delete vm.guardando[nota._id];
    } );
  }

  function fuenteSeleccionado( nota ) {
    vm.guardando[nota._id] = true;
    guardarNota( nota, function() {
      delete vm.guardando[nota._id];
    } );
  }

  function guardarNota( nota, callback ) {
    NotaAPI.guardarSinBarra( nota ).then( callback );
  }

  function algoSeleccionado() {
    return _.any( vm.listado.docs, "incluir" );
  }

  function nadaSeleccionado() {
    return !algoSeleccionado();
  }

  function cargarTema( texto ) {
    return TemaAPI.listarSinBarra( 0, 10, texto )
      .then( function( response ) {
        return response.docs;
      } );
  }

  function sentimientoSeleccionado( calif, sentimientoEsperado ) {
    return calif.sentimiento === sentimientoEsperado;
  }

  function generarReporte() {
    vm.generacion.untouch = false;
    if ( algoSeleccionado() && fechasValidas() ) {
      var mencion = formatearMencion( vm.filtro.tipoMencion );
      var servirArchivo = require( "../../reportes/modelos/servirArchivo.js" ).curryExcel;
      var ids = si.getIdsExcluidos( vm.notasExcluidas );

      ReporteAPI.notasGenerar( vm.clienteId || vm.filtro.cliente._id, ids,
        vm.filtro.fechaInicio.fecha || false, vm.filtro.fechaFin.fecha || false, mencion,
        vm.filtro.tipoMedio, vm.filtro.texto )
        .then( servirArchivo( "reporteNotas.xlsx" ) );
    }
  }

  function formatearMencion( pmencion ) {
    var mencion = {};
    switch ( pmencion ) {
      case "Competencia":
        mencion = {
          competencia: true,
          contexto: false,
          directa: false
        };
        break;
      case "Directa":
        mencion = {
          competencia: false,
          contexto: false,
          directa: true
        };
        break;
      case "Contexto":
        mencion = {
          competencia: false,
          contexto: true,
          directa: false
        };
        break;
      default:
        mencion = {
          competencia: false,
          contexto: false,
          directa: false
        };
    }
    return mencion;
  }

}

},{"../../base/selectorItems.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/selectorItems.js","../../reportes/modelos/servirArchivo.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/modelos/servirArchivo.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/controladores/ModalNotaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ModalNotaCtrl;

ModalNotaCtrl.$inject = [
  "nota",
  "cliente",
  "soloMultimedia",
  "ArchivoAPI",
  "TranscripcionAPI",
  "$modalInstance",
  "SeccionAPI"
];

function ModalNotaCtrl( nota, cliente, soloMultimedia, ArchivoAPI,
  TranscripcionAPI, $modalInstance, SeccionAPI ) {

  var mc = this;
  mc.nota = nota;
  mc.soloMultimedia = soloMultimedia;
  mc.cerrar = cerrar;
  mc.edicionFind = edicionFind;
  mc.clienteFind = clienteFind;
  mc.otrosClientes = otrosClientes;

  if ( mc.nota.seccion ) {
    SeccionAPI.obtener( mc.nota.seccion )
    .then( function( resp ) {
      mc.nota.seccionNombre = resp.nombre;
    } );
  }

  cargarDatos();

  function cargarDatos() {

    //cargar multimedia
    if ( !( _.isUndefined( mc.nota.multimedia ) || _.isNull( mc.nota.multimedia ) ) ) {
      ArchivoAPI.obtenerSinBarra( mc.nota.multimedia._id )
        .then( function( resp ) {
          mc.multimedia = {
            archivo: resp,
            tipo: _.head( resp.mymeType.split( "/" ) )
          };
          if ( mc.multimedia.tipo === "application" ) {
            mc.pdfUrl = "http://docs.google.com/gview?url=" +
            mc.multimedia.archivo.S3url +
            "&embedded=true";
          }
        } );
    }
  }

  function cerrar() {
    $modalInstance.dismiss( "cancel" );
  }

  function edicionFind() {
    return _.find( mc.nota.guionId.programa.ediciones, function( edicion ) {
      return edicion._id === mc.nota.guionId.edicion;
    } );
  }

  function clienteFind() {
    return _.find( mc.nota.clientes, function( cli ) {
      return cli._id._id === cliente;
    } )._id;
  }

  function otrosClientes() {
    var clientes = _.reject( mc.nota.clientes, function( cli ) {
      return cli._id._id === cliente;
    } );
    return _.map( clientes, function( cli ) { return cli._id; } );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/controladores/calificacionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = RevisionCtrl;

RevisionCtrl.$inject = [];
function RevisionCtrl() {
  var mod = this;
  mod.fechaActual = moment();
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../package.json" ).name;

var modulo = angular.module( nombre + ".Calificacion", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ListaCalificacionCtrl", require( "./controladores/ListaCalificacionCtrl.js" ) );
modulo.controller( "ModalNotaRev", require( "./controladores/ModalNotaCtrl.js" ) );
modulo.controller( "CalificacionCtrl", require( "./controladores/calificacionCtrl.js" ) );

module.exports = modulo;

},{"../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/ListaCalificacionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/controladores/ListaCalificacionCtrl.js","./controladores/ModalNotaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/controladores/ModalNotaCtrl.js","./controladores/calificacionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/controladores/calificacionCtrl.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/calificacion/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  //$stateProvider.state( "inicio.calificacion", {
  //  templateUrl: "calificacion/vistas/inicio.html",
  //  url: "/calificacion",
  //  controller: "CalificacionCtrl",
  //  controllerAs: "mod",
  //  data: {
  //    titulo: "Módulo Revision",
  //    icono: "fa-check-square-o",
  //    menu: "Calificación"
  //  }
  //} );

  //$stateProvider.state( "inicio.calificacion.calificacion-lista", {
  $stateProvider.state( "inicio.calificacion", {
    templateUrl: "calificacion/vistas/listaCalificacion.html",
    url: "/calificacion?pagina&cantidad",
    controller: "ListaCalificacionCtrl",
    controllerAs: "vm",
    resolve: {},
    data: {
      titulo: "Calificación de notas",
      icono: "fa-check-square-o",
      menu: "Calificación"
    }
  } );

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/cambioEstado.js":[function(require,module,exports){
"use strict";

module.exports = cambioEstado;

function cambioEstado( $auth, $localStorage, $sessionStorage, Notificaciones, $state, $http,
  Cache, ClienteAPI, EntidadAPI, PersonajeAPI, cargarCache ) {
  return function( event, toState, toParams, fromState ) {
    if ( $auth.isAuthenticated() ) {
      prevenirPantallaDeLogin( event, toState );
      headerOdoo();
      deslogueoEnOtroLugar( event );
      validarParametros( toState, toParams, fromState );
    } else {
      if ( $localStorage.usuario ) {
        logueoPorRecuerdo( event );
      } else {
        sinLogin( event, toState );
      }
    }
  };

  // Verifica que el cambio de estado sea diferente (no navega en la misma página) y elimina los
  // parámetros 'página' y 'cantidad', evita un bug de arrastre de parámetros cuando se navega
  // de una página con pagincación a otra diferente que también tiene paginación
  function validarParametros( toState, toParams, fromState ) {
    if ( toState.name !== fromState.name ) {
      toParams.pagina = undefined;
      toParams.cantidad = undefined;
    }
  }

  //Está logueado y quiere ir a login
  function prevenirPantallaDeLogin( event, toState ) {
    if ( toState.name === "login" ) {
      inicio( event );
    }
  }

  //Está logueado y se setean los valores de cabeceras default
  function headerOdoo() {
    if ( $sessionStorage.usuario ) {
      $http.defaults.headers.common.odooSession = $sessionStorage.usuario.sesionOdoo;
    }
  }

  //Tiene credenciales en session pero no en local. Se desloguea entonces.
  function deslogueoEnOtroLugar( event ) {
    if ( !$localStorage.usuario && !$sessionStorage.usuario ) {
      event.preventDefault();
      $auth.logout();
      delete $sessionStorage.usuario;
      Notificaciones.agregarPersonalizado( 400, "Ha finalizado la sesión desde otro lugar" );
      $state.go( "login" );
    }
  }

  /*Tiene credenciales en localStorage pero no en session.
  Se carga entonces los credenciales en session*/
  function logueoPorRecuerdo( event ) {
    $sessionStorage.usuario = $localStorage.usuario;
    $auth.setToken( $sessionStorage.usuario.token );
    inicio( event );
    Notificaciones.agregarPersonalizado( 200, "Bienvenido de vuelta " +
     $sessionStorage.usuario.nombre );
  }

  //No está logueado del todo y quiere ver un recurso que necesita logueo
  function sinLogin( event, toState ) {
    if ( !toState.libre ) {
      event.preventDefault();
      Notificaciones.agregarPersonalizado( 400,
         "Necesita estar autenticado para ver estos recursos" );
      $state.go( "login" );
    }
  }

  function inicio( event ) {
    event.preventDefault();
    cargarCache( Cache, ClienteAPI, EntidadAPI, PersonajeAPI );
    var usuario = $sessionStorage.usuario;
    if(usuario.permisos.guion.listar){
      return $state.go( "inicio.monitoreo" );
    }
    if(usuario.permisos.transcripcion.listar){
      return $state.go( "inicio.transcripciones" );
    }
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/cargarCache.js":[function(require,module,exports){
'use strict'

module.exports = CargarCache
function CargarCache(Cache, ClienteAPI, EntidadAPI, PersonajeAPI) {
  ClienteAPI.listarTodosLosClientes().then(function (clientes) {
    Cache.setClientes(clientes.docs)
  })

  EntidadAPI.listar(0, 150000).then(function (entidades) {
    Cache.setEntidades(entidades.docs)
  })

  PersonajeAPI.listar(0, 150000).then(function (personajes) {
    Cache.setPersonajes(personajes.docs)
  })
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/controladores/login.js":[function(require,module,exports){
"use strict";

module.exports = LoginCtrl;
var Usuario = require( "../modelos/usuario.js" );
var CargarCache = require( "../../cargarCache.js" );

LoginCtrl.$inject = [ "$auth", "Notificaciones", "$state", "$sessionStorage",
 "$localStorage", "Cache", "ClienteAPI", "EntidadAPI", "PersonajeAPI" ];

function LoginCtrl( $auth, Notificaciones, $state, $sessionStorage,
   $localStorage, Cache, ClienteAPI, EntidadAPI, PersonajeAPI ) {
  var vm = this;
  vm.ingresar = ingresar;
  vm.usuario = {
    recordar: true
  };

  function ingresar( form, usuario ) {
    if ( form.$valid ) {
      $auth.login( usuario ).then( ok, alerta );
    } else {
      return Notificaciones.agregarPersonalizado( 400, "Faltan campos por completar" );
    }
  }

  function ok( res ) {
    CargarCache( Cache, ClienteAPI, EntidadAPI, PersonajeAPI );
    var usuario = Usuario.cargar( res.data.usuario );
    $sessionStorage.usuario = usuario;
    if ( vm.usuario.recordar === true ) {
      $localStorage.usuario = usuario;
    }
    Notificaciones.agregarPersonalizado( 200, "Bienvenido " + usuario.nombre );
    if(usuario.permisos.guion.listar){
      return $state.go( "inicio.monitoreo" );
    }
    if(usuario.permisos.transcripcion.listar){
      return $state.go( "inicio.transcripciones" );
    }
  }

  function alerta( resp ) {
    if ( resp.status === -1 ) {
      Notificaciones.agregarPersonalizado( 500, "Sin conexión con el servidor" );
    } else {
      Notificaciones.agregarPersonalizado( resp.status, "Credenciales Inválidos" );
    }
  }
}

},{"../../cargarCache.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/cargarCache.js","../modelos/usuario.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/modelos/usuario.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/controladores/rest/usuarioAPI.js":[function(require,module,exports){
"use strict";

module.exports = UsuarioAPI;
var Usuario = require( "../../modelos/usuario.js" );

UsuarioAPI.$inject = [ "$http", "urlApi", "Notificaciones" ];
function UsuarioAPI( $http, urlApi, Notificaciones ) {
  var url = urlApi + "/api/usuario";
  UsuarioAPI.yo = yo;
  UsuarioAPI.buscar = buscar;
  UsuarioAPI.obtener = obtener;
  UsuarioAPI.listar = listar;
  UsuarioAPI.guardar = guardar;
  return UsuarioAPI;

  function yo() {
    return $http.get( url + "/yo" ).then( Usuario.cargar, alerta );
  }

  function buscar( texto ) {
    var params = {
      params: {
        texto: texto,
        pagina: 0,
        cantidad: 10
      }
    };
    return $http.get( url + "/busqueda/", params ).then( Usuario.cargar, alerta );
  }

  function alerta( resp ) {
    Notificaciones.agregar( resp.status, "Usuario" );
    return resp.data;
  }

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/usuario/" + id ).then( function( resp ) {
        return Usuario.cargar( resp.data );
      } );
    } else {
      return new Usuario();
    }
  }

  function listar( pagina, cantidad ) {
    cantidad = cantidad || 10;
    var params = {
      params: {
        pagina: (pagina || 0) * cantidad,
        cantidad: cantidad
      }
    };
    return $http.get( urlApi + "/api/usuario/", params ).then( ok, err );
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Usuario.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Usuario" );
    return [];
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/usuario/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return Usuario.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/usuario/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return Usuario.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Usuario" );
      return resp;
    } );
  }

}

},{"../../modelos/usuario.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/modelos/usuario.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/index.js":[function(require,module,exports){
"use strict";

var modulo = angular.module( "ProyectoBase.login", [] );

modulo.config( require( "./rutas" ) );

modulo.controller( "LoginCtrl", require( "./controladores/login.js" ) );

modulo.factory( "UsuarioAPI", require( "./controladores/rest/usuarioAPI.js" ) );

module.exports = modulo;

},{"./controladores/login.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/controladores/login.js","./controladores/rest/usuarioAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/controladores/rest/usuarioAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/modelos/usuario.js":[function(require,module,exports){
"use strict";

module.exports = Usuario;

function Usuario( nombre, foto, sesionOdoo, token, _id, correo, estado, rol, permisos ) {
  this.nombre = nombre || null;
  this.foto = foto || null;
  this.sesionOdoo = sesionOdoo || null;
  this.token = token || null;
  this._id = _id;
  this.correo = correo || null;
  this.estado = estado || null;
  this.rol = rol || null;
  this.permisos = permisos || {};
  this.elementosPorPagina = 10;
}

Usuario.cargar = cargar;

/*******************************************************  FUNCIONES PÚBLICAS  */

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Usuario( json.nombre, json.foto, json.sesionOdoo, json.token, json._id, json.correo,
    json.estado, json.rol, json.permisos );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/login/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;
rutas.$inject = [ "$stateProvider" ];

function rutas( $stateProvider ) {

  $stateProvider.state( "login", {
    url: "/",
    templateUrl: "login/vistas/login.html",
    controller: "LoginCtrl",
    controllerAs: "vm",
    libre:  true
  } );

} //rutas

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/ModalMultimediaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ModalMultimediaCtrl;
ModalMultimediaCtrl.$inject = [ "nota", "ArchivoAPI", "$modalInstance" ];
function ModalMultimediaCtrl( nota, ArchivoAPI, $modalInstance ) {
  var mc = this;
  mc.nota = nota;
  mc.cerrar = cerrar;

  cargarDatos();

  function cargarDatos() {

    //cargar multimedia
    if ( !( _.isUndefined( mc.nota.multimedia ) || _.isNull( mc.nota.multimedia ) ) ) {
      mc.cargandoMultimedia = true;
      ArchivoAPI.obtenerSinBarra( mc.nota.multimedia )
        .then( function( resp ) {
          mc.multimedia = {
            archivo: resp,
            tipo: _.head( resp.mymeType.split( "/" ) )
          };
          if ( mc.multimedia.tipo === "application" ) {
            mc.pdfUrl = "http://docs.google.com/gview?url=" +
            mc.multimedia.archivo.S3url +
            "&embedded=true";
          }
        } )
        .finally( function() {
          mc.cargandoMultimedia = false;
        } );
    }
  }

  function cerrar() {
    $modalInstance.dismiss( "cancel" );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/cacheNotaCtrls.js":[function(require,module,exports){
"use strict";

module.exports = formNotaCtrl;

formNotaCtrl.$inject = [ "nota", "ListaNotas", "NotaAPI", "SeccionAPI", "ArchivoAPI", "Cache",
  "Util", "$state", "$stateParams", "$scope", "$sessionStorage", "$location", "$anchorScroll",
  "$timeout" ];
function formNotaCtrl( nota, ListaNotas, NotaAPI, SeccionAPI, ArchivoAPI, Cache, Util, $state,
                       $stateParams, $scope, $sessionStorage, $location, $anchorScroll, $timeout ) {

  var self = this;
  var entidades = [];
  var personajes = [];
  var clientes = [];
  var Nota = require( "../modelos/nota.js" );
  inicializarNota();

  /////////////////////////////////////////////////////////////////////////
  //inicializadores y watchers

  function inicializarNota() {
    $sessionStorage.medio = nota.guionId ? nota.guionId.medio._id : $sessionStorage.medio;
    self.nota = angular.copy( nota );
    self.nota.fecha = $sessionStorage.fechaGuion;
    self.nota.tipoMedio = $stateParams.tipoMedio;
    self.personajes = [];
    self.entidades = [];
    self.clientes = [];
    self.mostrarBotones = self.nota._id;
    self.seccion = undefined;
    self.revision = angular.copy( $stateParams.filtroRevision );
    if ( self.nota.tipoMedio === "Prensa" ) {
      self.tamanios = [ "8", "7", "6", "5", "4", "3", "2", "1",
      "3/4", "1/2", "1/3", "1/4", "1/8", "1/16", "1/32" ];
      self.nota.tamanio = self.nota.tamanio ? self.nota.tamanio : "1";
      if ( !self.seccion ) {
        getSecciones( $sessionStorage.medio );
      }
    } else {
      self.hora = calcularHora();
    }
    if ( self.nota.multimedia ) {
      cargarArchivo( self.nota.multimedia._id );
    }
  }

  function getSecciones( id ) {
    SeccionAPI.obtenerSeccionesMedio( id )
    .then( function( resp ) {
      self.secciones = resp.docs;
      if ( self.nota._id ) {
        self.seccion = _.find( self.secciones, function( seccion ) {
          return self.nota.seccion === seccion._id;
        } );
      }
    } );
  }

  function setGuion() {
    if ( _.isUndefined( self.nota.guionId ) ) {
      self.nota.guionId = $stateParams.id;
    } else {
      self.nota.guionId = self.nota.guionId._id || self.nota.guionId;
    }
  }

  $scope.$watchCollection( function getEntidades() {
    return Cache.entidades;
  }, function setEntidades() {
    entidades =  Cache.listaEntidades();
    if ( !_.isUndefined( self.nota._id ) && !_.isEmpty( Cache.entidades ) ) {
      cargarEntidades();
    }
  } );

  $scope.$watchCollection( function getPersonajes() {
    return Cache.personajes;
  }, function setPersonajes() {
    personajes =  Cache.listaPersonajes();
    if ( !_.isUndefined( self.nota._id ) && !_.isEmpty( Cache.personajes ) ) {
      cargarPersonajes();
    }
  } );

  $scope.$watchCollection( function getClientes() {
    return Cache.clientes;
  }, function setClientes() {
    clientes =  Cache.listaClientes();
    if ( !_.isUndefined( self.nota._id ) && !_.isEmpty( Cache.clientes ) ) {
      cargarClientes();
    }
  } );

  $scope.$watchCollection( function getParams() {
    return $state.params;
  }, function setValoresNota() {
    self.nota.editando = $stateParams.editarNota === "true";
    self.mostrar = $stateParams.notas === "true" || self.nota._id;
    if ( self.mostrar ) {
      setFocus();
    }
    self.nota.tipoMedio = $stateParams.tipoMedio;
    entidades = angular.copy( Cache.listaEntidades() );
    personajes = angular.copy( Cache.listaPersonajes() );
    clientes = angular.copy( Cache.listaClientes() );
    setGuion();
  } );

  $scope.$watch( function getHoraEdicion() {
    return $sessionStorage.horaEdicion;
  }, function setHora() {
    self.hora = calcularHora();
  } );

  $scope.$watch( function updateSecciones() {
    return $sessionStorage.medio;
  }, function setSecciones() {
    getSecciones( $sessionStorage.medio );
  } );

  /////////////////////////////////////////////////////////////////////////
  //Fuciones utilitarias

  function reload( id, editando ) {
    $state.go( $state.current, {
      notaId: id,
      editarNota: editando
    }, {
      reload: true
    } );
  }

  function setFocus( ) {
    if ( !self.nota._id ) {
      if ( $stateParams.tipoMedio === "Prensa" ) {
        document.getElementById( "numPagina" ).focus();
      } else {
        $timeout( function() {
          document.querySelectorAll( "#timepicker button" )[0]
          .setAttribute( "tabindex", "-1" );
          document.querySelectorAll( "#timepicker input" )[1].focus();
        }, 100 );
      }
      $location.hash( "scrollHere" );
      $anchorScroll();
    }
  }

  function calcularHora() {
    if ( self.nota.hora ) {
      return self.nota.hora;
    }
    var ultimaNota = ListaNotas.notas.docs[0];
    return ( !_.isUndefined( ultimaNota ) ) ?
              new Date( ultimaNota.hora ) :
              new Date( $sessionStorage.horaEdicion );
  }

  function setDisplay( text1, text2, text3, personaje ) {
    if ( personaje ) {
      if ( text1 && text2 && text3 ) {
        return text1 + " " + text2 + " - " + text3;
      }
      return ( text1 || "" ) + " " + ( text2 || "" ) + " - " + ( text3 || "" );
    }
    if ( text1 && text2 ) {
      return text1 + " - " + text2;
    }
    if ( !text1 ) {
      return text2;
    }
    if ( !text2 ) {
      return text1;
    }
  }

  function buscarEntidades( texto ) {
    if ( texto ) {
      var clave = Util.desacentuar( texto );
      var query = new RegExp( "\b*" + clave, "gi" );
      var queryPrimary = new RegExp( "^" + clave + "$", "i" );
      var resultados = [];
      var entidadesAbreviatura = [];
      var entidadesNombre = [];
      _.forEach( entidades, function( entidad ) {
        entidad.display = "ENTIDAD " + setDisplay( entidad.abreviatura, entidad.nombre );
        if ( entidad.abreviatura ) {
          if ( entidad.abreviatura.match( queryPrimary ) ) {
            entidadesAbreviatura.unshift( entidad );
          } else {
            if ( entidad.abreviatura.match( query ) ) {
              entidadesAbreviatura.push( entidad );
            } else {
              if ( entidad.display.match( query ) ) {
                entidadesNombre.push( entidad );
              }
            }
          }
        } else {
          if ( entidad.display.match( query ) ) {
            entidadesNombre.push( entidad );
          }
        }
      } );
      entidadesAbreviatura = _.sortBy( entidadesAbreviatura, function( ent ) {
        return ent.abreviatura.length;
      } );
      entidadesNombre = _.sortBy( entidadesNombre, function( ent ) {
        return ent.nombre.length;
      } );
      resultados = resultados.concat( entidadesAbreviatura );
      resultados = resultados.concat( entidadesNombre );
      return resultados;
    }
    return [];
  }

  function buscarPersonajes( texto ) {
    var query = new RegExp( "\b*" + Util.desacentuar( texto ), "gi" );
    var personajesResult = [];
    _.forEach( personajes, function( personaje ) {
      var buscarEn = ( personaje.nombre || "" ) + " " + ( personaje.apellido || "" );
      personaje.display = "PERSONAJE ";
      personaje.display += setDisplay( personaje.nombre, personaje.apellido,
                                       personaje.descripcion, true );
      if ( buscarEn.match( query ) ) {
        personajesResult.push( personaje );
      }
    } );

    return _.sortBy( personajesResult, function( p ) {
      return p.display.length;
    } );

  }

  function buscarClientes( id ) {
    /* Esta función (y asociadas) se pasó a nota.js para poder tenerla disponible en el módulo
    Redes Sociales/Medios Digitales donde se requería la misma funcionalidad */
    Nota.buscarClientes( id, clientes, self, self.nota.tipoMedio, Util );
  }

  function agregarObjeto( objeto, arreglo ) {
    if ( ( _.isObject( objeto ) ) &&
         !_.find( arreglo, {
          "_id": objeto._id
        } ) ) {
      arreglo = _.union( arreglo, [ objeto ] );
    }
    return arreglo;
  }

  function agregarEntidad( entidad ) {
    buscarClientes( entidad._id );
    entidad.mencion = true;
    self.entidades = agregarObjeto( entidad, self.entidades );
  }

  function agregarPersonaje( personaje ) {
    buscarClientes( personaje._id );
    self.personajes = agregarObjeto( personaje, self.personajes );
  }

  function agregarEtiquetaTematica ( etiqueta ) {
    etiqueta = etiqueta.descrip.toUpperCase();
    buscarClientes( etiqueta );
    self.nota.agregarEtiquetaTematica( etiqueta );
  }

  function agregarEtiqueta ( etiqueta ) {
    etiqueta = etiqueta.descrip.toUpperCase();
    self.nota.agregarEtiqueta( etiqueta );
  }

  function agregarPorTipo( objeto ) {
    if ( !_.isNull( objeto ) ) {
      if ( _.startsWith( objeto.display, "ENTIDAD" ) ) {
        agregarEntidad( objeto );
      } else if ( _.startsWith( objeto.display, "PERSONAJE" ) ) {
        agregarPersonaje( objeto );
      } else if ( _.startsWith( objeto.display, "TEMA" ) ) {
        agregarEtiquetaTematica( objeto );
      } else if ( _.startsWith( objeto.display, "NR" ) ) {
        agregarEtiqueta( objeto );
      }
    }
  }

  /////////////////////////////////////////////////////////////////////////
  //Declaración de Funciones de MVC

  self.buscarOpciones = buscarOpciones;
  self.buscarClienteManual = buscarClienteManual;
  self.agregar = agregar;
  self.agregarClienteManual = agregarClienteManual;
  self.editar = editar;
  self.guardar = guardar;
  self.volverURI = volverURI;
  self.cambiarSentimiento = cambiarSentimiento;
  self.removerPersonaje = removerPersonaje;
  self.removerEntidad = removerEntidad;
  self.removerCliente = removerCliente;
  self.removerEtiqueta = removerEtiqueta;

  /////////////////////////////////////////////////////////////////////////
  //Funciones MVC

  function buscarOpciones() {
    var opciones = [];
    var tema = {display:"TEMA " + self.palabraClave, descrip: self.palabraClave};
    var nr = {display:"NR " + self.palabraClave, descrip: self.palabraClave};
    var entidadesMatch = buscarEntidades( self.palabraClave );
    var personajesMatch = buscarPersonajes( self.palabraClave );
    opciones = entidadesMatch;
    opciones = opciones.concat( personajesMatch );
    opciones.push( tema, nr );
    return opciones;
  }

  function buscarClienteManual( texto ) {
    return _.filter( clientes, function( cliente ) {
      var query = new RegExp( "\b*" + Util.desacentuar( texto ), "gi" );
      cliente.display = setDisplay( cliente.nombre, cliente.abreviatura );
      return cliente.display.match( query );
    } );
  }

  function editar( valor ) {
    reload( self.nota._id, valor );
  }

  function completarNota( nota ) {
    if ( self.nota.tipoMedio !== "Prensa" ) {
      nota.hora = moment( self.hora );
      nota.transcripcion = _.pluck( _.filter( self.clientes, "servicios.transcripcion" ), "_id" );
    }
    if ( !_.isUndefined( self.seccion ) ) {
      nota.seccion = self.seccion._id;
    }
    nota.agregarEntidades( self.entidades );
    nota.agregarPersonajes( self.personajes );
    self.nota.agregarClientes( self.clientes );
    return nota;
  }

  function terminar( form, id ) {
    if ( self.nota._id ) {
      reload( self.nota._id, false );
    } else {
      $state.params.notaId = id;
      $state.params.editarNota = false;
    }
    form.$setPristine();
    inicializarNota();
  }

  function guardar( form ) {
    if ( !self.cargandoCliente && !self.cargando && form.$valid ) {
      self.cargando = true;
      var notaCompleta = completarNota( self.nota );
      NotaAPI.guardarSinBarra( notaCompleta )
      .then( function( resp ) {
        ListaNotas.agregarNota( resp );
        terminar( form, resp._id );
      } )
      .finally( function() {
        self.cargando = false;
        setFocus( );
      } );
    }
  }

  function volverURI() {
    switch ( $stateParams.origen ) {
      case "Revision":
        $state.go( "inicio.monitoreo", {filtroRevision: self.revision}, {reload: true} );
        break;
      default:
        $state.go( "^.guion-uno", {id: self.nota.guionId, tipoMedio:self.nota.tipoMedio} );
    }
  }

  function agregarClienteManual() {
    if ( !_.isUndefined( self.cliente ) && self.cliente !== null && typeof( self.cliente ) === "object" )
    {
      var encontrado = _.find( self.clientes, function( c ) {
        return c._id === self.cliente._id;
      } );
      if ( encontrado ) {
        self.cliente = null;
        return;
      }
      self.cliente.mencion = "Contexto";
      self.cliente.manual = true;
      self.clientes = _.union( self.clientes, [ self.cliente ] );
      self.cliente = null;
    }
  }

  function agregar() {
    if ( _.isObject( self.palabraClave ) ) {
      agregarPorTipo( self.palabraClave );
    }
    self.palabraClave = null;
  }

  function cambiarSentimiento( cliente ) {
    cliente.sentimiento = cliente.negativa ? "negativa" : "positiva";
  }

  /////////////////////////////////////////////////////////////////////////
  //funciones para quitar elementos de la nota

  function removerPersonaje( personaje ) {
    if ( confirm( "¿Está seguro de que desea remover este personaje?" ) ) {
      self.personajes = _.without( self.personajes, personaje );
      self.nota.removerPersonaje( personaje._id );
      removerCliente( null, personaje._id );
    }
  }

  function removerEntidad( entidad ) {
    if ( confirm( "¿Está seguro de que desea remover esta entidad?" ) ) {
      self.entidades = _.without( self.entidades, entidad );
      self.nota.removerEntidad( entidad._id );
      removerCliente( null, entidad._id );
    }
  }

  function removerEtiqueta( etiqueta, esTema ) {
    if ( confirm( "¿Está seguro de que desea remover esta etiqueta?" ) ) {
      if ( esTema ) {
        self.nota.removerEtiquetaTematica( etiqueta );
        removerCliente( null, etiqueta );
      } else {
        self.nota.removerEtiqueta( etiqueta );
      }
    }
  }

  function removerCliente( clienteId, otroId ) {
    if ( !_.isNull( clienteId ) ) {
      if ( confirm( "¿Está seguro de que desea remover este cliente manualmente?" ) ) {
        self.clientes = _.reject( self.clientes, function( cliente ) {
          return cliente._id === clienteId;
        } );
      }
    } else {
      _.forEach( self.clientes, function( cliente )  {
        if ( !_.isEmpty( cliente.relaciones ) ) {
          _.forEach( cliente.relaciones, function( rel ) {
            if ( rel.relacion === otroId && !cliente.manual ) {
              self.clientes = _.reject( self.clientes, cliente );
            }
          } );
        }
      } );
    }
  }

  /////////////////////////////////////////////////////////////////////////
  //funciones para mostrar elementos de la nota si ya existe

  function cargarClientes() {
    var temp = _.map( self.nota.clientes, function( cliente ) {
      var match = angular.copy( Cache.clientes[cliente._id] );
      if ( !_.isUndefined( match ) ) {
        match.logo = cliente.logo;
        match.ignorar = cliente.ignorar;
        match.mencion = cliente.mencion;
        match.relaciones = cliente.relaciones;
        match.sentimiento = cliente.sentimiento;
        match.negativa = cliente.sentimiento === "negativa";
        return match;
      }
      return null;
    } );
    self.clientes = _.compact( temp );
  }

  function cargarEntidades() {
    self.entidades = _.map( self.nota.entidades, function( entidad ) {
      var match = angular.copy( Cache.entidades[entidad._id] );
      match.logo = entidad.logo;
      match.mencion = entidad.mencion;
      return match;
    } );
  }

  function cargarPersonajes() {
    self.personajes = _.map( self.nota.personajes, function( personaje ) {
      var match = angular.copy( Cache.personajes[personaje._id] );
      match.mencion = personaje.mencion;
      return match;
    } );
  }

  function cargarArchivo( id ) {
    self.cargandoMultimedia = true;
    ArchivoAPI.obtener( id )
    .then( function( resp ) {
      self.nota.archivo = resp;
      if ( _.startsWith( self.nota.archivo.mymeType, "image/" ) ) {
        self.imagen = true;
      } else if ( _.startsWith( self.nota.archivo.mymeType, "audio/" ) ) {
        self.audio = true;
      } else if ( _.startsWith( self.nota.archivo.mymeType, "video/" ) ) {
        self.video = true;
      } else if ( _.startsWith( self.nota.archivo.mymeType, "application/" ) ) {
        self.pdfUrl = "http://docs.google.com/gview?url=" +
        self.nota.archivo.S3url +
        "&embedded=true";
        self.application = true;
      }
    } )
    .finally( function() {
      self.cargandoMultimedia = false;
    } );
  }
}

},{"../modelos/nota.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/modelos/nota.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/formGuionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormGuionCtrl;

FormGuionCtrl.$inject = [
  "guion",
  "medios",
  "GuionAPI",
  "MedioAPI",
  "ProgramaAPI",
  "SeccionAPI",
  "ArchivoAPI",
  "$state",
  "$stateParams",
  "$scope",
  "$sessionStorage"
];

function FormGuionCtrl( guion, medios, GuionAPI, MedioAPI, ProgramaAPI,
   SeccionAPI, ArchivoAPI, $state, $stateParams, $scope, $sessionStorage ) {

  var self = this;
  inicializarGuion();

  /////////////////////////////////////////////////////////////////////////////
  //inicializadores y watchers

  function inicializarGuion() {
    self.medios = medios.docs;
    self.guion = guion;
    self.guion.tipoMedio = $stateParams.tipoMedio;
    self.fecha = new Date( self.guion.fecha );
    $sessionStorage.fechaGuion = self.guion.fecha;
    if ( self.guion._id ) {
      cargarArchivo( self.guion.medio.idLogo );
      self.medio = buscarEnArray( self.medios, self.guion.medio._id );
      getProgramas( self.guion.medio._id );
    }
    delete $sessionStorage.horaEdicion;
    if ( self.guion.medio ) {
      $sessionStorage.medio = self.guion.medio._id;
    }
  }

  $scope.$watchCollection( function() {
    return $state.params;
  }, function() {
    self.guion.editando = $stateParams.editar === "true";
    self.notas = $stateParams.notas === "true";
  } );

  /////////////////////////////////////////////////////////////////////////////
  //Funciones utilitarias

  function buscarEnArray( arreglo, id ) {
    return _.find( arreglo, function( item ) {
      return item._id === id;
    } );
  }

  function reload( id, editando, notas ) {
    $state.go( $state.current, {
      id: id,
      editar: editando,
      notas: notas
    }, {
      reload: true
    } );
  }

  function cargarArchivo( id ) {
    self.cargandoImg = true;
    if ( !_.isUndefined( id ) ) {
      ArchivoAPI.obtener( id )
      .then( function( resp ) {
        self.logoMedio = resp;
      } )
      .finally( function() {
        self.cargandoImg = false;
      } );
    }
  }

  function getProgramas( id ) {
    if ( self.guion.tipoMedio !== "Prensa" ) {
      ProgramaAPI.obtenerProgramasMedio( id ).then( function( resp ) {
        self.programas = resp.docs;
        if ( !_.isUndefined( self.guion._id ) ) {
          self.programa = buscarEnArray( self.programas, self.guion.programa._id );
          getEdiciones();
        }
      } );
    }
  }

  function getEdiciones() {
    self.ediciones = _.map( self.programa.ediciones, function( edicion ) {
      edicion.display = edicion.nombre + " | " +
        moment( edicion.horaInicio ).format( "hh:mm" ) +
        " - " + moment( edicion.horaFin ).format( "hh:mm" );
      return edicion;
    } );
  }

  /////////////////////////////////////////////////////////////////////////
  //Declaración de Funciones de MVC

  self.editar = editar;
  self.setMedio = setMedio;
  self.setPrograma = setPrograma;
  self.guardar = guardar;
  self.iniciarMonitoreo = iniciarMonitoreo;
  self.volverURI = volverURI;

  /////////////////////////////////////////////////////////////////////////////
  //Funciones MVC

  function editar( valor ) {
    reload( self.guion._id, valor, false );
  }

  function setMedio( ) {
    if ( !_.isUndefined( self.medio ) ) {
      self.guion.medio = self.medio._id;
      getProgramas( self.medio._id );
      cargarArchivo( self.medio.idLogo );
    }
  }

  function setPrograma() {
    if ( !_.isUndefined( self.programa ) ) {
      self.guion.programa = self.programa._id;
      getEdiciones();
    }
  }

  function setEdicion() {
    if ( self.guion.edicion ) {
      var edicion = buscarEnArray( self.ediciones, self.guion.edicion );
      $sessionStorage.horaEdicion = edicion.horaInicio;
    }
  }

  function guardar( formValido ) {
    if ( formValido ) {
      self.guion.fecha = moment( self.fecha );
      GuionAPI.guardar( self.guion ).then( function( resp ) {
        if ( !$sessionStorage.horaEdicion ) {
          setEdicion();
        }
        reload( resp._id, false, false );
      } );
    }
  }

  function iniciarMonitoreo() {
    setEdicion();
    $sessionStorage.medio = self.guion.medio._id;
    $state.params.id = self.guion._id;
    $state.params.editar = "false";
    $state.params.notas = "true";
  }

  function volverURI() {
    $state.go( "inicio.monitoreo", {origen: "Monitoreo"}, {reload: true} );
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/listadoGuionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoGuionCtrl;

ListadoGuionCtrl.$inject = [
  "listadoGuiones",
  "MedioAPI",
  "ProgramaAPI",
  "GuionAPI",
  "ReporteAPI",
  "ClienteAPI",
  "$scope",
  "$state",
  "$stateParams",
  "$timeout",
  "cfpLoadingBar"
];

function ListadoGuionCtrl( listadoGuiones, MedioAPI, ProgramaAPI, GuionAPI,
  ReporteAPI, ClienteAPI, $scope, $state, $stateParams, $timeout, cfpLoadingBar ) {

  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.paginaNotas = 0;
  vm.cantidadNotas = 50;
  vm.listado = listadoGuiones;
  vm.listadoNotas = { docs: [], contador: 0 };
  vm.eliminar = eliminar;
  vm.actualizarPagina = actualizarPagina;
  vm.fechasValidas = fechasValidas;
  vm.tiposValidos = tiposValidos;
  vm.cambioATodos = cambioATodos;
  vm.buscar = buscar;
  vm.limpiarFiltros = limpiar;
  vm.cargarCliente = cargarCliente;
  vm.abrir = abrir;
  vm.estado = "Normal";
  vm.mostrarFiltro = false;
  vm.tipoFiltro = $stateParams.origen || "Monitoreo";
  vm.opciones = {
    tipos: [ "Televisión", "Radio", "Prensa", "Medios Digitales", "Redes Sociales" ]
  };
  vm.cargando = {};
  vm.getMedios = getMedios;
  vm.getProgramas = getProgramas;
  vm.getEdiciones = getEdiciones;
  vm.buscarRevision = buscarRevision;
  vm.buscarMonitoreo = buscarMonitoreo;

  $scope.$watch( function() { return vm.tipoFiltro; }, function( value ) {
    vm.estado = value;
  } );

  $scope.$watch( function() { return vm.mostrarFiltro; }, function( value ) {
    vm.estado = ( value ) ? vm.tipoFiltro : "Normal";
  } );

  limpiar();
  if ( $stateParams.filtroRevision ) {
    vm.mostrarFiltro = true;
    vm.filtros.revision = $stateParams.filtroRevision;
    vm.todosLosClientes = $stateParams.filtroRevision.cliente === undefined;
    buscarRevision( vm.paginaNotas );
  }

  function limpiar( form ) {
    if ( form ) {
      form.$setUntouched();
      form.$setPristine();
    } else {
      $timeout( function() {
        angular.element( document.getElementById( "limpiar" ) ).triggerHandler( "click" );
      }, 0 );
    }
    vm.filtros = {
      revision: {
        fechaInicio: {
          fecha: new Date(),
          open: false
        },
        fechaFin: {
          fecha: new Date(),
          open: false
        },
        tipoMencion: {
          directa: false,
          contexto: false,
          competencia: false
        },
        tipoMedio: {
          television: false,
          radio: false,
          prensa: false
        }
      },
      monitoreo: {
        fechaInicio: {
          open: false
        },
        fechaFin: {
          open: false
        }
      }
    };
  }

  function eliminar( guion ) {
    if ( confirm( "¿Está seguro que desea eliminar el Guion?" ) ) {
      GuionAPI.eliminar( guion._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === guion._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function cargarCliente( texto ) {
    return ClienteAPI.listarSinBarra( 0, 10, texto )
      .then( function( response ) {
        return response.docs;
      } );
  }

  function fechasValidas() {
    return vm.filtros.revision.fechaInicio.fecha <= vm.filtros.revision.fechaFin.fecha;
  }

  function tiposValidos() {
    var tipos = vm.filtros.revision.tipo;
    return tipos.directa || tipos.contexto || tipos.competencia;
  }

  function cambioATodos() {
    if ( vm.todosLosClientes ) {
      delete vm.filtros.revision.cliente;
    }
  }

  function abrir( fecha ) {
    fecha.open = true;
  }

  function buscar( form ) {

    //busqueda de monitoreo
    if ( vm.tipoFiltro === "Monitoreo" && form.$valid ) {
      vm.pagina = 0;
      buscarMonitoreo( vm.pagina );
    }

    //busqueda de revision
    if ( vm.tipoFiltro === "Revision" && form.$valid ) {
      vm.paginaNotas = 0;
      buscarRevision( vm.paginaNotas );
    }
  }

  function buscarMonitoreo( pagina ) {
    cfpLoadingBar.start();
    var filtros = vm.filtros.monitoreo;
    GuionAPI.listar( pagina, vm.cantidad, null, filtros.edicion, filtros.medio, filtros.programa,
      filtros.fechaInicio.fecha, filtros.fechaFin.fecha, filtros.tipoMedio )
      .then( function( guiones ) {
        vm.listado.docs = guiones.docs;
        vm.listado.contador = guiones.contador;
        vm.esconderColumnas = vm.filtros.monitoreo.tipoMedio === "Prensa";
        cfpLoadingBar.complete();
      } );
  }

  function actualizarPagina( pagina ) {
    var filtros = {
      pagina: pagina || 0,
      cantidad: vm.cantidad || 10,
      origen: "Monitoreo",
      filtroRevision: vm.filtros.revision
    };
    _.assign( filtros, vm.filtros.monitoreo );
    if ( vm.filtros.monitoreo.fechaInicio.fecha || vm.filtros.monitoreo.fechaFin.fecha ) {
      filtros.fechaInicio = moment( filtros.fechaInicio.fecha ).startOf( "day" ).format(),
      filtros.fechaFin = moment( filtros.fechaFin.fecha ).endOf( "day" ).format();
    } else {
      delete filtros.fechaInicio;
      delete filtros.fechaFin;
    }
    $state.go( $state.current, filtros, {reload: true} );
  }

  function buscarRevision( pagina ) {
    var filtros = vm.filtros.revision;
    var cliente = ( filtros.cliente ) ? filtros.cliente._id : undefined;
    ReporteAPI.notas( cliente, moment( filtros.fechaInicio.fecha ),
        moment( filtros.fechaFin.fecha ), filtros.tipoMencion, filtros.tipoMedio,
        filtros.texto, pagina * vm.cantidadNotas, vm.cantidadNotas )
      .then( function( response ) {
        vm.listadoNotas.docs = response.docs;
        vm.listadoNotas.contador = response.contador;
      } );
  }

  function getMedios() {
    vm.cargando.medios = true;
    delete vm.filtros.monitoreo.medio;
    delete vm.filtros.monitoreo.programa;
    delete vm.filtros.monitoreo.edicion;
    MedioAPI.obtenerMediosTipo( vm.filtros.monitoreo.tipoMedio ).then( function( response ) {
      vm.opciones.medios = response.docs;
      vm.cargando.medios = false;
    } );
  }

  function getProgramas() {
    if ( vm.filtros.monitoreo.tipoMedio !== "Prensa" ) {
      vm.cargando.programas = true;
      delete vm.filtros.monitoreo.programa;
      delete vm.filtros.monitoreo.edicion;
      ProgramaAPI.obtenerProgramasMedioSinBarra( vm.filtros.monitoreo.medio )
        .then( function( response ) {
          vm.opciones.programas = response.docs;
          vm.cargando.programas = false;
        } );
    }
  }

  function getEdiciones() {
    vm.cargando.ediciones = true;
    delete vm.filtros.monitoreo.edicion;
    var programa = _.find( vm.opciones.programas, function( programa ) {
      return programa._id === vm.filtros.monitoreo.programa;
    } );
    if ( programa ) {
      vm.opciones.ediciones = _.map( programa.ediciones, function( edicion ) {
        edicion.display = edicion.nombre + " | " + moment( edicion.horaInicio ).format( "hh:mm" ) +
          " - " + moment( edicion.horaFin ).format( "hh:mm" );
        return edicion;
      } );
    }
    vm.cargando.ediciones = false;
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/listadoNotaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoNotaCtrl;

ListadoNotaCtrl.$inject = [ "NotaAPI", "GuionAPI", "ArchivoAPI", "$modal",
 "$state", "$stateParams", "ListaNotas" ];
function ListadoNotaCtrl( NotaAPI, GuionAPI, ArchivoAPI, $modal, $state,
   $stateParams, ListaNotas ) {
  var vm = this;
  vm.mostrar = $stateParams.id || false;
  vm.listado = ListaNotas.notas;
  vm.eliminar = eliminar;
  vm.eliminarArchivo = eliminarArchivo;
  vm.procesarNota = procesarNota;
  vm.mostrarModal = mostrarModal;
  vm.pagina = 1;
  vm.cantidad = 50;

  if ( $stateParams.id ) {
    GuionAPI.obtener( $stateParams.id ).then( function( resp ) {
      vm.guion = resp;
    } );
  }

  function mostrarModal( nota ) {
    var size = nota.numPagina ? "lg" : "";
    $modal.open( {
      templateUrl: "monitoreo/vistas/modalMultimedia.html",
      controller: "ModalMultimediaCtrl",
      size: size,
      resolve: {
        nota: nota
      },
      controllerAs: "mc"
    } );
  }

  function eliminar( nota ) {
    if ( confirm( "¿Está seguro que desea eliminar el Nota?" ) ) {
      NotaAPI.eliminar( nota._id ).then( function() {
        vm.listado.docs = _.reject( vm.listado.docs, function( elem ) {
          return elem._id === nota._id;
        } );
        vm.listado.contador -= 1;
      } );
    }
  }

  function procesarNota( nota ) {
    vm.actualizando = true;
    nota.agregarArchivo( nota.archivo.resultado, nota.archivo.duracion );
    NotaAPI.guardarSinBarra( nota )
    .then( function( resp ) {
      if ( resp ) {
        nota.subido = true;
      }
    } )
    .finally( function() {
      vm.actualizando = false;
    } );
  }

  function eliminarArchivo( nota ) {
    if ( confirm( "¿Está seguro que desea eliminar el archivo de la nota?" ) ) {
      var idArchivo = nota.multimedia;
      nota.removerArchivo();
      NotaAPI.guardar( nota ).then( function( resp ) {
        if ( resp ) {
          ArchivoAPI.eliminar( idArchivo ).then( function( r ) {
            if ( r ) {
              nota.subido = false;
            }
          } );
        }
      } );
    }
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/monitoreoCtrl.js":[function(require,module,exports){
"use strict";

module.exports = MonitoreoCtrl;

MonitoreoCtrl.$inject = [];
function MonitoreoCtrl() {
  var mod = this;
  mod.fechaActual = moment();
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/printPrensaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = PrintPrensaCtrl;

PrintPrensaCtrl.$inject = [ "$stateParams", "ListaNotas", "secciones", "Cache" ];
function PrintPrensaCtrl( $stateParams, ListaNotas, secciones, Cache ) {
  var vm = this;
  var listaSecciones = secciones;

  ListaNotas.ordenar( true );
  vm.guionId = $stateParams.id;
  vm.notas = _.map(ListaNotas.notas.docs.reverse(), enriquecerNota);
  vm.guion = $stateParams.guion;
  vm.getCliente = getCliente;
  vm.clienteImpresion = clienteImpresion;

  vm.imprimir = function() {
    var menuMostrado = !$( "#wrapper" ).hasClass( "minimizado" );
    if ( menuMostrado ) {
      $( "#wrapper" ).toggleClass( "minimizado" );
    }
    window.print();
    if ( menuMostrado ) {
      $( "#wrapper" ).toggleClass( "minimizado" );
    }
  };

  function getCliente( id ) {
    return Cache.clientes[ id ];
  }

  function clienteImpresion( cliente ) {
    var cli = getCliente( cliente._id );
    var nombre = cli.abreviatura || cli.nombre;
    return ( cliente.mencion === "Directa" ) ? nombre + " (D)": nombre;
  }

  function enriquecerNota( nota ) {
    nota.seccionNombre = getSeccion(nota.seccion).nombre;
    nota.clientesImpresion = _.map(nota.clientes, clienteImpresion).join("; ");
    return nota;
  }

  function getSeccion( id ) {
    return listaSecciones[id];
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/rest/guionAPI.js":[function(require,module,exports){
"use strict";

module.exports = GuionAPI;

var Guion = require( "../../modelos/guion.js" );

GuionAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function GuionAPI( urlApi, $http, Notificaciones ) {
  GuionAPI.obtener = obtener;
  GuionAPI.listar = listarCurried( true );
  GuionAPI.listarSinBarra = listarCurried( false );
  GuionAPI.guardar = guardar;
  GuionAPI.eliminar = eliminar;
  GuionAPI.getGuionesBulk = getGuionesBulk;
  GuionAPI.buscarMonitoreo = buscarMonitoreo;
  GuionAPI.buscarRevision = buscarRevision;
  GuionAPI.buscarXNombre = buscarXNombre;
  return GuionAPI;

  function buscarMonitoreo( tipoMedio, medio, programa, edicion,
                            fechaInicio, fechaFin ) {
    var obj = {
      pagina: 0,
      cantidad: 10,
      tipoMedio: tipoMedio,
      medio: medio,
      programa: programa,
      edicion: edicion,
      fechaInicio: fechaInicio,
      fechaFin: fechaFin
    };
    return $http.post( urlApi + "/api/guion/monitoreo", obj ).then( ok, err );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, texto, edicion, medio, programa, fechaInicio, fechaFin,
    tipoMedio ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          edicion: edicion || false,
          medio: medio || false,
          programa: programa || false,
          fechaInicio: fechaInicio || false,
          fechaFin: fechaFin || false,
          tipoMedio: tipoMedio || false
        },
        ignoreLoadingBar: !loadingBar
      };
      if ( !_.isUndefined( texto ) ) {
        params.params.texto = texto;
      }
      //return $http.get( urlApi + "/api/guion/", params ).then( ok, err );
      return $http.post( urlApi + "/api/guion/monitoreo", params.params ).then( ok, err );
    };
  }

  function buscarRevision( cliente, tipoMencion, tipoMedio, texto, fechaInicio, fechaFin ) {
    var obj = {
      pagina: 0,
      cantidad: 10,
      cliente: cliente,
      tipoMencion: tipoMencion,
      tipoMedio: tipoMedio,
      texto: texto,
      fechaInicio: fechaInicio,
      fechaFin: fechaFin
    };
    return $http.post( urlApi + "/api/guion/revision", obj ).then( ok, err );
  }

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/guion/" + id ).then( function( resp ) {
        return Guion.cargar( resp.data );
      } );
    } else {
      return new Guion();
    }
  }

  function getGuionesBulk( ids ) {
    return $http.post( urlApi + "/api/guion/guiones", ids ).then( function( resp ) {
      return resp.data;
    } );
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Guion.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Guion" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/guion/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Guion" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Guion" );
      return resp;
    } );
  }

  function guardar( obj ) {
    if ( obj._id ) {
      return editar( obj );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/guion/", obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Guion" );
      return Guion.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Guion" );
      return resp;
    } );
  }

  function editar( obj ) {
    return $http.put( urlApi + "/api/guion/" + obj._id, obj ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Guion" );
      return Guion.cargar( resp.data );
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Guion" );
      return resp;
    } );
  }

  function buscarXNombre( nombre ) {
    return new Promise( function( resolve, reject ) {
      $http.get( urlApi + "/api/nombre" + nombre ).then( function( resp ) {
        resolve( resp.data );
      }, function( err ) {
        reject( err );
      } );
    } );
  }
}

},{"../../modelos/guion.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/modelos/guion.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/rest/notaAPI.js":[function(require,module,exports){
"use strict";

module.exports = NotaAPI;

var Nota = require( "../../modelos/nota.js" );

NotaAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function NotaAPI( urlApi, $http, Notificaciones ) {
  NotaAPI.obtener = obtener;
  NotaAPI.listar = listar;
  NotaAPI.listarSinBarra = listarSinBarra;
  NotaAPI.guardar = guardar;
  NotaAPI.guardarSinBarra = guardarSinBarra;
  NotaAPI.eliminar = eliminar;
  NotaAPI.listarPalabrasClave = listarPalabrasClave;
  NotaAPI.notasRevision = notasRevision;
  NotaAPI.getNotasCompletas = getNotasCompletas;
  return NotaAPI;

  function obtener( id ) {
    if ( id ) {
      return $http.get( urlApi + "/api/nota/" + id ).then( function( resp ) {
        return Nota.cargar( resp.data );
      } );
    } else {
      return new Nota();
    }
  }

  function notasRevision( pagina, cantidad, clienteId, desde, hasta, tipoMedio, tipoMencion,
                          texto ) {
    var params = {
      pagina: pagina || 0,
      cantidad: cantidad || 50,
      desde: desde,
      hasta: hasta,
      tipoMencion: tipoMencion,
      tipoMedio: tipoMedio,
      texto:texto
    };
    if ( clienteId ) {
      params.clienteId = clienteId;
    }
    return $http.post( urlApi + "/api/nota/notas", params ).then( ok, err );
  }

  function listar( pagina, cantidad, guionId, texto ) {
    return listarCurried( false )( pagina, cantidad, guionId, texto );
  }

  function listarSinBarra( pagina, cantidad, guionId, texto ) {
    return listarCurried( true )( pagina, cantidad, guionId, texto );
  }

  function listarCurried( loadingBar ) {
    return function( pagina, cantidad, guionId, texto ) {
      var params = {
        params: {
          pagina: pagina || 0,
          cantidad: cantidad || 10,
          texto: texto
        },
        ignoreLoadingBar: loadingBar
      };
      if ( guionId ) {
        params.params.guionId = guionId;
      }
      return $http.get( urlApi + "/api/nota/", params ).then( ok, err );
    };
  }

  function listarPalabrasClave( pagina, cantidad, texto ) {
    var params = {
      params: {
        pagina: pagina || 0,
        cantidad: cantidad || 10,
        texto: texto
      },
      ignoreLoadingBar: true
    };
    return $http.get( urlApi + "/api/nota/palabrasClave", params ).then( exito, err );
  }

  function exito ( resp ) {
    return resp.data;
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Nota.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Nota" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/nota/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Nota" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Nota" );
      return resp;
    } );
  }

  function guardar( obj ) {
    return guardarCurried( false )( obj );
  }

  function guardarSinBarra( obj ) {
    return guardarCurried( true )( obj );
  }

  function guardarCurried( loadingBar ) {
    return function( obj ) {
      if ( obj._id ) {
        return editar( loadingBar )( obj );
      } else {
        return crear( loadingBar )( obj );
      }
    };
  }

  function crear( loadingBar ) {
    return function( obj ) {
      return $http.post( urlApi + "/api/nota/", obj, { ignoreLoadingBar: loadingBar } )
        .then( okGuargar, errGuardar );
    };
  }

  function editar( loadingBar ) {
    return function( obj ) {
      return $http.put( urlApi + "/api/nota/" + obj._id, obj, { ignoreLoadingBar: loadingBar } )
        .then( okGuargar, errGuardar );
    };
  }

  function okGuargar( resp ) {
    Notificaciones.agregar( resp.status, "Nota" );
    return Nota.cargar( resp.data );
  }

  function errGuardar( resp ) {
    Notificaciones.agregar( resp.status, "Nota" );
    return resp;
  }

  function getNotasCompletas( claves ) {
    return $http.post( urlApi + "/api/nota/notascompletas", {
      claves: claves,
      ignoreLoadingBar: true
    } ).then( function( resp ) {
      return resp;
    }, function( err ) {
      Notificaciones.agregar( err.status );
      return err;
    } );
  }
}

},{"../../modelos/nota.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/modelos/nota.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/servicios/listaNotas.js":[function(require,module,exports){
"use strict";

module.exports = ListaNotas;

ListaNotas.$inject = [];
function ListaNotas() {
  ListaNotas.notas = {
    docs:[],
    contador:0
  };
  ListaNotas.agregarNota = agregarNota;
  ListaNotas.ordenar = ordenar;
  return ListaNotas;

  function agregarNota( nota ) {
    ListaNotas.notas.docs.push( nota );
    ListaNotas.notas.contador += 1;
    ordenar( nota.numPagina );
  }

  function ordenar( porPagina ) {
    if ( porPagina ) {
      ListaNotas.notas.docs.sort( ordenarPorPagina );
    } else {
      ListaNotas.notas.docs.sort( ordenarPorHora );
    }
  }

  function ordenarPorPagina( a, b ) {
    var intA = parseInt( a.numPagina );
    var intB = parseInt( b.numPagina );
    if ( _.isNaN( intA ) || _.isNaN( intB ) ) {
      if ( a.numPagina < b.numPagina ) {
        return 1;
      }
      if ( a.numPagina > b.numPagina ) {
        return -1;
      }
      return ordenarPorCreacion( a, b );
    }
    var resultado = b.numPagina - a.numPagina;
    if ( resultado === 0 ) {
      return ordenarPorCreacion( a, b );
    }
    return resultado;
  }

  function ordenarPorHora( a, b ) {
    if ( moment( a.hora ).isBefore( b.hora ) ) {
      return 1;
    }
    if ( moment( a.hora ).isAfter( b.hora ) ) {
      return -1;
    }
    return ordenarPorCreacion( a, b );
  }

  function ordenarPorCreacion( a, b ) {
    if ( moment( a.createdAt ).isBefore( b.createdAt ) ) {
      return 1;
    }
    if ( moment( a.createdAt ).isAfter( b.createdAt ) ) {
      return -1;
    }
    return 0;
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../package.json" ).name;

var modulo = angular.module( nombre + ".Monitoreo", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "MonitoreoCtrl", require( "./controladores/monitoreoCtrl.js" ) );

modulo.controller( "ListadoGuionCtrl", require( "./controladores/listadoGuionCtrl.js" ) );
modulo.controller( "FormGuionCtrl", require( "./controladores/formGuionCtrl.js" ) );
modulo.controller( "PrintPrensaCtrl", require( "./controladores/printPrensaCtrl.js" ) );

modulo.factory( "GuionAPI", require( "./controladores/rest/guionAPI.js" ) );

modulo.controller( "ListadoNotaCtrl", require( "./controladores/listadoNotaCtrl.js" ) );
modulo.controller( "CacheNotaCtrl", require( "./controladores/cacheNotaCtrls.js" ) );

modulo.controller( "ModalMultimediaCtrl", require( "./controladores/ModalMultimediaCtrl.js" ) );

modulo.factory( "NotaAPI", require( "./controladores/rest/notaAPI.js" ) );
modulo.factory( "ListaNotas", require( "./controladores/servicios/listaNotas.js" ) );

module.exports = modulo;

},{"../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/ModalMultimediaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/ModalMultimediaCtrl.js","./controladores/cacheNotaCtrls.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/cacheNotaCtrls.js","./controladores/formGuionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/formGuionCtrl.js","./controladores/listadoGuionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/listadoGuionCtrl.js","./controladores/listadoNotaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/listadoNotaCtrl.js","./controladores/monitoreoCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/monitoreoCtrl.js","./controladores/printPrensaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/printPrensaCtrl.js","./controladores/rest/guionAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/rest/guionAPI.js","./controladores/rest/notaAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/rest/notaAPI.js","./controladores/servicios/listaNotas.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/controladores/servicios/listaNotas.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/modelos/guion.js":[function(require,module,exports){
"use strict";

module.exports = Guion;

function Guion( fecha, tipoMedio, medio, programa, edicion, _id ) {
  this.fecha = fecha || moment();
  this.tipoMedio = tipoMedio || null;
  this.medio = medio || null;
  this.programa = programa || null;
  this.edicion = edicion || null;
  this._id = _id;
}

Guion.cargar = cargar;

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Guion( json.fecha, json.tipoMedio, json.medio,
     json.programa, json.edicion, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/modelos/nota.js":[function(require,module,exports){
"use strict";

module.exports = Nota;

function Nota( hora, fecha, seccion, tamanio, numPagina, titulo, clientes,
  entidades, personajes, etiquetasTematicas, etiquetas, guionId, transcripcion,
  multimedia, duracion, tema, fuente, calificacionEntidad, _id, createdAt, url ) {
  this.hora = hora;
  this.fecha = fecha;
  this.seccion = seccion || null;
  this.tamanio = tamanio || null;
  this.numPagina = numPagina || null;
  this.titulo = titulo || null;
  this.clientes = clientes || [];
  this.entidades = entidades || [];
  this.personajes = personajes || [];
  this.etiquetasTematicas = etiquetasTematicas || [];
  this.etiquetas = etiquetas || [];
  this.guionId = guionId;
  this.transcripcion = transcripcion || false;
  this.multimedia = multimedia;
  this.duracion = duracion;
  this.tema = tema;
  this.fuente = fuente;
  this.calificacionEntidad = calificacionEntidad || [];
  this._id = _id;
  this.createdAt = createdAt;
  this.url = url || null;
}

Nota.cargar = cargar;
Nota.buscarClientes = buscarClientes;
Nota.prototype.agregarEntidades = agregarEntidades;
Nota.prototype.agregarPersonajes = agregarPersonajes;
Nota.prototype.agregarClientes = agregarClientes;
Nota.prototype.agregarEtiqueta = agregarEtiqueta;
Nota.prototype.agregarEtiquetaTematica = agregarEtiquetaTematica;
Nota.prototype.removerCliente = removerCliente;
Nota.prototype.removerPersonaje = removerPersonaje;
Nota.prototype.removerEntidad = removerEntidad;
Nota.prototype.removerEtiqueta = removerEtiqueta;
Nota.prototype.removerEtiquetaTematica = removerEtiquetaTematica;
Nota.prototype.agregarArchivo = agregarArchivo;
Nota.prototype.removerArchivo = removerArchivo;

function instanciar( json ) {
  return new Nota( json.hora, json.fecha, json.seccion, json.tamanio,
  json.numPagina, json.titulo, json.clientes, json.entidades, json.personajes,
  json.etiquetasTematicas, json.etiquetas, json.guionId, json.transcripcion,
  json.multimedia, json.duracion, json.tema, json.fuente,
  json.calificacionEntidad, json._id, json.createdAt, json.url );
}

function agregarClientes( clientes ) {
  clientes = _.map( clientes, function( cliente ) {
    return {
      _id: cliente._id,
      mencion: cliente.mencion || "Directa",
      logo: cliente.logo || false,
      sentimiento: cliente.sentimiento || "positiva",
      ignorar: cliente.ignorar || false,
      relaciones: cliente.relaciones || []
    };
  } );
  this.clientes = clientes;
}

function agregarArchivo( archivo, duracion ) {
  this.multimedia = archivo._id;
  this.duracion = duracion;
}

function removerArchivo() {
  delete this.multimedia;
}

function agregarPersonajes( personajes ) {
  personajes = _.map( personajes, function( personaje ) {
    return {
      _id: personaje._id,
      mencion: personaje.mencion || false
    };
  } );
  this.personajes = personajes;
}

function agregarEntidades( entidades ) {
  entidades = _.map( entidades, function( entidad ) {
    return {
      _id: entidad._id,
      mencion: entidad.mencion || false,
      logo: entidad.logo || false
    };
  } );
  this.entidades = entidades ;
}

function agregarEtiquetaTematica ( etiqueta ) {
  if ( _.isString( etiqueta ) ) {
    this.etiquetasTematicas = _.union( this.etiquetasTematicas, [ etiqueta ] );
  }
}

function agregarEtiqueta ( etiqueta ) {
  if ( _.isString( etiqueta ) ) {
    this.etiquetas = _.union( this.etiquetas, [ etiqueta ] );
  }
}

function removerCliente ( id ) {
  _.remove( this.clientes, function( cliente ) {
    return cliente._id === id;
  } );
}

function removerPersonaje ( id ) {
  this.personajes = _.without( this.personajes, id );
}

function removerEntidad ( id ) {
  this.entidades = _.without( this.entidades, id );
}

function removerEtiqueta ( etiqueta ) {
  this.etiquetas = _.without( this.etiquetas, etiqueta );
}

function removerEtiquetaTematica( etiqueta ) {
  this.etiquetasTematicas = _.without( this.etiquetasTematicas, etiqueta );
}

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

/* Estas funciones fueron trasladadas tal y como estaban desde cacheNotaCtrls.js
para poder ser utilizadas también en el módulo de Redes Sociales/Medios Digitales */
function buscarClientes( id, clientes, self, tipoMedio, Util ) {
  var clientesMatch = _.filter( _.map( clientes, function( temp ) {
    var clientesEnNota = _.find( self.clientes, {_id: id} );
    var cliente = clientesEnNota ? clientesEnNota : temp;
    // busca solamente si el cliente recibe del tipo de medio actual
    if ( cliente.medios[tipoMedio] || tipoMedio === "Medios Digitales" ||
    tipoMedio === "Redes Sociales" ) {
      var entidad = _.find( cliente.entidades, function( ent ) {
        return ( ent._id === id );
      } );
      var personaje = _.find( cliente.personajes, function( per ) {
        return ( per._id === id );
      } );
      var tema = _.find( cliente.temas, function( tem ) {
        if ( tem ) {
          return Util.comparar( tem, id );
        }
      } );
      if ( !_.isUndefined( entidad ) ) {
        return setMencion( entidad, cliente );
      }
      if ( !_.isUndefined( personaje ) ) {
        return setMencion( personaje, cliente );
      }
      if ( !_.isUndefined( tema ) ) {
        if ( !cliente.mencion ) {
          cliente.mencion = "Contexto";
        }
        cliente.relaciones = _.union( cliente.relaciones,
          [ {relacion:tema, tipoRelacion:cliente.mencion} ] );
        return cliente;
      }
    }
  } ), function( ele ) {
    return !_.isUndefined( ele );
  } );
  _.forEach( clientesMatch, function( cliente ) {
    if ( !tieneCliente( self.clientes, cliente ) ) {
      self.clientes.push( cliente );
    } else {
      self.clientes = _.map( self.clientes, unirRelaciones( cliente ) );
    }
  } );
}

function unirRelaciones( clienteAAgregar ) {
  return function( clienteNota ) {
    if ( clienteNota._id.toString() === clienteAAgregar._id.toString() ) {
      var cliente = getClienteConMayorRelacion(clienteNota, clienteAAgregar);
      var temp = _.cloneDeep( cliente );
      temp.relaciones = _.union( clienteNota.relaciones, clienteAAgregar.relaciones );
      return temp;
    } else {
      return clienteNota;
    }
  };
}

function getClienteConMayorRelacion(clienteNota, clienteAAgregar) {
  var relaciones = ["Contexto", "Competencia", "Directa"];
  if (_.indexOf(relaciones, clienteNota.mencion) > _.indexOf(relaciones, clienteAAgregar.mencion)) {
    return clienteNota;
  }
  return clienteAAgregar;
}

function setRelaciones( id, cliente ) {
  cliente.relaciones = ( _.isUndefined( cliente.relaciones ) ) ? [] : cliente.relaciones;
  if ( _.isEmpty( cliente.relaciones ) ) {
    cliente.relaciones.push( {relacion:id, tipoRelacion:cliente.mencion} );
  } else {
    cliente.relaciones = _.union( cliente.relaciones,
      [ {relacion:id, tipoRelacion:cliente.mencion} ] );
  }
  return cliente;
}

function setMencion( obj, cliente ) {
  if ( _.isUndefined( cliente.mencion ) ) {
    cliente.mencion = obj.tipoRelacion;
  } else {
    if ( cliente.mencion === "Contexto" ) {
      cliente.mencion = obj.tipoRelacion;
    } else if ( cliente.mencion === "Competencia" ) {
      if ( obj.tipoRelacion === "Directa" ) {
        cliente.mencion = obj.tipoRelacion;
      }
    }
  }
  return setRelaciones( obj._id, cliente );
}

function tieneCliente( clientes, clienteNuevo ) {
  return _.any( clientes, function( cliente ) {
    return cliente._id.toString() === clienteNuevo._id.toString();
  } );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/monitoreo/rutas.js":[function(require,module,exports){
'use strict'

module.exports = rutas

rutas.$inject = ['$stateProvider']

function rutas($stateProvider) {
  $stateProvider.state('inicio.monitoreo', {
    templateUrl: 'monitoreo/vistas/inicio.html',
    url: '/monitoreo?pagina&cantidad?edicion?medio?programa?fechaInicio&fechaFin',
    params: {
      filtroRevision: null,
      origen: null,
    },
    controller: 'ListadoGuionCtrl',
    controllerAs: 'vm',
    resolve: {
      listadoGuiones: listarGuion,
    },
    data: {
      titulo: 'Módulo Monitoreo',
      icono: 'fa-eye',
      menu: 'Monitoreo',
    },
  })

  $stateProvider.state('inicio.monitoreo.guion-uno', {
    url: '/guion/:id?editar&tipoMedio&notas&pagina&cantidad',
    views: {
      '': {
        templateUrl: 'monitoreo/vistas/formGuion.html',
        controller: 'FormGuionCtrl',
        controllerAs: 'fgc',
        resolve: {
          guion: obtenerGuion,
          medios: listarMedios,
        },
        data: {
          titulo: 'Form de Guion',
          icono: 'fa-file-o',
          menu: 'Form Guion',
        },
      },
      notaForm: {
        templateUrl: 'monitoreo/vistas/formNota.html',
        controller: 'CacheNotaCtrl',
        controllerAs: 'cnn',
        resolve: {
          nota: obtenerNota,
        },
      },
      notaLista: {
        templateUrl: 'monitoreo/vistas/listaNota.html',
        controller: 'ListadoNotaCtrl',
        controllerAs: 'lnc',
        resolve: {
          listado: listarNota,
        },
      },
    },
  })

  $stateProvider.state('inicio.monitoreo.nota-uno', {
    templateUrl: 'monitoreo/vistas/formNota.html',
    url: '/nota/:id/:notaId?tipoMedio&notas&editarNota',
    params: {
      filtroRevision: null,
      origen: null,
    },
    controller: 'CacheNotaCtrl',
    controllerAs: 'cnn',
    resolve: {
      nota: obtenerNota,
    },
    data: {
      titulo: 'Form de Nota',
      icono: 'fa-file-o',
      menu: 'Form Nota',
    },
  })

  $stateProvider.state('inicio.monitoreo.guion-impresion', {
    templateUrl: 'monitoreo/vistas/printPrensa.html',
    url: '/guionImpresion/:id',
    params: {
      guion: null,
    },
    controller: 'PrintPrensaCtrl',
    controllerAs: 'vm',
    resolve: {
      secciones: obtenerSecciones,
    },
    data: {
      titulo: 'Impresión de Guión',
      icono: 'fa-print',
      menu: 'Impresión Guión',
    },
  })

  listarGuion.$inject = ['GuionAPI', '$stateParams', '$auth', '$q']
  function listarGuion(GuionAPI, $stateParams, $auth, $q) {
    if ($auth.getPayload().permisos.guion.listar) {
      return GuionAPI.listar(
        $stateParams.pagina || 0,
        $stateParams.cantidad || 10,
        true,
        $stateParams.edicion,
        $stateParams.medio,
        $stateParams.programa,
        $stateParams.fechaInicio,
        $stateParams.fechaFin
      ).then(function (guiones) {
        guiones.docs = _.map(guiones.docs, function (guion) {
          if (!_.isNull(guion.programa)) {
            guion.edicion = _.find(
              guion.programa.ediciones,
              function (edicion) {
                return guion.edicion === edicion._id
              }
            )
          }
          return guion
        })
        return guiones
      })
    }
    return $q.reject({ autenticado: false })
  }

  obtenerGuion.$inject = ['GuionAPI', '$stateParams', 'Validaciones', '$q']
  function obtenerGuion(GuionAPI, $stateParams, Validaciones, $q) {
    if (Validaciones.dejarPasar($stateParams, 'guion')) {
      return GuionAPI.obtener($stateParams.id, $stateParams.editar)
    }
    return $q.reject({ autenticado: false })
  }

  listarMedios.$inject = ['MedioAPI', '$stateParams']
  function listarMedios(MedioAPI, $stateParams) {
    var tipoMedio = $stateParams.tipoMedio
    return MedioAPI.listar(0, 75, undefined, tipoMedio)
  }

  listarNota.$inject = ['NotaAPI', '$stateParams', '$auth', '$q', 'ListaNotas']
  function listarNota(NotaAPI, $stateParams, $auth, $q, ListaNotas) {
    if ($auth.getPayload().permisos.nota.listar) {
      if (!_.isEmpty($stateParams.id)) {
        return NotaAPI.listar(0, 1000, $stateParams.id).then(function (resp) {
          ListaNotas.notas = resp
          ListaNotas.ordenar($stateParams.tipoMedio === 'Prensa')
        })
      } else {
        return { docs: [], contador: 0 }
      }
    }
    return $q.reject({ autenticado: false })
  }

  obtenerNota.$inject = ['NotaAPI', '$stateParams', 'Validaciones', '$q']
  function obtenerNota(NotaAPI, $stateParams, Validaciones, $q) {
    if (Validaciones.dejarPasar($stateParams, 'nota')) {
      return NotaAPI.obtener($stateParams.notaId, $stateParams.editar)
    }
    return $q.reject({ autenticado: false })
  }

  obtenerSecciones.$inject = ['SeccionAPI', '$stateParams']
  function obtenerSecciones(SeccionAPI, $stateParams) {
    return SeccionAPI.obtenerSeccionesMedioSinBarra(
      $stateParams.guion.medio._id
    ).then(function (secs) {
      return _.reduce(
        secs.docs,
        function (result, sec) {
          result[sec._id] = {
            nombre: sec.nombre,
            publicity: sec.publicity,
          }
          return result
        },
        {}
      )
    })
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/ModalEmailCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ModalEmailCtrl;
ModalEmailCtrl.$inject = [ "cliente", "idNotas", "ReporteAPI", "$modalInstance" ];
function ModalEmailCtrl( cliente, idNotas, ReporteAPI, $modalInstance ) {
  var mc = this;
  mc.correos = [];
  mc.correosInvalidos = [];
  mc.formulario = { untouch: true };
  mc.cerrar = cerrar;
  mc.agregarMultiplesCorreo = agregarMultiplesCorreo;
  mc.borrarCorreo = borrarCorreo;
  mc.enviar = enviar;
  validarDatos();

  function cerrar() {
    $modalInstance.dismiss( "cancel" );
  }

  function agregarCorreo( correo ) {
    var email = correo.trim();
    if ( /[^\s@]+@[^\s@]+\.[^\s@]{2,}/.test( email ) ) {
      mc.correos.push( email );
    } else {
      mc.correosInvalidos.push( email );
    }
  }

  function agregarMultiplesCorreo( correos ) {
    if ( correos ) {
      mc.correosInvalidos = [];
      _.forEach( correos.split( /,\s|,/ ), function( correo ) {
        agregarCorreo( correo );
      } );
      delete mc.correo;
      validarDatos();
    }
  }

  function borrarCorreo( correo ) {
    mc.correos = _.reject( mc.correos, function( c ) { return c === correo; } );
    validarDatos();
  }

  function validarDatos() {
    mc.sinCorreos = _.isEmpty( mc.correos );
  }

  function enviar() {
    mc.formulario.untouch = false;
    if ( !mc.sinCorreos ) {
      ReporteAPI.enviarNotasCorreo( cliente, idNotas, mc.correos, function( resp ) {
        cierreExitoso( resp.data );
      }, function( ) {
        cerrar();
      } );
    }
  }

  function cierreExitoso( data ) {
    $modalInstance.close( data );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/ModalNotaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ModalNotaCtrl;
ModalNotaCtrl.$inject = [
  "nota",
  "cliente",
  "ArchivoAPI",
  "SeccionAPI",
  "$modalInstance"
];

function ModalNotaCtrl( nota, cliente, ArchivoAPI, SeccionAPI, $modalInstance ) {
  var mc = this;
  mc.nota = nota;
  mc.cerrar = cerrar;

  cargarDatos();

  function cargarDatos() {
    if ( mc.nota.seccion ) {
      SeccionAPI.obtener( mc.nota.seccion )
      .then( function( resp ) {
        mc.nota.seccionNombre = resp.nombre;
      } );
    } else if ( mc.nota.guionId.edicion ) {
      mc.edicion = mc.nota.guionId.edicion.nombre;
    }

    mc.clienteRelativo = _.find( mc.nota.clientes, function( cl ) {
      return cl._id._id === cliente;
    } );

    mc.otrosClientes = _.reject( mc.nota.clientes, function( cl ) {
      return cl._id._id === cliente;
    } );

    //cargar multimedia
    if ( !( _.isUndefined( mc.nota.multimedia ) || _.isNull( mc.nota.multimedia ) ) ) {
      ArchivoAPI.obtenerSinBarra( mc.nota.multimedia )
        .then( function( resp ) {
          mc.multimedia = {
            archivo: resp,
            tipo: _.head( resp.mymeType.split( "/" ) )
          };
        } );
    }
  }

  function cerrar() {
    $modalInstance.dismiss( "cancel" );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteEmailCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReporteNotaCtrl;

ReporteNotaCtrl.$inject = [
  "SeccionAPI",
  "ReporteAPI",
  "ClienteAPI",
  "TranscripcionAPI",
  "Notificaciones",
  "$state",
  "$modal",
  "$timeout"
];

function ReporteNotaCtrl( SeccionAPI, ReporteAPI, ClienteAPI,
  TranscripcionAPI, Notificaciones, $state, $modal, $timeout ) {
  var vm = this;
  vm.actualizarPagina = actualizarPagina;
  vm.fechasValidas = fechasValidas;
  vm.tiposValidos = tiposValidos;
  vm.cambioATodos = cambioATodos;
  vm.buscar = buscar;
  vm.limpiarFiltros = limpiar;
  vm.cargarCliente = cargarCliente;
  vm.todoSeleccionado = todoSeleccionado;
  vm.algoSeleccionado = algoSeleccionado;
  vm.nadaSeleccionado = nadaSeleccionado;
  vm.cambiarInclusion = cambiarInclusion;
  vm.mostrarModalEmail = mostrarModalEmail;
  vm.mostrarModalNota = mostrarModalNota;
  vm.generacion = { untouch: true };
  vm.abrir = abrir;
  vm.checkAll = true;
  vm.datepickerConfig = {
    maxdate: new Date()
  };

  limpiar();

  function limpiar( filtrosForm ) {
    if ( filtrosForm ) {
      vm.filtro.cliente = null;
      filtrosForm.$setUntouched();
      filtrosForm.$setPristine();
    } else {
      $timeout( function() {
        angular.element( document.getElementById( "limpiar" ) ).triggerHandler( "click" );
      }, 0 );
    }
    vm.listado = { docs: [], contador: 0 };
    vm.filtro = {
      fechaInicio: {
        fecha: new Date(),
        open: false
      },
      fechaFin: {
        fecha: new Date(),
        open: false
      },
      tipoMencion: {
        directa: false,
        contexto: false,
        competencia: false
      },
      tipoMedio: {
        television: false,
        radio: false,
        prensa: false
      }
    };
  }

  function fechasValidas() {
    return vm.filtro.fechaInicio.fecha <= vm.filtro.fechaFin.fecha;
  }

  function tiposValidos() {
    var tipos = vm.filtro.tipo;
    return tipos.directa || tipos.contexto || tipos.competencia;
  }

  function cambioATodos() {
    if ( vm.todosLosClientes ) {
      delete vm.filtro.cliente;
    }
  }

  function abrir( fecha ) {
    fecha.open = true;
  }

  function buscar( filtrosForm ) {
    if ( filtrosForm.$valid && fechasValidas() ) {
      var cliente = ( vm.filtro.cliente ) ? vm.filtro.cliente._id : undefined;
      ReporteAPI.notas( cliente, moment( vm.filtro.fechaInicio.fecha ),
          moment( vm.filtro.fechaFin.fecha ), vm.filtro.tipoMencion, vm.filtro.tipoMedio,
          vm.filtro.texto )
        .then( function( response ) {
          vm.checkAll = true;
          vm.listado.docs = _.map( response.docs, function( nota ) {
            if ( nota.seccion ) {
              nota.seccionNombre = nota.seccion.nombre;
            }
            if ( nota.guionId.tipoMedio !== "Prensa" ) {
              nota.guionId.edicion = obtenerEdicion( nota );
            }
            nota.incluir = true;
            return nota;
          } );
          vm.listado.contador = response.contador;
          vm.generacion = { untouch: true };
          var conTrans = _.filter( response.docs, function( n ) { return n.transcripcion; } );
          buscarTranscripciones( _.pluck( conTrans, "_id" ) );
        } );
    }
  }

  function buscarTranscripciones( idNotas ) {
    TranscripcionAPI.obtenerDesdeNotas( idNotas ).then( mapearTranscripciones );
  }

  function mapearTranscripciones( transcripciones ) {
    _.forEach( transcripciones, function( transcripcion ) {
      var nota = _.find( vm.listado.docs, function( n ) {
        return n._id === transcripcion.notaId;
      } );
      nota.trans = transcripcion;
    } );
  }

  function obtenerEdicion( nota ) {
    var guion = nota.guionId;
    return _.find( guion.programa.ediciones, function( edicion ) {
      return edicion._id === guion.edicion;
    } );
  }

  function actualizarPagina() {
    $state.go( $state.current, {}, {reload: false} );
  }

  function cargarCliente( texto ) {
    return ClienteAPI.listarSinBarra( 0, 10, texto )
      .then( function( response ) {
        return response.docs;
      } );
  }

  function todoSeleccionado() {
    return _.every( vm.listado.docs, "incluir" );
  }

  function algoSeleccionado() {
    return _.any( vm.listado.docs, "incluir" );
  }

  function nadaSeleccionado() {
    return !algoSeleccionado();
  }

  function cambiarInclusion() {
    var nuevoEstado = !todoSeleccionado();
    vm.checkAll = nuevoEstado;
    _.forEach( vm.listado.docs, function( doc ) {
      doc.incluir = nuevoEstado;
    } );
  }

  function notasSeleccionadas() {
    var selecionados = _.filter( vm.listado.docs, "incluir" );
    return _.pluck( selecionados, "_id" );
  }

  function mostrarModalEmail() {
    var modalEmail = $modal.open( {
      templateUrl: "reportes/vistas/modalEmail.html",
      controller: "ModalEmailCtrl",
      resolve: {
        idNotas: notasSeleccionadas,
        cliente: function() {
          return vm.filtro.cliente ? vm.filtro.cliente._id : vm.filtro.cliente;
        }
      },
      controllerAs: "mc"
    } );
    modalEmail.result.then( function() {
      Notificaciones.agregarPersonalizado( 200,
        "Las notas se han puesto en la cola de envío en el servidor de correos." );
      limpiar();
    } );
  }

  function mostrarModalNota( nota ) {
    $modal.open( {
      templateUrl: "reportes/vistas/modalNota.html",
      controller: "ModalNotaCtrl",
      size: "lg",
      resolve: {
        nota: nota,
        cliente: function() {
          return vm.filtro.cliente ? vm.filtro.cliente._id : vm.filtro.cliente;
        }
      },
      controllerAs: "mc"
    } );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteMultimediaCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReporteMultimediaCtrl;

ReporteMultimediaCtrl.$inject = [
  "ReporteAPI",
  "ClienteAPI",
  "SeccionAPI",
  "$state",
  "$timeout"
];

function ReporteMultimediaCtrl( ReporteAPI, ClienteAPI, SeccionAPI, $state,
  $timeout ) {

  var vm = this;
  vm.actualizarPagina = actualizarPagina;
  vm.fechasValidas = fechasValidas;
  vm.tiposValidos = tiposValidos;
  vm.cambioATodos = cambioATodos;
  vm.buscar = buscar;
  vm.limpiarFiltros = limpiar;
  vm.cargarCliente = cargarCliente;
  vm.generar = generarReporte;
  vm.todoSeleccionado = todoSeleccionado;
  vm.algoSeleccionado = algoSeleccionado;
  vm.nadaSeleccionado = nadaSeleccionado;
  vm.cambiarInclusion = cambiarInclusion;
  vm.generacion = { untouch: true };
  vm.abrir = abrir;
  vm.datepickerConfig = {
    maxdate: new Date()
  };

  limpiar();

  function limpiar( filtrosForm ) {
    if ( filtrosForm ) {
      filtrosForm.$setUntouched();
      filtrosForm.$setPristine();
    } else {
      $timeout( function() {
        angular.element( document.getElementById( "limpiar" ) ).triggerHandler( "click" );
      }, 0 );
    }
    vm.listado = { docs: [], contador: 0 };
    vm.filtro = {
      fechaInicio: {
        fecha: new Date(),
        open: false
      },
      fechaFin: {
        fecha: new Date(),
        open: false
      },
      tipoMencion: {
        directa: false,
        contexto: false,
        competencia: false
      },
      tipoMedio: {
        television: false,
        radio: false,
        prensa: false
      }
    };
  }

  function fechasValidas() {
    return vm.filtro.fechaInicio.fecha <= vm.filtro.fechaFin.fecha;
  }

  function tiposValidos() {
    var tipos = vm.filtro.tipo;
    return tipos.directa || tipos.contexto || tipos.competencia;
  }

  function cambioATodos() {
    if ( vm.todosLosClientes ) {
      delete vm.filtro.cliente;
    }
  }

  function abrir( fecha ) {
    fecha.open = true;
  }

  function buscar( filtrosForm ) {
    if ( filtrosForm.$valid && fechasValidas() ) {
      var cliente = ( vm.filtro.cliente ) ? vm.filtro.cliente._id : undefined;
      ReporteAPI.multimedia( cliente, moment( vm.filtro.fechaInicio.fecha ),
          moment( vm.filtro.fechaFin.fecha ), vm.filtro.tipoMencion, vm.filtro.tipoMedio,
          vm.filtro.texto )
        .then( function( response ) {
          vm.listado.docs = _.map( response.docs, function( nota ) {
            if ( nota.seccion ) {
              nota.seccionNombre = nota.seccion.nombre;
            }
            if ( nota.guionId.tipoMedio === "Televisión" || nota.guionId.tipoMedio === "Radio" ) {
              nota.guionId.edicion = obtenerEdicion( nota );
            }
            nota.incluir = true;
            vm.checkAll = true;
            return nota;
          } );
          vm.listado.contador = response.contador;
        } );
    }
  }

  function obtenerEdicion( nota ) {
    var guion = nota.guionId;
    return _.find( guion.programa.ediciones, function( edicion ) {
      return edicion._id === guion.edicion;
    } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad}, {reload: false} );
  }

  function cargarCliente( texto ) {
    return ClienteAPI.listarSinBarra( 0, 10, texto )
      .then( function( response ) {
        return response.docs;
      } );
  }

  function todoSeleccionado() {
    return _.every( vm.listado.docs, "incluir" );
  }

  function algoSeleccionado() {
    return _.any( vm.listado.docs, "incluir" );
  }

  function nadaSeleccionado() {
    return !algoSeleccionado();
  }

  function cambiarInclusion() {
    var nuevoEstado = !todoSeleccionado();
    _.forEach( vm.listado.docs, function( doc ) {
      doc.incluir = nuevoEstado;
    } );
  }

  function generarReporte() {
    vm.generacion.untouch = false;
    if ( algoSeleccionado() && fechasValidas() ) {
      var servirArchivo = require( "../modelos/servirArchivo.js" ).curry;
      var selecionados = _.filter( vm.listado.docs, "incluir" );
      var ids = _.pluck( selecionados, "_id" );
      var cliente = ( vm.filtro.cliente ) ? vm.filtro.cliente._id : undefined;
      ReporteAPI.multimediaGenerar( cliente, ids )
        .then( servirArchivo( "text/plain", "multimedia.txt" ) );
    }
  }

}

},{"../modelos/servirArchivo.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/modelos/servirArchivo.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteNotaCtrl.js":[function(require,module,exports){
"use strict";

var si = require( "../../base/selectorItems.js" );

module.exports = ReporteNotaCtrl;

ReporteNotaCtrl.$inject = [
  "ReporteAPI",
  "ClienteAPI",
  "SeccionAPI",
  "$state",
  "$timeout",
  "$stateParams"
];

function ReporteNotaCtrl( ReporteAPI, ClienteAPI, SeccionAPI, $state, $timeout, $stateParams ) {

  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 50 );
  vm.actualizarPagina = actualizarPagina;
  vm.fechasValidas = fechasValidas;
  vm.tiposValidos = tiposValidos;
  vm.cambioATodos = cambioATodos;
  vm.buscar = buscar;
  vm.limpiarFiltros = limpiar;
  vm.cargarCliente = cargarCliente;
  vm.generar = generarReporte;
  vm.algoSeleccionado = algoSeleccionado;
  vm.nadaSeleccionado = nadaSeleccionado;
  vm.cambiarInclusion = si.cambiarInclusion;
  vm.generacion = { untouch: true };
  vm.abrir = abrir;
  vm.datepickerConfig = {
    maxdate: new Date()
  };
  vm.buscarFiltro = buscarFiltro;
  vm.notasExcluidas = {};
  vm.excluir = si.excluir;

  limpiar();

  function limpiar( filtrosForm ) {
    if ( filtrosForm ) {
      filtrosForm.$setUntouched();
      filtrosForm.$setPristine();
    } else {
      $timeout( function() {
        angular.element( document.getElementById( "limpiar" ) ).triggerHandler( "click" );
      }, 0 );
    }
    vm.listado = { docs: [], contador: 0 };
    vm.filtro = {
      fechaInicio: {
        fecha: new Date(),
        open: false
      },
      fechaFin: {
        fecha: new Date(),
        open: false
      },
      tipoMencion: {
        directa: false,
        contexto: false,
        competencia: false
      },
      tipoMedio: {
        television: false,
        radio: false,
        prensa: false
      }
    };
  }

  function fechasValidas() {
    return vm.filtro.fechaInicio.fecha <= vm.filtro.fechaFin.fecha;
  }

  function tiposValidos() {
    var tipos = vm.filtro.tipo;
    return tipos.directa || tipos.contexto || tipos.competencia;
  }

  function cambioATodos() {
    if ( vm.todosLosClientes ) {
      delete vm.filtro.cliente;
    }
  }

  function abrir( fecha ) {
    fecha.open = true;
  }

  function buscar( pagina ) {
    var cliente = ( vm.filtro.cliente ) ? vm.filtro.cliente._id : undefined;
    ReporteAPI.notas( cliente, moment( vm.filtro.fechaInicio.fecha ),
      moment( vm.filtro.fechaFin.fecha ), vm.filtro.tipoMencion, vm.filtro.tipoMedio,
      vm.filtro.texto, pagina * vm.cantidad, vm.cantidad )
    .then( function( response ) {
      vm.listado.docs = _.map( response.docs, function( nota ) {
        if ( nota.seccion ) {
          nota.seccionNombre = nota.seccion.nombre;
        }
        if ( nota.guionId.tipoMedio !== "Prensa" ) {
          nota.guionId.edicion = obtenerEdicion( nota );
        }
        nota.incluir = _.get( vm.notasExcluidas[vm.pagina], nota._id, true );
        return nota;
      } );
      vm.checkAll = si.todoSeleccionado( vm.listado.docs );
      vm.listado.contador = response.contador;
      vm.generacion = { untouch: true };
    } );
  }

  function obtenerEdicion( nota ) {
    var guion = nota.guionId;
    if ( guion.programa ) {
      return _.find( guion.programa.ediciones, function( edicion ) {
        return edicion._id === guion.edicion;
      } );
    } else {
      return "N/A";
    }

  }

  function actualizarPagina( pagina ) {
    buscar( pagina );
  }

  function buscarFiltro( filtrosForm ) {
    vm.notasExcluidas = {};
    if ( filtrosForm.$valid && fechasValidas() ) {
      vm.pagina = 1;
      buscar( vm.pagina - 1 );
    }
  }

  function cargarCliente( texto ) {
    return ClienteAPI.listarSinBarra( 0, 10, texto )
      .then( function( response ) {
        return response.docs;
      } );
  }

  function algoSeleccionado() {
    return _.any( vm.listado.docs, "incluir" );
  }

  function nadaSeleccionado() {
    return !algoSeleccionado();
  }

  function generarReporte() {
    vm.generacion.untouch = false;
    if ( algoSeleccionado() && fechasValidas() ) {
      var servirArchivo = require( "../modelos/servirArchivo.js" ).curryExcel;
      var ids = si.getIdsExcluidos( vm.notasExcluidas );
      var cliente = ( vm.filtro.cliente ) ? vm.filtro.cliente._id : undefined;
      ReporteAPI.notasGenerar( cliente, ids, vm.filtro.fechaInicio.fecha, vm.filtro.fechaFin.fecha,
        vm.filtro.tipoMencion, vm.filtro.tipoMedio, vm.filtro.texto )
      .then( servirArchivo( "reporteNotas.xlsx" ) );
    }
  }

}

},{"../../base/selectorItems.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/base/selectorItems.js","../modelos/servirArchivo.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/modelos/servirArchivo.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reportePagoTranscripcionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReportePagoTranscripcionCtrl;

ReportePagoTranscripcionCtrl.$inject = [ "ReporteAPI", "$timeout" ];
function ReportePagoTranscripcionCtrl( ReporteAPI, $timeout ) {
  var vm = this;
  vm.fechasValidas = fechasValidas;
  vm.buscar = buscar;
  vm.limpiarFiltros = limpiar;
  vm.abrir = abrir;
  vm.totalCaracteres = totalCaracteres;
  vm.datepickerConfig = {
    maxdate: new Date()
  };

  limpiar();

  function limpiar( filtrosForm ) {
    if ( filtrosForm ) {
      filtrosForm.$setUntouched();
      filtrosForm.$setPristine();
    } else {
      $timeout( function() {
        angular.element( document.getElementById( "limpiar" ) ).triggerHandler( "click" );
      }, 0 );
    }
    vm.filtro = {
      fechaInicio: {
        fecha: new Date(),
        open: false
      },
      fechaFin: {
        fecha: new Date(),
        open: false
      },
      precio: 0
    };
  }

  function fechasValidas() {
    return vm.filtro.fechaInicio.fecha <= vm.filtro.fechaFin.fecha;
  }

  function abrir( fecha ) {
    fecha.open = true;
  }

  function buscar( filtrosForm ) {
    if ( filtrosForm.$valid && fechasValidas() ) {
      ReporteAPI.pagoTranscripcion( moment( vm.filtro.fechaInicio.fecha ),
          moment( vm.filtro.fechaFin.fecha ), vm.filtro.precio )
        .then( function(resp){
          vm.transcripciones = resp;
        } );
    }
  }

  function totalCaracteres(porFecha){
    return _.foldl(porFecha, function(total, n){
      return total + n;
    }, 0);
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteRankingCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReporteNotaCtrl;

ReporteNotaCtrl.$inject = [ "ReporteAPI", "$timeout" ];
function ReporteNotaCtrl( ReporteAPI, $timeout ) {
  var vm = this;
  vm.fechasValidas = fechasValidas;
  vm.limpiarFiltros = limpiar;
  vm.generar = generarReporte;
  vm.abrir = abrir;
  vm.datepickerConfig = {
    maxdate: new Date()
  };

  limpiar();

  function limpiar( filtrosForm ) {
    if ( filtrosForm ) {
      filtrosForm.$setUntouched();
      filtrosForm.$setPristine();
    } else {
      $timeout( function() {
        angular.element( document.getElementById( "limpiar" ) ).triggerHandler( "click" );
      }, 0 );
    }
    vm.filtro = {
      fechaInicio: {
        fecha: new Date(),
        open: false
      },
      fechaFin: {
        fecha: new Date(),
        open: false
      },
      tipo: "Entidades"
    };
  }

  function fechasValidas() {
    return vm.filtro.fechaInicio.fecha <= vm.filtro.fechaFin.fecha;
  }

  function abrir( fecha ) {
    fecha.open = true;
  }

  function generarReporte( form ) {
    if ( fechasValidas() && form.$valid ) {
      var servirArchivo = require("../modelos/servirArchivo.js").curryExcel;
      if ( vm.filtro.tipo === "Entidades" ) {
        ReporteAPI.generarRankingEntidades( vm.filtro.fechaInicio.fecha, vm.filtro.fechaFin.fecha )
          .then( servirArchivo( "rankingEntidades.xlsx" ) );
      }
      if ( vm.filtro.tipo === "Personajes" ) {
        ReporteAPI.generarRankingPersonajes( vm.filtro.fechaInicio.fecha, vm.filtro.fechaFin.fecha )
          .then( servirArchivo( "rankingPersonajes.xlsx" ) );
      }
    }
  }

}

},{"../modelos/servirArchivo.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/modelos/servirArchivo.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteTrancripcionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReporteTrancripcionCtrl;

ReporteTrancripcionCtrl.$inject = [ "ReporteAPI", "ClienteAPI", "$state",
"$timeout" ];
function ReporteTrancripcionCtrl( ReporteAPI, ClienteAPI, $state, $timeout ) {
  var vm = this;
  vm.actualizarPagina = actualizarPagina;
  vm.fechasValidas = fechasValidas;
  vm.cambioATodos = cambioATodos;
  vm.buscar = buscar;
  vm.limpiarFiltros = limpiar;
  vm.cargarCliente = cargarCliente;
  vm.generar = generarReporte;
  vm.todoSeleccionado = todoSeleccionado;
  vm.algoSeleccionado = algoSeleccionado;
  vm.nadaSeleccionado = nadaSeleccionado;
  vm.cambiarInclusion = cambiarInclusion;
  vm.generacion = { untouch: true };
  vm.abrir = abrir;
  vm.datepickerConfig = {
    maxdate: new Date()
  };

  limpiar();

  function limpiar( filtrosForm ) {
    if ( filtrosForm ) {
      filtrosForm.$setUntouched();
      filtrosForm.$setPristine();
    } else {
      $timeout( function() {
        angular.element( document.getElementById( "limpiar" ) ).triggerHandler( "click" );
      }, 0 );
    }
    vm.listado = { docs: [], contador: 0 };
    vm.filtro = {
      fechaInicio: {
        fecha: new Date(),
        open: false
      },
      fechaFin: {
        fecha: new Date(),
        open: false
      },
      tipoMencion: {
        directa: false,
        contexto: false,
        competencia: false
      },
      tipoMedio: {
        television: false,
        radio: false
      }
    };
  }

  function fechasValidas() {
    return vm.filtro.fechaInicio.fecha <= vm.filtro.fechaFin.fecha;
  }

  function cambioATodos() {
    if ( vm.todosLosClientes ) {
      delete vm.filtro.cliente;
    }
  }

  function abrir( fecha ) {
    fecha.open = true;
  }

  function buscar( filtrosForm ) {
    if ( filtrosForm.$valid && fechasValidas() ) {
      var cliente = ( vm.filtro.cliente ) ? vm.filtro.cliente._id : undefined;
      ReporteAPI.transacciones( cliente, moment( vm.filtro.fechaInicio.fecha ),
          moment( vm.filtro.fechaFin.fecha ), vm.filtro.tipoMencion, vm.filtro.tipoMedio,
          vm.filtro.texto )
        .then( function( response ) {
          vm.listado.docs = _.map( response.docs, function( trans ) {
            trans.notaId.guionId.edicion = obtenerEdicion( trans );
            trans.incluir = true;
            return trans;
          } );
          vm.checkAll = true;
          vm.listado.contador = response.contador;
          vm.generacion = { untouch: true };
        } );
    }
  }

  function obtenerEdicion( transcripcion ) {
    var guion = transcripcion.notaId.guionId;
    return _.find( guion.programa.ediciones, function( edicion ) {
      return edicion._id.toString() === guion.edicion;
    } );
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current, {pagina: pagina, cantidad: vm.cantidad}, {reload: false} );
  }

  function cargarCliente( texto ) {
    return ClienteAPI.listarSinBarra( 0, 10, texto )
      .then( function( response ) {
        return response.docs;
      } );
  }

  function todoSeleccionado() {
    return _.every( vm.listado.docs, "incluir" );
  }

  function algoSeleccionado() {
    return _.any( vm.listado.docs, "incluir" );
  }

  function nadaSeleccionado() {
    return !algoSeleccionado();
  }

  function cambiarInclusion() {
    var nuevoEstado = !todoSeleccionado();
    vm.checkAll = nuevoEstado;
    _.forEach( vm.listado.docs, function( doc ) {
      doc.incluir = nuevoEstado;
    } );
  }

  function generarReporte() {
    vm.generacion.untouch = false;
    if ( algoSeleccionado() && fechasValidas() ) {
      var servirArchivo = require("../modelos/servirArchivo.js").curry;
      var tipo = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      var seleccionados = _.filter( vm.listado.docs, "incluir" );
      var ids = _.pluck( seleccionados, "_id" );
      var cliente = ( vm.filtro.cliente ) ? vm.filtro.cliente._id : undefined;
      ReporteAPI.transaccionesGenerar( cliente, moment( vm.filtro.fechaInicio.fecha ),
          moment( vm.filtro.fechaFin.fecha ), ids, vm.filtro.tipo )
        .then( servirArchivo( tipo, "reporteTranscripciones.docx" ) );
    }
  }

}

},{"../modelos/servirArchivo.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/modelos/servirArchivo.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reportesCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ReportesCtrl;

ReportesCtrl.$inject = [];
function ReportesCtrl() {
  var mod = this;
  mod.fechaActual = moment();
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/rest/reporteAPI.js":[function(require,module,exports){
"use strict";

module.exports = ReporteAPI;

ReporteAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function ReporteAPI( urlApi, $http, Notificaciones ) {
  ReporteAPI.transacciones = transacciones;
  ReporteAPI.transaccionesGenerar = generarTransacciones;
  ReporteAPI.notasGenerar = generarNotas;
  ReporteAPI.notas = notas;
  ReporteAPI.multimediaGenerar = generarMultimedia;
  ReporteAPI.multimedia = multimedia;
  ReporteAPI.enviarNotasCorreo = enviarNotasCorreo;
  ReporteAPI.generarRankingEntidades = generarRanking( "Entidades" );
  ReporteAPI.generarRankingPersonajes = generarRanking( "Personajes" );
  ReporteAPI.pagoTranscripcion = pagoTranscripcion;
  return ReporteAPI;

  function ok( resp ) {
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Reporte" );
    return resp;
  }

  function postGenerico( url, cliente, fInicio, fFin, tipoMencion, tipoMedio, texto, others_params, options ) {
    var body = {
        cliente: cliente || false,
        fechaInicio: fInicio || null,
        fechaFin: fFin || null,
        tipoMencion: tipoMencion || null,
        tipoMedio: tipoMedio || null,
        texto: texto || null
      };
    _.assign( body, others_params || {} );
    return $http.post( urlApi + "/api/reporte/" + url, body, options || {} ).then( ok, err );
  }

  function transacciones( cliente, fInicio, fFin, tipoMencion, tipoMedio, texto ) {
    return postGenerico( "transcripcion", cliente, fInicio, fFin, tipoMencion, tipoMedio, texto );
  }

  function multimedia( cliente, fInicio, fFin, tipoMencion, tipoMedio, texto ) {
    return postGenerico( "multimedia", cliente, fInicio, fFin, tipoMencion, tipoMedio, texto );
  }

  /*function notas( cliente, fInicio, fFin, tipoMencion, tipoMedio, texto ) {
    return postGenerico( "nota", cliente, fInicio, fFin, tipoMencion, tipoMedio, texto );
  }*/

  function notas( cliente, fInicio, fFin, tipoMencion, tipoMedio, texto, yaCargados, limite ) {
    var body = {
      cliente: cliente || false,
      fechaInicio: fInicio || null,
      fechaFin: fFin || null,
      tipoMencion: tipoMencion || null,
      tipoMedio: tipoMedio || null,
      texto: texto || null,
      yaCargados: yaCargados || 0,
      limite: limite || 0
    };
    return $http.post( urlApi + "/api/guion/getGuiones/", body ).then( function( resp ) {
      return resp.data;
    }, err );
  }

  function generarTransacciones( cliente, fInicio, fFin, idTranscripciones, tipos ) {
    var others_params = {transcripciones: idTranscripciones, tipo: tipos};
    return postGenerico( "transcripcion/generar", cliente, fInicio, fFin, false, false, false, others_params, { responseType: "arraybuffer" } );
  }

  function generarNotas( cliente, idNotas, fInicio, fFin, tipoMencion, tipoMedio, texto ) {
    return postGenerico( "nota/generar", cliente, fInicio, fFin, tipoMencion, tipoMedio, texto, { notas: idNotas }, { responseType: "arraybuffer" } );
  }

  function generarMultimedia( cliente, idNotas ) {
    return postGenerico( "multimedia/generar", cliente, false, false, false, false, false, { notas: idNotas }, { responseType: "arraybuffer" } );
  }

  function generarRanking( tipo ) {
    return function( fInicio, fFin ) {
      return postGenerico( "ranking/" + tipo, false, fInicio, fFin, false, false, false, {}, { responseType: "arraybuffer" } );
    };
  }

  function pagoTranscripcion( fInicio, fFin, precio ) {
    return postGenerico( "pago/", false, fInicio, fFin, false, false, false, { precio: precio } );
  }

  function enviarNotasCorreo( cliente, idNotas, correos, okCB, errorCB ) {
    var body = {
      notas: idNotas,
      cliente: cliente,
      destinatarios: correos
    };
    return $http.post( urlApi + "/api/reporte/nota/enviarCorreo", body ).then( okCB, function( r ) {
      err( r );
      errorCB( r );
    } );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../package.json" ).name;

var modulo = angular.module( nombre + ".Reportes", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "ReporteNotaCtrl", require( "./controladores/reporteNotaCtrl.js" ) );
modulo.controller( "ModalNotaCtrl", require( "./controladores/ModalNotaCtrl.js" ) );
modulo.controller( "ReporteEmailCtrl", require( "./controladores/reporteEmailCtrl.js" ) );
modulo.controller( "ModalEmailCtrl", require( "./controladores/ModalEmailCtrl.js" ) );
modulo.controller( "ReporteRankingCtrl", require( "./controladores/reporteRankingCtrl.js" ) );
modulo.controller( "ReporteMultimediaCtrl", require( "./controladores/reporteMultimediaCtrl.js" ) );
modulo.controller( "ReportePagoTranscripcionCtrl", require( "./controladores/reportePagoTranscripcionCtrl.js" ) );
modulo.controller( "ReporteTrancripcionCtrl", require( "./controladores/reporteTrancripcionCtrl.js" ) );
modulo.controller( "ReportesCtrl", require( "./controladores/reportesCtrl.js" ) );
modulo.factory( "ReporteAPI", require( "./controladores/rest/reporteAPI.js" ) );

module.exports = modulo;

},{"../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/ModalEmailCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/ModalEmailCtrl.js","./controladores/ModalNotaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/ModalNotaCtrl.js","./controladores/reporteEmailCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteEmailCtrl.js","./controladores/reporteMultimediaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteMultimediaCtrl.js","./controladores/reporteNotaCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteNotaCtrl.js","./controladores/reportePagoTranscripcionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reportePagoTranscripcionCtrl.js","./controladores/reporteRankingCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteRankingCtrl.js","./controladores/reporteTrancripcionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reporteTrancripcionCtrl.js","./controladores/reportesCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/reportesCtrl.js","./controladores/rest/reporteAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/controladores/rest/reporteAPI.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/modelos/servirArchivo.js":[function(require,module,exports){
"use strict";

module.exports = {
  normal: servirArchivo,
  curry: curry,
  curryExcel: curryExcel
};

function servirArchivo( data, tipo, nombre ) {
  var blob = new Blob( [ data ], {
    type: tipo
  } );
  var url = URL.createObjectURL( blob );
  var elementoDescarga = document.createElement( "a" );
  document.body.appendChild( elementoDescarga );
  elementoDescarga.setAttribute( "type", "hidden" );
  elementoDescarga.href = url;
  elementoDescarga.target = "_blank";
  elementoDescarga.download = nombre;
  elementoDescarga.click();
}

function curry(tipo, nombre){
  return function(data){
    return servirArchivo(data, tipo, nombre);
  };
}

function curryExcel(nombre){
  return function(data){
    var tipo = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    return servirArchivo(data, tipo, nombre);
  };
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/reportes/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.reportes", {
    templateUrl: "reportes/vistas/inicio.html",
    url: "/reportes",
    controller: "ReportesCtrl",
    controllerAs: "mod",
    data: {
      titulo: "Módulo Reportes",
      icono: "fa-file-text-o",
      menu: "Reportes"
    }
  } );

  $stateProvider.state( "inicio.reportes.reporte-transcripcion", {
    templateUrl: "reportes/vistas/reporteTranscripcion.html",
    url: "/reportes/transcripcion",
    controller: "ReporteTrancripcionCtrl",
    controllerAs: "vm",
    resolve: {},
    data: {
      titulo: "Reporte de transcripciones",
      icono: "fa-pencil-square-o",
      menu: "Reporte transcripciones"
    }
  } );

  $stateProvider.state( "inicio.reportes.reporte-nota", {
    templateUrl: "reportes/vistas/reporteNota.html",
    url: "/reportes/notas",
    controller: "ReporteNotaCtrl",
    controllerAs: "vm",
    resolve: {},
    data: {
      titulo: "Reporte de notas",
      icono: "fa-file-text-o",
      menu: "Reporte notas"
    }
  } );

  $stateProvider.state( "inicio.reportes.reporte-multimedia", {
    templateUrl: "reportes/vistas/reporteMultimedia.html",
    url: "/reportes/multimedia",
    controller: "ReporteMultimediaCtrl",
    controllerAs: "vm",
    resolve: {},
    data: {
      titulo: "Reporte de multimedia",
      icono: "fa-file-text-o",
      menu: "Reporte multimedia"
    }
  } );

  $stateProvider.state( "inicio.reportes.reporte-email", {
    templateUrl: "reportes/vistas/reporteEmail.html",
    url: "/reportes/email",
    controller: "ReporteEmailCtrl",
    controllerAs: "vm",
    resolve: {},
    data: {
      titulo: "Envío de notas por email",
      icono: "fa-file-envelop-o",
      menu: "Envío email"
    }
  } );

  $stateProvider.state( "inicio.reportes.reporte-ranking", {
    templateUrl: "reportes/vistas/reporteRanking.html",
    url: "/reportes/ranking",
    controller: "ReporteRankingCtrl",
    controllerAs: "vm",
    resolve: {},
    data: {
      titulo: "Ranking de entidades y personajes",
      icono: "fa-file-envelop-o",
      menu: "Ranking"
    }
  } );

  $stateProvider.state( "inicio.reportes.reporte-pago", {
    templateUrl: "reportes/vistas/reportePagoTranscripcion.html",
    url: "/reportes/pago",
    controller: "ReportePagoTranscripcionCtrl",
    controllerAs: "vm",
    resolve: {},
    data: {
      titulo: "Reporte de pago por transcriptor",
      icono: "fa-file-envelop-o",
      menu: "Pago transcripción"
    }
  } );

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/controladores/formTranscripcionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = FormTranscripcionCtrl;

FormTranscripcionCtrl.$inject = [
  "$scope",
  "transcripcion",
  "TranscripcionAPI",
  "$state",
  "$stateParams",
  "hotkeys",
  "$interval",
  "$auth",
  "toastr",
  "contarCaracteres"
];
function FormTranscripcionCtrl( $scope, transcripcion, TranscripcionAPI, $state, $stateParams, hotkeys,
                                $interval, $auth, toastr, contarCaracteres ) {
  var playerControles = {
    play: {
      combo: "f6",
      description: "Reproducir Multimedia",
      callback: callback( "play" )
    },
    pause: {
      combo: "f5",
      description: "Pausar Multimedia",
      callback: callback( "pause" )
    },
    stop: {
      combo: "f1",
      description: "Detener Multimedia",
      callback: callback( "stop" )
    },
    forward: {
      combo: "f9",
      description: "Adelantar Multimedia",
      callback: callback( "forward" )
    },
    rewind: {
      combo: "f7",
      description: "Retroceder Multimedia",
      callback: callback( "rewind" )
    }
  };
  
  var vm = this;
  var interval = null;
  vm.usuario = $auth.getPayload().sub;
  vm.transcripcion = transcripcion;
  vm.transcripcion.editando = ( $stateParams.editar === "true" ) && vm.transcripcion.mostrar( vm.usuario );
  vm.guardar = guardar;
  vm.contarChars = contarChars;
  vm.controlMedia = controlMedia;
  vm.checkCopyPaste = checkCopyPaste;
  vm.nota = vm.transcripcion.notaId;
  vm.nota.edicion = _.find( vm.nota.guionId.programa.ediciones, function( ed ) {
    return ed._id === vm.nota.guionId.edicion;
  } ).nombre;
  iniciar();
  mostrarArchivo( vm.transcripcion.multimedia, playerControles );

  function detener() {
    $interval.cancel( interval );
    toastr.info( "Ha finalizado el autoguardado de la transcripción" );
  }

  $scope.$on( "$destroy", function() {
    if ( interval !== null ) {
      detener();
    }
  } );

  function iniciar() {
    if ( !vm.transcripcion.usuario || vm.transcripcion.mostrar( vm.usuario ) ) {
      toastr.info( "Ha iniciado el autoguardado para la transcripción" );
      interval = $interval( function() {
        if ( vm.transcripcion.editando ) {
          TranscripcionAPI.guardar( vm.transcripcion, true );
        }
      }, 10000 );
    }
  }


  function checkCopyPaste( event ) {
    if ( !$auth.getPayload().permisos.transcripcion.copyPaste ) {
      event.preventDefault();
    }
  }

  function controlMedia( accion ) {
    switch ( accion ) {
      case "play":
        vm.player.play();
        break;
      case "pause":
        vm.player.pause();
        break;
      case "stop":
        vm.player.currentTime = 0;
        vm.player.pause();
        break;
      case "rewind":
        vm.player.currentTime = vm.player.currentTime - 3;
        break;
      case "forward":
        vm.player.currentTime = vm.player.currentTime + 3;
        break;
    }
  }

  function guardar( formValido, finalizar ) {
    if ( formValido ) {
      if ( finalizar ) {
        detener();
        vm.transcripcion.completa = true;
      }
      TranscripcionAPI.guardar( vm.transcripcion, false ).then( function( resp ) {
        if ( finalizar ) {
          $state.go( "inicio.transcripciones", {}, {reload: true} );
        }
      } );
    }
  }

  function reload( id, editando ) {
    $state.go( $state.current, {id: id, editar: editando}, {reload: true} );
  }

  function mostrarArchivo( multimedia, controles ) {
    if ( _.startsWith( multimedia.mymeType, "audio/" ) ) {
      vm.audio = true;
      vm.player = document.getElementById( "audioPlayer" );
    } else if ( _.startsWith( multimedia.mymeType, "video/" ) ) {
      vm.video = true;
      vm.player = document.getElementById( "videoPlayer" );
    }
    agregarAtajos( controles );
  }

  function agregarAtajos( controles ) {
    _.forEach( controles, function( control ) {
      control.allowIn = [ "INPUT", "SELECT", "TEXTAREA" ];
    } );
    hotkeys.add( controles.play );
    hotkeys.add( controles.pause );
    hotkeys.add( controles.stop );
    hotkeys.add( controles.forward );
    hotkeys.add( controles.rewind );
  }

  function contarChars() {
    vm.transcripcion.caracteresBrutos =
    contarCaracteres.contarCaracteresBrutos( vm.transcripcion.transcripcion );
    vm.transcripcion.caracteres =
    contarCaracteres.contarCaracteres( vm.transcripcion.transcripcion );
    vm.transcripcion.caracteresSinEspacios =
    contarCaracteres.caracteresSinEspacios( vm.transcripcion.transcripcion );
    vm.transcripcion.abstract = _.trunc( vm.transcripcion.transcripcion, 80 );
  }

  function callback( accion ) {
    return function( event ) {
      event.preventDefault();
      vm.controlMedia( accion );
    };
  }


}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/controladores/listadoTranscripcionCtrl.js":[function(require,module,exports){
"use strict";

module.exports = ListadoTranscripcionCtrl;

ListadoTranscripcionCtrl.$inject = [
  "listado",
  "TranscripcionAPI",
  "$state",
  "$stateParams",
  "$auth"
];

function ListadoTranscripcionCtrl( listado, TranscripcionAPI, $state,
  $stateParams, $auth ) {

  var vm = this;
  vm.pagina = parseInt( $stateParams.pagina || 0 ) + 1;
  vm.cantidad = parseInt( $stateParams.cantidad || 10 );
  vm.listadoClientes = listado;
  vm.listadoTranscrip = [];
  vm.usuario = $auth.getPayload().sub;

  vm.listarTranscripciones = listarTranscripciones;
  vm.asignarTranscripcion = asignarTranscripcion;
  vm.actualizarPagina = actualizarPagina;

  function listarTranscripciones( cliente ) {
    TranscripcionAPI.obtenerSinBarra( cliente.transcripciones ).then( function( result ) {
        vm.listadoTranscrip = result.length > 1 ? result : [ result ];
      } );
  }

  function asignarTranscripcion( transcripcion ) {
    if ( _.isNull( transcripcion.usuario ) ) {
      transcripcion.usuario = vm.usuario;
      TranscripcionAPI.setUsuario( transcripcion ).then( function( resp ) {
        if ( !_.isUndefined( resp._id ) ) {
          $state.go( "inicio.transcripciones.transcripcion-uno",
          {id: transcripcion._id, editar: true} );
        }
      } );
    } else if ( transcripcion.usuario === vm.usuario ) {
      $state.go( "inicio.transcripciones.transcripcion-uno",
      {id: transcripcion._id, editar: true} );
    }
  }

  function actualizarPagina( pagina ) {
    $state.go( $state.current,
      {pagina: pagina, cantidad: vm.cantidad},
      {reload: false}
    );
  }

}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/controladores/rest/transcripcionAPI.js":[function(require,module,exports){
"use strict";

module.exports = TranscripcionAPI;

var Transcripcion = require( "../../modelos/transcripcion.js" );

TranscripcionAPI.$inject = [ "urlApi", "$http", "Notificaciones" ];

function TranscripcionAPI( urlApi, $http, Notificaciones ) {
  TranscripcionAPI.obtener = obtener;
  TranscripcionAPI.obtenerSinBarra = obtenerSinBarra;
  TranscripcionAPI.listar = listar;
  TranscripcionAPI.guardar = guardar;
  TranscripcionAPI.eliminar = eliminar;
  TranscripcionAPI.setUsuario = setUsuario;
  TranscripcionAPI.obtenerDesdeNotas = obtenerDesdeNotas;
  return TranscripcionAPI;

  function obtener( id ) {
    return obtenerCurried( false )( id );
  }

  function obtenerSinBarra( id ) {
    return obtenerCurried( true )( id );
  }

  function obtenerCurried( loadingBar ) {
    return function( id ) {
      if ( id ) {
        return $http.get( urlApi + "/api/transcripcion/" + id, { ignoreLoadingBar: loadingBar } )
          .then( function( resp ) {
            return Transcripcion.cargar( resp.data );
          }
        );
      } else {
        return new Transcripcion();
      }
    };
  }

  function listar( ) {
    return $http.get( urlApi + "/api/transcripcion/" ).then( ok, err );
  }

  function ok( resp ) {
    if ( resp.data.docs ) {
      resp.data.docs = Transcripcion.cargar( resp.data.docs );
    }
    return resp.data;
  }

  function err( resp ) {
    Notificaciones.agregar( resp.status, "Transcripcion" );
    return [];
  }

  function eliminar( id ) {
    return $http.delete( urlApi + "/api/transcripcion/" + id ).then( function( resp ) {
      Notificaciones.agregar( resp.status, "Transcripcion" );
      return resp.data;
    }, function( resp ) {
      Notificaciones.agregar( resp.status, "Transcripcion" );
      return resp;
    } );
  }

  function guardar( obj, ignorarBarra ) {
    if ( obj._id ) {
      return editar( obj, ignorarBarra );
    } else {
      return crear( obj );
    }
  }

  function crear( obj ) {
    return $http.post( urlApi + "/api/transcripcion/", obj ).then( okGuargar, errGuardar );
  }

  function editar( obj, ignorarBarra ) {
    return $http.put( urlApi + "/api/transcripcion/" + obj._id, obj,
    {ignoreLoadingBar: ignorarBarra} )
    .then( function( resp ) {
      if ( !ignorarBarra ) {
        Notificaciones.agregar( resp.status, "Transcripcion" );
      }
      return Transcripcion.cargar( resp.data );
    }, errGuardar );
  }

  function setUsuario( obj ) {
    return $http.put( urlApi + "/api/transcripcion/usuario/" + obj._id, obj )
    .then( okGuargar, function( error ) {
      Notificaciones.agregarPersonalizado( error.status, "Esta nota ya está en transcripcion" );
      return error;
    } );
  }

  function okGuargar( resp ) {
    Notificaciones.agregar( resp.status, "Transcripcion" );
    return resp.data;
  }

  function errGuardar( resp ) {
    Notificaciones.agregar( resp.status, "Transcripcion" );
    return resp;
  }

  function obtenerDesdeNotas( ids ) {
    var params = {
      ids: ids,
      ignoreLoadingBar: true
    };
    return $http.post( urlApi + "/api/transcripcion/notas", params ).then( ok, err );
  }
}

},{"../../modelos/transcripcion.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/modelos/transcripcion.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/controladores/transcripcionesCtrl.js":[function(require,module,exports){
"use strict";

module.exports = TranscripcionesCtrl;

TranscripcionesCtrl.$inject = ["transcripciones", "$sessionStorage"];
function TranscripcionesCtrl(transcripciones, $sessionStorage) {
  var mod = this;
  mod.precio = 0.1702;
  mod.transcripciones = transcripciones[$sessionStorage.usuario.nombre];
  mod.totalCaracteres = totalCaracteres;

  function totalCaracteres(porFecha){
    return _.foldl(porFecha, function(total, n){
      return total + n;
    }, 0);
  }
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/index.js":[function(require,module,exports){
"use strict";

var nombre = require( "../../../package.json" ).name;

var modulo = angular.module( nombre + ".Transcripciones", [] );
modulo.config( require( "./rutas" ) );

modulo.controller( "TranscripcionesCtrl", require( "./controladores/transcripcionesCtrl.js" ) );

modulo.controller( "ListadoTranscripcionCtrl",
  require( "./controladores/listadoTranscripcionCtrl.js" ) );
modulo.controller( "FormTranscripcionCtrl", require( "./controladores/formTranscripcionCtrl.js" ) );

modulo.factory( "TranscripcionAPI", require( "./controladores/rest/transcripcionAPI.js" ) );

module.exports = modulo;

},{"../../../package.json":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/package.json","./controladores/formTranscripcionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/controladores/formTranscripcionCtrl.js","./controladores/listadoTranscripcionCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/controladores/listadoTranscripcionCtrl.js","./controladores/rest/transcripcionAPI.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/controladores/rest/transcripcionAPI.js","./controladores/transcripcionesCtrl.js":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/controladores/transcripcionesCtrl.js","./rutas":"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/rutas.js"}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/modelos/transcripcion.js":[function(require,module,exports){
"use strict";

module.exports = Transcripcion;

function Transcripcion( transcripcion, abstract, caracteres, caracteresBrutos,
  caracteresSinEspacios, clientes,
  usuario, completa, notaId, _id ) {
  this.transcripcion = transcripcion;
  this.abstract = abstract;
  this.caracteres = caracteres || 0;
  this.caracteresBrutos = caracteresBrutos || 0;
  this.caracteresSinEspacios = caracteresSinEspacios || 0;
  this.clientes = clientes || [];
  this.usuario = usuario || null;
  this.completa = completa || false;
  this.notaId = notaId;
  this._id = _id;
}

Transcripcion.cargar = cargar;
Transcripcion.prototype.mostrar = mostrar;

function mostrar( usuario ) {
  return usuario ? this.usuario === usuario : true;
}

function cargar( json ) {
  if ( json ) {
    if ( _.isArray( json ) ) {
      return _.map( json, function( elem ) {
        return instanciar( elem );
      } );
    } else {
      return instanciar( json );
    }
  }
}

function instanciar( json ) {
  return new Transcripcion( json.transcripcion, json.abstract,
    json.caracteres, json.caracteresBrutos, json.caracteresSinEspacios,
    json.clientes, json.usuario, json.completa, json.notaId, json._id );
}

},{}],"/home/runner/work/controles-monitoreo-frontend/controles-monitoreo-frontend/monitoreo/src/app/transcripciones/rutas.js":[function(require,module,exports){
"use strict";

module.exports = rutas;

rutas.$inject = [ "$stateProvider" ];
function rutas( $stateProvider ) {

  $stateProvider.state( "inicio.transcripciones", {
    templateUrl: "transcripciones/vistas/inicio.html",
    url: "/transcripciones",
    controller: "TranscripcionesCtrl",
    controllerAs: "vm",
    resolve: {
      transcripciones: resumenTranscripciones
    },
    data: {
      titulo: "Módulo Transcripciones",
      icono: "fa-pencil-square-o",
      menu: "Transcripciones"
    }
  } );

  $stateProvider.state( "inicio.transcripciones.lista", {
    templateUrl: "transcripciones/vistas/listaTranscripcion.html",
    url: "/lista?pagina&cantidad",
    controller: "ListadoTranscripcionCtrl",
    controllerAs: "vm",
    resolve: {
      listado: listarTranscripcion
    },
    data: {
      titulo: "Transcripciones Pendientes",
      icono: "fa-pencil-square-o",
      menu: "Transcripciones"
    }
  } );

  $stateProvider.state( "inicio.transcripciones.transcripcion-uno", {
    templateUrl: "transcripciones/vistas/formTranscripcion.html",
    url: "/transcripcion/:id?editar",
    controller: "FormTranscripcionCtrl",
    controllerAs: "vm",
    resolve: {
      transcripcion: obtenerTranscripcion
    },
    data: {
      titulo: "Form de Transcripcion",
      icono: "fa-file-o",
      menu: "Form Transcripcion"
    }
  } );

  listarTranscripcion.$inject = [
    "TranscripcionAPI",
    "ClienteAPI",
    "$auth",
    "$q",
    "Cache"
  ];

  function listarTranscripcion( TranscripcionAPI, ClienteAPI,
    $auth, $q, Cache ) {
    if ( $auth.getPayload().permisos.transcripcion.listar ) {
      return TranscripcionAPI.listar(  )
      .then( function( resp ) {
        var clientes = angular.copy( Cache.clientes );

        var listado = [];
        _.forEach( resp,  function( value, key ) {
            listado.push( _.merge( clientes[key], { transcripciones: value } ) );
          } );
        return listado;
      } );
    }
    return $q.reject( {autenticado: false} );
  }

  resumenTranscripciones.$inject = [
    "ReporteAPI",
    "$auth",
    "$q"
  ];

  function resumenTranscripciones(ReporteAPI, $auth, $q) {
    if ( $auth.getPayload().permisos.transcripcion.listar ) {
      return ReporteAPI.pagoTranscripcion( moment().startOf("month"), moment().endOf("month"), 0.18 )
        .then( function(resp){
          return resp;
        } );
    }
    return $q.reject( {autenticado: false} );
  }

  function agruparTranscrip( transcrips, clientes ) {
    var clientesTrs = [];
    var transcripciones = {};
    _.forEach( transcrips, function( trs ) {
      if ( !_.isUndefined( trs.notaId.multimedia ) ) {
        _.forEach( trs.clientes, function algo( cliId ) {
            clientesTrs = setCliente( clientesTrs, cliId, trs._id );
          } );
        transcripciones[trs._id] = trs;
      }
    } );
    clientesTrs = mapearClientes( clientesTrs, clientes );
    return {
      clientes:clientesTrs,
      transcripciones:transcripciones
    };
  }

  function mapearClientes( clientesTrs, clientes ) {
    return _.map( clientesTrs, function( cli ) {
      var cliente = clientes[cli.id];
      if ( !_.isUndefined( cliente ) ) {
        return {
          nombre: cliente.nombre,
          abreviatura: cliente.abreviatura || "",
          id: cliente._id,
          transcripciones:cli.transcripciones
        };
      }
    } );
  }

  function setCliente( clientesTrs, clienteId, transcripcionId ) {
    var cliente = _.find( clientesTrs, function( cliente ) {
      return cliente.id === clienteId;
    } );
    if ( _.isUndefined( cliente ) ) {
      cliente = {id:clienteId, transcripciones:[ transcripcionId ]};
      clientesTrs.push( cliente );
    } else {
      cliente.transcripciones.push( transcripcionId );
    }
    return clientesTrs;
  }

  /*function obtenerNotaInfo( NotaAPI ) {
    return function( transcripcion ) {
      return NotaAPI.obtener( transcripcion.notaId ).then( function( nota ) {
        var guion = nota.guionId;
        transcripcion.notaInfo = {
          titulo: nota.titulo,
          hora:nota.hora,
          guion: guion._id

          //multimedia: nota.multimedia._id
        };
        var edicion = _.find( guion.programa.ediciones, function( edicion ) {
          return edicion._id === guion.edicion;
        } );
        transcripcion.guionInfo = {
          edicion: edicion.nombre,
          medio: guion.medio.nombre,
          programa: guion.programa.nombre
        };
        return transcripcion;
      } );
    };
  }*/

  obtenerTranscripcion.$inject = [
    "TranscripcionAPI",
    "ArchivoAPI",
    "$stateParams",
    "Validaciones",
    "$q"
  ];
  function obtenerTranscripcion( TranscripcionAPI, ArchivoAPI, $stateParams,
    Validaciones, $q ) {
    if ( Validaciones.dejarPasar( $stateParams, "transcripcion" ) ) {
      return TranscripcionAPI.obtener( $stateParams.id, $stateParams.editar )
        .then( function( resp ) {
          return ArchivoAPI.obtener( resp.notaId.multimedia )
          .then( function( archivo ) {
            resp.multimedia = archivo;
            return resp;
          } );
        } );
    }
    return $q.reject( {autenticado: false} );
  }

}

},{}]},{},["./src/app/index.js"]);
